import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { toast as _rToast } from "react-toastify";
import AdminNavbar from "../Layout/AdminNavbar";
import API_BASE_URL from "../config";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

/* ─── Google Fonts Loader ─────────────────────────────────── */
const FontLoader = () => {
  useEffect(() => {
    const link1 = document.createElement("link");
    link1.rel = "preconnect";
    link1.href = "https://fonts.googleapis.com";
    document.head.appendChild(link1);
    const link2 = document.createElement("link");
    link2.rel = "stylesheet";
    link2.href =
      "https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=DM+Sans:wght@300;400;500&display=swap";
    document.head.appendChild(link2);
    const link3 = document.createElement("link");
    link3.rel = "stylesheet";
    link3.href = "https://fonts.googleapis.com/icon?family=Material+Icons+Round";
    document.head.appendChild(link3);
  }, []);
  return null;
};

/* ─── Global CSS ──────────────────────────────────────────── */
const STYLES = `
:root {
  --bg:#ECEEF4;--surface:#FFFFFF;--surface2:#F4F5FA;--surface3:#ECEEF4;
  --border:#DDE0EE;--border2:#C4C8DC;
  --text:#13152B;--text2:#4E5270;--text3:#8E91A8;
  --accent:#2041CC;--accent-light:#EEF1FF;--accent-mid:#BAC4FC;
  --green:#166534;--green-bg:#F0FDF4;--green-bd:#86EFAC;
  --amber:#92400E;--amber-bg:#FFFBEB;--amber-bd:#FCD34D;
  --red:#991B1B;--red-bg:#FFF1F2;--red-bd:#FCA5A5;
  --violet:#5B21B6;--violet-bg:#F5F3FF;--violet-bd:#C4B5FD;
  --teal:#0F766E;--teal-bg:#F0FDFA;--teal-bd:#5EEAD4;
  --orange:#9A3412;--orange-bg:#FFF7ED;--orange-bd:#FDBA74;
  --cyan:#0E7490;--cyan-bg:#ECFEFF;--cyan-bd:#A5F3FC;
  --sidebar:#FFFFFF;
  --font:'Outfit',sans-serif;--font2:'DM Sans',sans-serif;
  --radius:14px;--shadow:0 1px 3px rgba(0,0,0,.07),0 4px 18px rgba(0,0,0,.05);
}
*{box-sizing:border-box;margin:0;padding:0}
.exp-root{font-family:var(--font);background:var(--bg);color:var(--text);display:flex;height:calc(100vh - 106px);overflow:hidden}

/* SIDEBAR */
.sidebar{width:256px;min-width:256px;background:var(--sidebar);border-right:1px solid var(--border);display:flex;flex-direction:column;height:calc(100vh - 106px);overflow-y:auto;overflow-x:hidden}
.sidebar::-webkit-scrollbar{width:3px}
.sidebar::-webkit-scrollbar-thumb{background:#D7DBEB;border-radius:3px}
.brand{height:58px;padding:0 18px;border-bottom:1px solid var(--border);display:flex;align-items:center;flex-shrink:0;position:sticky;top:0;z-index:2;background:var(--sidebar)}
.brand-logo{display:flex;align-items:center;gap:10px}
.brand-icon{width:36px;height:36px;background:linear-gradient(135deg,#2041CC,#7C3AED);border-radius:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.brand-icon .mi{font-size:19px;color:#fff}
.brand-name{font-size:17px;font-weight:800;color:var(--text);letter-spacing:.2px}
.brand-tag{font-size:9px;color:var(--text3);letter-spacing:2px;text-transform:uppercase;margin-top:2px}
.admin-chip{margin:12px 10px;background:linear-gradient(135deg,#F8FAFF,#F2F5FF);border:1px solid #D7DDFB;border-radius:11px;padding:11px 13px;display:flex;align-items:center;gap:10px}
.admin-av{width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,#2041CC,#7C3AED);display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:800;color:#fff;flex-shrink:0}
.admin-name{font-size:13px;font-weight:600;color:var(--text)}
.admin-role{font-size:10px;color:var(--text3);margin-top:1px}
.admin-badge{margin-left:auto;background:linear-gradient(135deg,#2041CC,#7C3AED);color:#fff;font-size:9px;font-weight:700;padding:3px 8px;border-radius:10px;letter-spacing:.3px}
.nav-section{padding:14px 12px 4px;font-size:9.5px;letter-spacing:2px;text-transform:uppercase;color:#A0A6C0;font-weight:600;flex-shrink:0}
.nav-item{display:flex;align-items:center;gap:10px;padding:9px 14px;font-size:13px;color:var(--text2);cursor:pointer;border-radius:9px;margin:1px 8px;transition:all .15s;font-family:var(--font);flex-shrink:0;user-select:none;border:none;background:transparent;width:calc(100% - 16px);text-align:left}
.nav-item:hover{background:#F4F6FD;color:var(--text)}
.nav-item.active{background:#EEF2FF;color:var(--accent);font-weight:600}
.nav-item .mi{font-size:18px;flex-shrink:0}
.nav-badge{margin-left:auto;min-width:20px;height:20px;background:#EF4444;border-radius:10px;font-size:10px;color:#fff;display:flex;align-items:center;justify-content:center;padding:0 5px;font-weight:700}
.nb-amber{background:#F59E0B;color:#78350F}
.sidebar-foot{margin-top:auto;border-top:1px solid var(--border);padding:12px;flex-shrink:0;position:sticky;bottom:0;z-index:2;background:var(--sidebar)}
.nav-item.dim{color:var(--text3)}
.nav-item.dim:hover{color:var(--text);background:#F7F8FC}

/* MAIN */
.main{flex:1;display:flex;flex-direction:column;overflow:hidden;min-width:0}
.topbar{height:58px;background:var(--surface);border-bottom:1px solid var(--border);display:flex;align-items:center;padding:0 26px;gap:12px;flex-shrink:0}
.topbar-title{font-size:15px;font-weight:700;color:var(--text)}
.topbar-right{margin-left:auto;display:flex;align-items:center;gap:10px}
.icon-btn{width:34px;height:34px;border-radius:8px;border:1px solid var(--border);background:var(--surface);display:flex;align-items:center;justify-content:center;cursor:pointer;color:var(--text2);position:relative;transition:all .15s}
.icon-btn:hover{background:var(--surface2)}
.notif-dot{position:absolute;top:6px;right:6px;width:7px;height:7px;background:#EF4444;border-radius:50%;border:1.5px solid #fff}
.top-av{width:34px;height:34px;border-radius:50%;background:linear-gradient(135deg,#2041CC,#7C3AED);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#fff;cursor:pointer}
.breadcrumb{display:flex;align-items:center;gap:6px;font-size:13px;color:var(--text3)}

/* CONTENT */
.content{flex:1;overflow-y:auto;padding:20px 24px;display:flex;flex-direction:column;gap:16px}
.content::-webkit-scrollbar{width:5px}
.content::-webkit-scrollbar-thumb{background:#C4C8DC;border-radius:4px}

/* PAGE HEADER */
.page-header{display:flex;align-items:center;justify-content:space-between}
.page-title{font-size:20px;font-weight:800;color:var(--text)}
.page-sub{font-size:13px;color:var(--text3);font-family:var(--font2);margin-top:2px}
.header-actions{display:flex;align-items:center;gap:10px}

/* BUTTONS */
.btn{padding:8px 16px;border-radius:8px;border:1px solid var(--border);background:var(--surface);font-size:13px;color:var(--text);cursor:pointer;font-family:var(--font);display:inline-flex;align-items:center;gap:6px;font-weight:500;transition:all .15s}
.btn:hover{background:var(--surface2)}
.btn-primary{background:var(--accent);color:#fff;border-color:var(--accent)}
.btn-primary:hover{background:#1A35A8}
.btn-success{background:var(--green-bg);color:var(--green);border-color:var(--green-bd)}
.btn-success:hover{background:#DCFCE7}
.btn-danger{background:var(--red-bg);color:var(--red);border-color:var(--red-bd)}
.btn-danger:hover{background:#FFE4E6}
.btn-amber{background:var(--amber-bg);color:var(--amber);border-color:var(--amber-bd)}
.btn-sm{padding:5px 12px;font-size:12px;border-radius:7px}
.btn-ghost{border:none;background:transparent;color:var(--text2);font-size:13px;cursor:pointer;font-family:var(--font);padding:0;font-weight:500}
.btn-ghost:hover{color:var(--accent)}
.tbl-actions{display:flex;align-items:center;gap:6px;flex-wrap:nowrap}
.btn-icon{width:28px;height:28px;padding:0;border-radius:6px;border:1px solid var(--border);background:var(--surface);display:flex;align-items:center;justify-content:center;cursor:pointer;color:var(--text2);transition:all .15s;flex-shrink:0}
.btn-icon:hover{background:var(--accent-light);color:var(--accent);border-color:var(--accent-mid)}

/* ALERT BANNERS */
.alert-row{display:flex;gap:10px}
.alert-card{border-radius:10px;padding:12px 15px;display:flex;align-items:flex-start;gap:10px;font-size:13px;cursor:pointer;transition:all .15s;border:1px solid transparent}
.alert-row .alert-card{flex:1}
.alert-card:hover{transform:translateY(-1px);box-shadow:0 4px 16px rgba(0,0,0,.08)}
.alert-card .mi{font-size:20px;flex-shrink:0;margin-top:1px}
.ac-title{font-size:13px;font-weight:600}
.ac-sub{font-size:12px;margin-top:1px;font-family:var(--font2);opacity:.8}
.ac-red{background:linear-gradient(135deg,#FFF1F2,#FFE4E6);color:var(--red);border-color:var(--red-bd)}
.ac-amber{background:linear-gradient(135deg,#FFFBEB,#FEF3C7);color:var(--amber);border-color:var(--amber-bd)}
.ac-blue{background:linear-gradient(135deg,#EEF1FF,#E0E7FF);color:var(--accent);border-color:var(--accent-mid)}

/* KPI GRID */
.kpi-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px}
.kpi{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:16px;box-shadow:var(--shadow);transition:all .18s;cursor:pointer;position:relative;overflow:hidden}
.kpi::before{content:'';position:absolute;bottom:-18px;right:-18px;width:60px;height:60px;border-radius:50%;opacity:.07}
.kpi-blue::before{background:var(--accent)}.kpi-green::before{background:var(--green)}
.kpi-amber::before{background:var(--amber)}.kpi-violet::before{background:var(--violet)}
.kpi-teal::before{background:var(--teal)}.kpi-red::before{background:var(--red)}
.kpi-orange::before{background:var(--orange)}.kpi-cyan::before{background:var(--cyan)}
.kpi:hover{transform:translateY(-2px);box-shadow:0 6px 24px rgba(0,0,0,.1)}
.kpi-top{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:10px}
.kpi-label{font-size:11.5px;color:var(--text2);font-weight:500;font-family:var(--font2);line-height:1.35}
.kpi-icon{width:36px;height:36px;border-radius:9px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.kpi-icon .mi{font-size:19px}
.ki-blue{background:var(--accent-light);color:var(--accent)}.ki-green{background:var(--green-bg);color:var(--green)}
.ki-amber{background:var(--amber-bg);color:var(--amber)}.ki-violet{background:var(--violet-bg);color:var(--violet)}
.ki-teal{background:var(--teal-bg);color:var(--teal)}.ki-red{background:var(--red-bg);color:var(--red)}
.ki-orange{background:var(--orange-bg);color:var(--orange)}.ki-cyan{background:var(--cyan-bg);color:var(--cyan)}
.kpi-val{font-size:24px;font-weight:800;color:var(--text)}
.kpi-trend{font-size:11px;color:var(--text3);margin-top:3px;font-family:var(--font2)}
.trend-up{color:var(--green);font-weight:600}.trend-dn{color:var(--red);font-weight:600}

/* CARDS */
.card{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:18px;box-shadow:var(--shadow)}
.card-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px}
.card-title{font-size:14px;font-weight:700;color:var(--text)}
.card-sub{font-size:12px;color:var(--text3);margin-top:2px;font-family:var(--font2)}

/* LAYOUTS */
.two-col{display:grid;grid-template-columns:1.5fr 1fr;gap:14px}
.three-col{display:grid;grid-template-columns:1fr 1fr 1fr;gap:14px}
.four-col{display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:12px}

/* TABLE */
.tbl-wrap{overflow-x:auto;overflow-y:auto;max-height:calc(100vh - 320px);border-radius:10px;border:1px solid var(--border);-webkit-overflow-scrolling:touch}
.tbl-wrap::-webkit-scrollbar{height:4px;width:4px}
.tbl-wrap::-webkit-scrollbar-thumb{background:#C4C8DC;border-radius:4px}
.tbl-wrap::-webkit-scrollbar-track{background:transparent}
table{width:100%;border-collapse:collapse;font-family:var(--font2)}
thead th{background:var(--surface2);padding:9px 13px;text-align:left;font-size:11px;font-weight:700;color:var(--text2);text-transform:uppercase;letter-spacing:.5px;border-bottom:1px solid var(--border);white-space:nowrap;position:sticky;top:0;z-index:2}tbody td{padding:10px 13px;border-bottom:1px solid var(--border);font-size:13px;color:var(--text);vertical-align:middle;white-space:nowrap}
tbody td.td-wrap{white-space:normal;min-width:160px;max-width:260px;overflow:hidden;text-overflow:ellipsis}
tbody tr:last-child td{border-bottom:none}
tbody tr:hover td{background:var(--surface2)}
.pager{padding:10px 16px;display:flex;align-items:center;justify-content:space-between;border-top:1px solid var(--border);flex-shrink:0}
.pager-info{font-size:12px;color:var(--text3);font-family:var(--font2)}
.pager-btns{display:flex;gap:6px;align-items:center}
.pager-count{font-size:12px;font-family:var(--font2);color:var(--text2);padding:0 4px}

/* STATUS PILLS */
.pill{display:inline-flex;align-items:center;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600;gap:4px;white-space:nowrap}
.pill::before{content:'';width:5px;height:5px;border-radius:50%;flex-shrink:0}
.p-draft{background:#F1F5F9;color:#475569}.p-draft::before{background:#94A3B8}
.p-submitted{background:var(--violet-bg);color:var(--violet)}.p-submitted::before{background:var(--violet)}
.p-pending{background:var(--amber-bg);color:var(--amber)}.p-pending::before{background:var(--amber)}
.p-approved{background:var(--green-bg);color:var(--green)}.p-approved::before{background:var(--green)}
.p-rejected{background:var(--red-bg);color:var(--red)}.p-rejected::before{background:var(--red)}
.p-reimbursed{background:var(--accent-light);color:var(--accent)}.p-reimbursed::before{background:var(--accent)}
.p-paid{background:var(--teal-bg);color:var(--teal)}.p-paid::before{background:var(--teal)}
.p-overdue{background:var(--red-bg);color:var(--red)}.p-overdue::before{background:var(--red)}
.p-info{background:var(--orange-bg);color:var(--orange)}.p-info::before{background:var(--orange)}
.p-pending-a{background:var(--amber-bg);color:var(--amber)}.p-pending-a::before{background:var(--amber)}
.cat-tag{background:var(--surface2);color:var(--text2);border-radius:5px;padding:2px 8px;font-size:11px;font-family:var(--font2);border:1px solid var(--border)}

/* PROGRESS */
.prog-wrap{background:#E8EAF4;border-radius:4px;height:6px;overflow:hidden;margin-top:4px}
.prog-fill{height:100%;border-radius:4px}
.pf-blue{background:var(--accent)}.pf-green{background:var(--green)}.pf-amber{background:var(--amber)}
.pf-red{background:var(--red)}.pf-violet{background:var(--violet)}.pf-teal{background:var(--teal)}

/* METRIC STRIP */

/* PETTY CASH CARD */
.petty-card{background:linear-gradient(135deg,#0D0F1E 0%,#1A1034 40%,#1E1050 100%);border-radius:12px;padding:18px;color:#fff;position:relative;overflow:hidden;flex-shrink:0}
.petty-card::before{content:'';position:absolute;top:-40px;right:-40px;width:150px;height:150px;background:rgba(124,58,237,.15);border-radius:50%}
.petty-card::after{content:'';position:absolute;bottom:-30px;left:40px;width:100px;height:100px;background:rgba(32,65,204,.1);border-radius:50%}
.petty-account{font-size:11px;color:rgba(255,255,255,.45);text-transform:uppercase;letter-spacing:1px;margin-bottom:4px;position:relative;z-index:1}
.petty-balance{font-size:30px;font-weight:800;position:relative;z-index:1;margin-bottom:2px}
.petty-sub{font-size:12px;color:rgba(255,255,255,.5);position:relative;z-index:1}
.petty-bar-wrap{background:rgba(255,255,255,.12);border-radius:4px;height:6px;margin:10px 0;position:relative;z-index:1}
.petty-bar-fill{background:linear-gradient(90deg,#A78BFA,#60A5FA);height:100%;border-radius:4px}
.petty-meta{display:flex;justify-content:space-between;position:relative;z-index:1}
.petty-meta-item{text-align:center}
.pm-val{font-size:14px;font-weight:700;color:#fff}
.pm-lbl{font-size:10px;color:rgba(255,255,255,.4);margin-top:1px}

/* DONUT */
.donut-wrap{display:flex;align-items:center;gap:16px}
.donut{width:100px;height:100px;border-radius:50%;background:conic-gradient(var(--accent) 0deg 138deg,var(--green) 138deg 201deg,var(--amber) 201deg 245deg,var(--violet) 245deg 280deg,var(--teal) 280deg 306deg,var(--red) 306deg 360deg);flex-shrink:0;position:relative}
.donut::after{content:'';position:absolute;inset:22px;background:var(--surface);border-radius:50%}
.legend{display:flex;flex-direction:column;gap:5px}
.leg-item{display:flex;align-items:center;gap:6px;font-size:12px;font-family:var(--font2)}
.leg-dot{width:8px;height:8px;border-radius:2px;flex-shrink:0}
.leg-lbl{color:var(--text2);flex:1}
.leg-val{font-weight:600;color:var(--text)}

/* SECTION DIVIDER */
.section-divider{display:flex;align-items:center;gap:12px;margin:2px 0}
.sd-label{font-size:11px;font-weight:700;color:var(--text3);text-transform:uppercase;letter-spacing:1px;white-space:nowrap}
.sd-line{flex:1;height:1px;background:var(--border)}

/* REIMB ITEMS */
.reimb-item{display:flex;align-items:center;gap:10px;padding:10px;border-radius:8px;cursor:pointer;transition:background .12s;margin-bottom:4px}
.reimb-item:hover{background:var(--surface2)}
.ri-av{border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;flex-shrink:0;font-size:12px}
.av-blue{background:#DBEAFE;color:#1D4ED8}.av-green{background:#DCFCE7;color:#166534}
.av-amber{background:#FEF3C7;color:#92400E}.av-orange{background:#FFEDD5;color:#9A3412}
.av-violet{background:#EDE9FE;color:#5B21B6}.av-teal{background:#CCFBF1;color:#0F766E}
.av-red{background:#FEE2E2;color:#991B1B}.av-indigo{background:#E0E7FF;color:#4338CA}
.ri-info{flex:1}
.ri-name{font-size:13px;font-weight:600;color:var(--text)}
.ri-det{font-size:11px;color:var(--text3);font-family:var(--font2);margin-top:1px}
.ri-right{text-align:right}
.ri-amt{font-size:14px;font-weight:800;color:var(--text)}
.ri-bank{font-size:11px;color:var(--text3);font-family:var(--font2)}

/* DEPT ROWS */
.dept-row{margin-bottom:12px}
.dept-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:2px}
.dept-name{font-size:13px;font-weight:500;color:var(--text);font-family:var(--font2)}
.dept-pct{font-size:12px;font-weight:700}
.dept-nums{font-size:11px;color:var(--text3);font-family:var(--font2);margin-bottom:2px}

/* UTIL / RECUR */
.util-row{display:flex;align-items:center;gap:10px;padding:9px 0;border-bottom:1px solid var(--border)}
.util-row:last-child{border-bottom:none}
.util-icon{width:32px;height:32px;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.util-icon .mi{font-size:17px}
.util-info{flex:1}
.util-name{font-size:13px;font-weight:600;color:var(--text)}
.util-month{font-size:11px;color:var(--text3);font-family:var(--font2);margin-top:1px}
.util-right{text-align:right}
.util-amt{font-size:13px;font-weight:700;color:var(--text)}
.util-status{font-size:11px;font-family:var(--font2);margin-top:1px}
.recur-item{display:flex;align-items:center;gap:10px;padding:9px 0;border-bottom:1px solid var(--border)}
.recur-item:last-child{border-bottom:none}
.recur-icon{width:32px;height:32px;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.recur-icon .mi{font-size:17px}
.rec-info{flex:1}
.rec-name{font-size:13px;font-weight:600;color:var(--text)}
.rec-det{font-size:11px;color:var(--text3);font-family:var(--font2);margin-top:1px}
.rec-right{text-align:right}
.rec-due{font-size:11px;font-weight:600;font-family:var(--font2)}
.rec-amt{font-size:13px;font-weight:700;color:var(--text)}

/* POLICY */
.pol-item{display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid var(--border)}
.pol-item:last-child{border-bottom:none}
.pol-key{font-size:12.5px;color:var(--text3);font-family:var(--font2)}
.pol-val{font-size:12.5px;font-weight:600;color:var(--text);font-family:var(--font2)}

/* ACTIVITY */
.act-item{display:flex;gap:10px;padding:8px 0;border-bottom:1px solid var(--border)}
.act-item:last-child{border-bottom:none}
.act-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0;margin-top:5px}
.act-info{flex:1}
.act-text{font-size:12.5px;color:var(--text);font-family:var(--font2);line-height:1.4}
.act-time{font-size:11px;color:var(--text3);margin-top:2px}

/* CHART BAR */
.chart-bar-wrap{display:flex;align-items:flex-end;gap:8px;height:120px;padding-top:12px}
.chart-bar{flex:1;border-radius:4px 4px 0 0;background:var(--accent);position:relative;min-width:0;transition:opacity .15s;cursor:pointer}
.chart-bar:hover{opacity:.8}
.chart-bar-label{text-align:center;font-size:10px;font-family:var(--font2);color:var(--text3);margin-top:4px}

/* TAB BAR */
.tab-bar{display:flex;gap:0;border-bottom:1px solid var(--border);margin-bottom:12px}
.tab{padding:8px 16px;font-size:13px;font-weight:500;color:var(--text3);cursor:pointer;border-bottom:2px solid transparent;transition:all .15s;font-family:var(--font);background:transparent;border-top:none;border-left:none;border-right:none}
.tab:hover{color:var(--text)}
.tab.active{color:var(--accent);border-bottom-color:var(--accent);font-weight:600}

/* SEARCH BAR */
.search-bar{display:flex;align-items:center;gap:8px;padding:7px 12px;background:var(--surface);border:1px solid var(--border);border-radius:8px;min-width:220px}
.search-bar input{border:none;outline:none;background:transparent;font-size:13px;color:var(--text);font-family:var(--font2);width:100%}
.search-bar input::placeholder{color:var(--text3)}
.search-bar .mi{font-size:18px;color:var(--text3)}
.filter-row{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
select,input,textarea{font-family:var(--font2)}
.form-control{padding:9px 12px;border-radius:8px;border:1px solid var(--border);font-size:13px;color:var(--text);font-family:var(--font2);background:var(--surface);outline:none;transition:border-color .15s;width:100%}
.form-control:focus{border-color:var(--accent-mid)}

/* MODAL */
.modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:5000;display:flex;align-items:center;justify-content:center;backdrop-filter:blur(3px);padding:24px}
.modal{display:flex;flex-direction:column;position:relative;inset:auto;height:auto;min-height:0;background:var(--surface);border-radius:18px;padding:24px;width:clamp(360px,52vw,620px);max-width:calc(100vw - 48px);max-height:calc(100vh - 48px);overflow:hidden;box-shadow:0 24px 64px rgba(0,0,0,.2);animation:modalIn .2s ease;transform:none;flex:0 0 auto}
.modal.modal-lg{width:clamp(420px,72vw,840px)}
.modal.modal-sm{width:clamp(320px,40vw,460px)}
@keyframes modalIn{from{opacity:0;transform:translateY(16px) scale(.97)}to{opacity:1;transform:none}}
.modal-head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:18px;flex-shrink:0}
.modal-title{font-size:17px;font-weight:800;color:var(--text)}
.modal-close{width:32px;height:32px;border-radius:8px;border:none;background:var(--surface2);display:flex;align-items:center;justify-content:center;cursor:pointer;color:var(--text2);transition:all .15s}
.modal-close:hover{background:var(--border);color:var(--text)}
.modal-body{display:flex;flex-direction:column;gap:16px;overflow-y:auto;overflow-x:hidden;padding-right:14px;margin-right:-14px;flex:0 1 auto;min-height:0;max-height:calc(100vh - 240px);scrollbar-gutter:stable}
.modal-body::-webkit-scrollbar{width:6px}
.modal-body::-webkit-scrollbar-thumb{background:#C4C8DC;border-radius:999px}
.modal-foot{display:flex;justify-content:flex-end;align-items:center;gap:10px;flex-wrap:wrap;margin-top:18px;padding-top:18px;border-top:1px solid var(--border);flex-shrink:0}
.modal-foot .btn{justify-content:center;min-width:120px}
.form-group{display:flex;flex-direction:column;gap:5px;min-width:0}
.form-group label{font-size:12px;font-weight:600;color:var(--text2);text-transform:uppercase;letter-spacing:.4px}
.form-row{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;align-items:start}
.form-note{font-size:11.5px;color:var(--text3);font-family:var(--font2);line-height:1.4}
.modal-info-box{background:var(--surface2);border-radius:8px;padding:12px;font-size:12.5px;font-family:var(--font2);color:var(--text2);line-height:1.5}
.modal-emp-row{display:flex;align-items:center;gap:10px;padding:10px;background:var(--surface2);border-radius:10px}
.modal-amount-big{font-size:28px;font-weight:800;color:var(--text);text-align:center;padding:14px 0}
textarea.form-control{resize:vertical;min-height:96px}
input[type="file"].form-control{padding:10px 12px}

/* TOAST */
.toast-container{position:fixed;bottom:24px;right:24px;z-index:9999;display:flex;flex-direction:column;gap:8px;pointer-events:none}
.toast{background:var(--sidebar);color:#fff;padding:12px 18px;border-radius:10px;font-size:13px;font-weight:500;display:flex;align-items:center;gap:8px;min-width:260px;box-shadow:0 8px 24px rgba(0,0,0,.2);animation:toastIn .25s ease;pointer-events:all}
@keyframes toastIn{from{opacity:0;transform:translateX(30px)}to{opacity:1;transform:none}}
@keyframes toastOut{to{opacity:0;transform:translateX(30px)}}
.t-success{background:linear-gradient(135deg,#14532D,#166534)}
.t-error{background:linear-gradient(135deg,#7F1D1D,#991B1B)}
.t-info{background:linear-gradient(135deg,#1e3a8a,#2041CC)}
.t-amber{background:linear-gradient(135deg,#78350F,#92400E)}
.toast .mi{font-size:18px}

/* NOTIF PANEL */
.notif-panel{position:absolute;top:50px;right:0;width:360px;background:var(--surface);border:1px solid var(--border);border-radius:14px;box-shadow:0 16px 48px rgba(0,0,0,.12);z-index:900;max-height:calc(100vh - 80px);overflow-y:auto}
.notif-head{padding:14px 16px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between}
.notif-title{font-size:14px;font-weight:700}
.notif-item{padding:12px 16px;border-bottom:1px solid var(--border);display:flex;gap:10px;cursor:pointer;transition:background .12s}
.notif-item:last-child{border-bottom:none}
.notif-item:hover{background:var(--surface2)}
.notif-dot2{width:8px;height:8px;border-radius:50%;flex-shrink:0;margin-top:5px}
.notif-text{font-size:12.5px;font-family:var(--font2);color:var(--text);line-height:1.4}
.notif-time{font-size:11px;color:var(--text3);margin-top:2px}

/* PERM TABLE */
.perm-table{width:100%;border-collapse:collapse}
.perm-table th{padding:8px 12px;font-size:11px;font-weight:700;color:var(--text2);text-transform:uppercase;letter-spacing:.4px;background:var(--surface2);border-bottom:1px solid var(--border)}
.perm-table td{padding:9px 12px;border-bottom:1px solid var(--border);font-size:13px}
.perm-table tr:last-child td{border-bottom:none}

/* TOGGLE */
.toggle-switch{position:relative;display:inline-block;width:36px;height:20px;cursor:pointer;flex-shrink:0}
.toggle-switch input{opacity:0;width:0;height:0;position:absolute}
.toggle-track{position:absolute;inset:0;background:#CBD5E1;border-radius:10px;transition:background .2s}
.toggle-switch input:checked + .toggle-track{background:var(--accent)}
.toggle-thumb{position:absolute;top:3px;left:3px;width:14px;height:14px;background:#fff;border-radius:50%;transition:transform .2s;box-shadow:0 1px 3px rgba(0,0,0,.2);pointer-events:none}
.toggle-switch input:checked ~ .toggle-thumb{transform:translateX(16px)}

/* EMPTY STATE */
.empty-state{text-align:center;padding:48px 24px;color:var(--text3)}
.empty-state .mi{font-size:48px;display:block;margin-bottom:12px;opacity:.3}
@media (max-width:640px){
  .modal-overlay{padding:12px}
  .modal,.modal.modal-lg,.modal.modal-sm{width:calc(100vw - 24px);max-width:calc(100vw - 24px);max-height:calc(100vh - 24px);padding:18px}
  .modal-head{margin-bottom:16px}
  .modal-body{gap:14px}
  .form-row{grid-template-columns:1fr}
  .modal-foot{justify-content:stretch}
  .modal-foot .btn{flex:1;min-width:0}
  .modal-emp-row{align-items:flex-start;flex-wrap:wrap}
}
.adm-spinner-wrap{display:flex;align-items:center;justify-content:center;flex:1;min-height:340px;flex-direction:column;gap:14px;}
.adm-spinner{width:40px;height:40px;border:3px solid var(--border2);border-top-color:var(--accent);border-radius:50%;animation:adm-spin .65s linear infinite;}
@keyframes adm-spin{to{transform:rotate(360deg)}}
.adm-spinner-label{font-size:13px;color:var(--text3);font-family:var(--font2);}
`;

/* ─── Helpers ─────────────────────────────────────────────── */
const Mi = ({ icon, style, className }) => (
  <span className={`mi material-icons-round${className ? " " + className : ""}`} style={style}>{icon}</span>
);

const Pill = ({ children, variant = "p-pending" }) => (
  <span className={`pill ${variant}`}>{children}</span>
);

const RiAv = ({ initials, color = "av-blue", size = 30 }) => (
  <div className={`ri-av ${color}`} style={{ width: size, height: size, fontSize: size * 0.38 }}>{initials}</div>
);

const Toggle = ({ checked, onChange }) => (
  <label className="toggle-switch" onClick={e => e.stopPropagation()}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    <div className="toggle-track" />
    <div className="toggle-thumb" />
  </label>
);

const PAGE_SIZE = 20;
const Pager = ({ page, total, onChange, label = "items" }) => {
  const pages = Math.max(1, Math.ceil(total / PAGE_SIZE));
  if (pages <= 1) return null;
  const from = Math.min((page - 1) * PAGE_SIZE + 1, total);
  const to = Math.min(page * PAGE_SIZE, total);
  return (
    <div className="pager">
      <span className="pager-info">Showing {from}–{to} of {total} {label}</span>
      <div className="pager-btns">
        <button className="btn btn-sm" disabled={page <= 1} style={page <= 1 ? { opacity: 0.4 } : {}} onClick={() => onChange(page - 1)}>← Prev</button>
        <span className="pager-count">Page {page} of {pages}</span>
        <button className="btn btn-sm" disabled={page >= pages} style={page >= pages ? { opacity: 0.4 } : {}} onClick={() => onChange(page + 1)}>Next →</button>
      </div>
    </div>
  );
};

/* ─── Data Helpers ────────────────────────────────────────── */
const fmtAmt = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
const getInitials = (name) => (name || "?").split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
const fmtDate = (d) => { if (!d) return "—"; try { return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }); } catch { return d; } };

/* ─── Slip download (jsPDF) ─────────────────────────────────── */
const downloadSlip = (expense) => {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const margin = 22;
  const cW = W - margin * 2;
  const dark = [24, 25, 42], muted = [100, 102, 120], border = [220, 222, 232], blue = [37, 99, 235], green = [22, 163, 74], violet = [124, 58, 237];
  const tc = (c) => doc.setTextColor(c[0], c[1], c[2]);
  const dc = (c) => doc.setDrawColor(c[0], c[1], c[2]);
  const hline = (y) => { dc(border); doc.setLineWidth(0.3); doc.line(margin, y, W - margin, y); };

  doc.setFont("helvetica", "bold"); doc.setFontSize(13); tc(blue);
  doc.text("Balsuite ", margin, 22);
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); tc(muted);
  doc.text("Expense Reimbursement Slip", margin, 28);
  doc.setFont("courier", "normal"); doc.setFontSize(9); tc(blue);
  doc.text(expense.id || "—", W - margin, 22, { align: "right" });
  doc.setFont("helvetica", "bold"); doc.setFontSize(8); tc(green);
  doc.text("Reimbursed", W - margin, 28, { align: "right" });
  hline(34);

  doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted);
  doc.text("Amount reimbursed", margin, 44);
  doc.setFont("helvetica", "bold"); doc.setFontSize(26); tc(green);
  doc.text(`Rs. ${Number(expense.amount).toLocaleString("en-IN")}`, margin, 56);
  hline(63);

  const fields = [
    ["Employee", expense.employee || "—"],
    ["Department", expense.dept || "—"],
    ["Category", expense.category || "—"],
    ["Expense date", fmtDate(expense.date)],
    ["Reimbursement date", fmtDate(expense.reimbursedAt || expense.paidDate) !== "—" ? fmtDate(expense.reimbursedAt || expense.paidDate) : new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })],
    ["Payment mode", expense.payment || "—"],
    ["Transaction ref", expense.transactionRef || "—"],
    ["Status", "Reimbursed"],
  ];

  const colW = cW / 2, cellH = 14;
  let y = 70;
  for (let i = 0; i < fields.length; i += 2) {
    [0, 1].forEach((col) => {
      const f = fields[i + col]; if (!f) return;
      const x = margin + col * colW;
      doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted); doc.text(f[0], x, y);
      const isStatus = f[0] === "Status", isTxn = f[0] === "Transaction ref";
      doc.setFont("helvetica", "bold"); doc.setFontSize(11);
      tc(isStatus ? green : isTxn ? violet : dark); doc.text(String(f[1]), x, y + 7);
    });
    y += cellH;
  }
  hline(y + 4);

  const genDate = new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted);
  doc.text(`Generated ${genDate}  ·  Balsuite Expense Management System`, W / 2, y + 11, { align: "center" });
  doc.save(`slip-${expense.id}.pdf`);
};

const downloadClaimSlip = (claim) => {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const margin = 22;
  const cW = W - margin * 2;
  const dark = [24, 25, 42], muted = [100, 102, 120], border = [220, 222, 232], blue = [37, 99, 235], green = [22, 163, 74], violet = [124, 58, 237];
  const tc = (c) => doc.setTextColor(c[0], c[1], c[2]);
  const dc = (c) => doc.setDrawColor(c[0], c[1], c[2]);
  const hline = (y) => { dc(border); doc.setLineWidth(0.3); doc.line(margin, y, W - margin, y); };

  doc.setFont("helvetica", "bold"); doc.setFontSize(13); tc(blue);
  doc.text("Balsuite ", margin, 22);
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); tc(muted);
  doc.text("Claim Reimbursement Slip", margin, 28);
  doc.setFont("courier", "normal"); doc.setFontSize(9); tc(blue);
  doc.text(claim.id || "—", W - margin, 22, { align: "right" });
  doc.setFont("helvetica", "bold"); doc.setFontSize(8); tc(green);
  doc.text("Reimbursed", W - margin, 28, { align: "right" });
  hline(34);

  doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted);
  doc.text("Total reimbursed", margin, 44);
  doc.setFont("helvetica", "bold"); doc.setFontSize(26); tc(green);
  doc.text(`Rs. ${Number(claim.total).toLocaleString("en-IN")}`, margin, 56);
  hline(63);

  const fields = [
    ["Claim ID", claim.id || "—"],
    ["Period", claim.period || "—"],
    ["Title", claim.title || "—"],
    ["No. expenses", String(claim.items ?? "—")],
    ["Employee", claim.employee || "—"],
    ["Reimbursement date", fmtDate(claim.reimbursedAt || claim.paidDate) !== "—" ? fmtDate(claim.reimbursedAt || claim.paidDate) : new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })],
    ["Status", claim.statusLabel || claim.status || "—"],
  ];
  const colW = cW / 2, cellH = 14;
  let y = 70;
  for (let i = 0; i < fields.length; i += 2) {
    [0, 1].forEach((col) => {
      const f = fields[i + col]; if (!f) return;
      const x = margin + col * colW;
      doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted); doc.text(f[0], x, y);
      const isStatus = f[0] === "Status", isId = f[0] === "Claim ID", isPeriod = f[0] === "Period";
      doc.setFont("helvetica", "bold"); doc.setFontSize(11);
      tc(isStatus ? green : isId ? blue : isPeriod ? violet : dark); doc.text(String(f[1]), x, y + 7);
    });
    y += cellH;
  }
  hline(y + 4);

  const genDate = new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted);
  doc.text(`Generated ${genDate}  ·  Balsuite Expense Management System`, W / 2, y + 11, { align: "center" });
  doc.save(`claim-slip-${claim.id}.pdf`);
};

const overdueDays = (dueDate) => { if (!dueDate) return 0; return Math.max(0, Math.floor((Date.now() - new Date(dueDate).getTime()) / 86400000)); };
const AV_COLORS = ["av-blue", "av-green", "av-amber", "av-orange", "av-violet", "av-teal", "av-red", "av-indigo"];
const nameColor = (name) => AV_COLORS[[...(name || "?")].reduce((s, c) => s + c.charCodeAt(0), 0) % AV_COLORS.length];
const statusVariant = (s) => ({ "Draft": "p-draft", "Submitted": "p-submitted", "Pending L1": "p-pending", "Pending L2": "p-pending", "Pending": "p-pending-a", "Info Requested": "p-info", "Approved": "p-approved", "Reimbursed": "p-reimbursed", "Rejected": "p-rejected", "Paid": "p-paid", "Overdue": "p-overdue", "Active": "p-approved", "Paused": "p-rejected", "Credit": "p-approved", "Debit": "p-rejected" }[s] || "p-draft");
const budgetPfCls = (pct) => pct >= 80 ? "pf-red" : pct >= 60 ? "pf-amber" : "pf-green";
const budgetTextCls = (pct) => pct >= 80 ? "var(--red)" : pct >= 60 ? "var(--amber)" : "var(--green)";

/* ─── Static Data ─────────────────────────────────────────── */
const PAGE_TITLES = {
  dashboard: " Dashboard", reports: "Reports & Analytics",
  "all-expenses": "All Expenses", approvals: "Approval Queue",
  reimbursements: "Reimbursements", claims: "Expense Claims",
  budgets: "Budget Management", categories: "Categories",
  "internal-expenses": "Internal Expenses",
  "utility-bills": "Utility Bills", grocery: "Office Grocery",
  overdue: "Overdue Bills", "petty-cash": "Petty Cash",
  "int-categories": "Int. Categories",
  "system-notes": "System Notes",
  permissions: "Permissions", settings: "Settings",
};

const NAV_SECTIONS = [
  {
    title: "Overview",
    items: [
      { key: "dashboard", icon: "dashboard", label: " Dashboard" },
      { key: "reports", icon: "analytics", label: "Reports & Analytics" },

    ],
  },
  {
    title: "Employee Expenses",
    items: [
      { key: "all-expenses", icon: "receipt_long", label: "All Expenses" },
      { key: "approvals", icon: "fact_check", label: "Approval Queue" },
      { key: "reimbursements", icon: "payments", label: "Reimbursements", badgeClass: "nb-amber" },
      { key: "claims", icon: "folder_shared", label: "Expense Claims" },
      { key: "budgets", icon: "account_balance_wallet", label: "Budget Management" },
      { key: "categories", icon: "category", label: "Categories" },
    ],
  },
  {
    title: "Internal & Ops",
    items: [
      { key: "internal-expenses", icon: "business_center", label: "Internal Expenses" },
      { key: "utility-bills", icon: "bolt", label: "Utility Bills" },
      { key: "grocery", icon: "shopping_basket", label: "Office Grocery" },
      { key: "overdue", icon: "warning_amber", label: "Overdue Bills" },
      { key: "petty-cash", icon: "savings", label: "Petty Cash" },
      { key: "int-categories", icon: "tune", label: "Int. Categories" },
      { key: "system-notes", icon: "history", label: "System Notes" },
    ],
  },
];

const FOOTER_NAV = [
  { key: "permissions", icon: "manage_accounts", label: "Permissions" },
  { key: "settings", icon: "settings", label: "Settings" },
];


/* ─── Toast System (backed by react-toastify global container in App.js) ─── */
function useToast() {
  const showToast = useCallback((msg, type = "t-info") => {
    if (type === "t-error") _rToast.error(msg);
    else if (type === "t-success") _rToast.success(msg);
    else if (type === "t-amber") _rToast.warning(msg);
    else _rToast.info(msg);
  }, []);
  return { showToast };
}

/* ─── Badge State ─────────────────────────────────────────── */
function useBadges() {
  const [badges, setBadges] = useState({});
  const decrement = useCallback((key) => setBadges(p => ({ ...p, [key]: Math.max(0, (p[key] || 0) - 1) })), []);
  const syncBadges = useCallback((counts) => setBadges(counts), []);
  return { badges, decrement, syncBadges };
}

/* ─── Sidebar ─────────────────────────────────────────────── */
function Sidebar({ active, onNav, badges }) {
  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="brand-logo">
          <div className="brand-icon"><Mi icon="account_balance" /></div>
          <div>
            <div className="brand-name">Balsuite</div>
            <div className="brand-tag">Expense Control</div>
          </div>
        </div>
      </div>
      {/* <div className="admin-chip">
        <div className="admin-av">NV</div>
        <div>
          <div className="admin-name">Nikhil Varpe</div>
          <div className="admin-role">System Administrator</div>
        </div>
        <div className="admin-badge">ADMIN</div>
      </div> */}
      {NAV_SECTIONS.map((sec) => (
        <div key={sec.title}>
          <div className="nav-section">{sec.title}</div>
          {sec.items.map((item) => {
            const count = badges[item.key] !== undefined ? badges[item.key] : null;
            return (
              <button key={item.key} className={`nav-item${active === item.key ? " active" : ""}`} onClick={() => onNav(item.key)}>
                <Mi icon={item.icon} />
                <span style={{ flex: 1, textAlign: "left" }}>{item.label}</span>
                {count !== null && count > 0 && (
                  <span className={`nav-badge${item.badgeClass ? " " + item.badgeClass : ""}`}>{count}</span>
                )}
              </button>
            );
          })}
        </div>
      ))}
      <div className="sidebar-foot">
        {FOOTER_NAV.map((item) => (
          <button key={item.key} className={`nav-item dim${active === item.key ? " active" : ""}`} onClick={() => onNav(item.key)}>
            <Mi icon={item.icon} /><span>{item.label}</span>
          </button>
        ))}
      </div>
    </aside>
  );
}

/* ─── Topbar ──────────────────────────────────────────────── */
function Topbar({ active, onModal, showToast, notifOpen, setNotifOpen, notifRead, onNav, markAllRead }) {
  const ref = useRef(null);
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setNotifOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [setNotifOpen]);

  return (
    <div className="topbar">
      <div className="breadcrumb">
        <Mi icon="home" style={{ fontSize: 18, color: "var(--text3)" }} />
        <span>›</span>
        <span className="topbar-title">{PAGE_TITLES[active] || active}</span>
      </div>
      <div className="topbar-right">
        {/* <button className="btn btn-sm" onClick={() => onModal("export")}>
          <Mi icon="file_download" style={{ fontSize: 14 }} />Export
        </button> */}
        <button className="btn btn-sm btn-primary" onClick={() => onModal("new-expense")}>
          <Mi icon="add" style={{ fontSize: 14 }} />New Expense
        </button>

      </div>
    </div>
  );
}

/* ─── Page: Dashboard ─────────────────────────────────────── */
function DashboardPage({ onModal, onNav, showToast, adminStats, pendingExpenses, pendingReimbExpenses, overdueExpenses, utilityExpenses, internalSummary, pettyCashSummary, budgets }) {
  const [activeTab, setActiveTab] = useState("approvals");

  const pendingL2 = pendingExpenses || [];
  const pendingReimb = pendingReimbExpenses || [];
  const pendingReimbCount = pendingReimb.length;
  const totalReimbPending = pendingReimb.reduce((s, e) => s + Number(e.amount || 0), 0);
  const overdueList = overdueExpenses || [];
  const totalInternal = Number(internalSummary?.totalAmount || 0);
  const pcAccount = pettyCashSummary;
  const pcPct = pcAccount ? Math.min(100, Math.round((Number(pcAccount.balance) / Number(pcAccount.maxBalance)) * 100)) : 0;
  const utilityList = (utilityExpenses || []).slice(0, 3);
  const curPeriod = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}`;
  const budgetRows = (budgets || []).filter(b => b.period === curPeriod).slice(0, 6);
  const upcoming7Days = internalSummary?.upcomingItems || [];

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Expense Control Centre</div><div className="page-sub">Full operational visibility · All departments · INR</div></div>
      </div>

      {(overdueList.length > 0 || pendingL2.length > 0 || pendingReimb.length > 0) && (
        <div className="alert-row">
          {overdueList.length > 0 && (
            <div className="alert-card ac-red" onClick={() => onNav("overdue")}>
              <Mi icon="error_outline" /><div><div className="ac-title">{overdueList.length} Overdue Bill{overdueList.length > 1 ? "s" : ""}</div><div className="ac-sub">{fmtAmt(overdueList.reduce((s, e) => s + Number(e.amount || 0), 0))} at risk of late fee</div></div>
            </div>
          )}
          {pendingL2.length > 0 && (
            <div className="alert-card ac-amber" onClick={() => onNav("approvals")}>
              <Mi icon="warning_amber" /><div><div className="ac-title">{pendingL2.length} Expense{pendingL2.length > 1 ? "s" : ""} Awaiting Approval</div><div className="ac-sub">Please review and action</div></div>
            </div>
          )}
          {pendingReimb.length > 0 && (
            <div className="alert-card ac-blue" onClick={() => onNav("reimbursements")}>
              <Mi icon="info" /><div><div className="ac-title">{pendingReimb.length} Reimbursement{pendingReimb.length > 1 ? "s" : ""} Due</div><div className="ac-sub">{fmtAmt(totalReimbPending)} pending processing</div></div>
            </div>
          )}
        </div>
      )}

      <div className="section-divider"><div className="sd-label">Employee Expenses</div><div className="sd-line" /></div>
      <div className="kpi-grid">
        {[
          { label: "Total Expenses This Month", val: fmtAmt(adminStats?.totalThisMonth), trend: fmtAmt(adminStats?.totalAllExpenses) + " all time", icon: "receipt_long", kCls: "kpi-blue", iCls: "ki-blue", page: "all-expenses" },
          { label: "Pending Approvals", val: pendingL2.length, trend: `${pendingL2.length} awaiting review`, trendCls: pendingL2.length > 0 ? "trend-dn" : "", icon: "pending_actions", kCls: "kpi-red", iCls: "ki-red", page: "approvals" },
          { label: "Pending Reimbursements", val: fmtAmt(totalReimbPending), trend: `${pendingReimb.length} employee${pendingReimb.length !== 1 ? "s" : ""} awaiting`, icon: "account_balance_wallet", kCls: "kpi-amber", iCls: "ki-amber", page: "reimbursements" },
          { label: "Reimbursed This Month", val: fmtAmt(adminStats?.totalReimbursed), trend: "View full report", trendCls: "trend-up", icon: "check_circle", kCls: "kpi-green", iCls: "ki-green", page: "reports" },
        ].map((k) => (
          <div key={k.label} className={`kpi ${k.kCls}`} onClick={() => onNav(k.page)}>
            <div className="kpi-top"><span className="kpi-label">{k.label}</span><div className={`kpi-icon ${k.iCls}`}><Mi icon={k.icon} /></div></div>
            <div className="kpi-val">{k.val}</div>
            <div className={`kpi-trend${k.trendCls ? " " + k.trendCls : ""}`}>{k.trend}</div>
          </div>
        ))}
      </div>

      <div className="section-divider"><div className="sd-label">Internal & Operations</div><div className="sd-line" /></div>
      <div className="kpi-grid">
        {[
          { label: "Total Internal Expenses", val: fmtAmt(totalInternal), trend: `${internalSummary?.upcomingCount ?? 0} upcoming dues`, icon: "business_center", kCls: "kpi-violet", iCls: "ki-violet", page: "internal-expenses" },
          { label: "Overdue Bills", val: overdueList.length, trend: overdueList.length > 0 ? `${fmtAmt(overdueList.reduce((s, e) => s + Number(e.amount || 0), 0))} at risk` : "All bills current", trendCls: overdueList.length > 0 ? "trend-dn" : "", icon: "warning", kCls: "kpi-orange", iCls: "ki-orange", page: "overdue" },
          { label: "Petty Cash Balance", val: pcAccount ? fmtAmt(pcAccount.balance) : "—", trend: pcAccount?.name || "Main Office account", icon: "savings", kCls: "kpi-teal", iCls: "ki-teal", page: "petty-cash" },
          { label: "Upcoming Dues (7 days)", val: upcoming7Days.length, trend: upcoming7Days.length > 0 ? `${fmtAmt(upcoming7Days.reduce((s, e) => s + Number(e.amount || 0), 0))} due soon` : "No upcoming dues", icon: "event", kCls: "kpi-cyan", iCls: "ki-cyan", page: "utility-bills" },
        ].map((k) => (
          <div key={k.label} className={`kpi ${k.kCls}`} onClick={() => onNav(k.page)}>
            <div className="kpi-top"><span className="kpi-label">{k.label}</span><div className={`kpi-icon ${k.iCls}`}><Mi icon={k.icon} /></div></div>
            <div className="kpi-val">{k.val}</div>
            <div className={`kpi-trend${k.trendCls ? " " + k.trendCls : ""}`}>{k.trend}</div>
          </div>
        ))}
      </div>

      <div className="two-col">
        <div className="card">
          <div className="card-head">
            <div><div className="card-title">All Pending Actions</div><div className="card-sub">Requires admin attention</div></div>
            {/* <button className="btn btn-sm btn-success" onClick={() => showToast("Bulk action initiated", "t-success")}><Mi icon="done_all" style={{ fontSize: 14 }} />Bulk Action</button> */}
          </div>
          <div className="tab-bar">
            {[["approvals", `Approvals (${pendingL2.length})`], ["reimb", `Reimbursements (${pendingReimb.length})`], ["overdue-tab", `Overdue (${overdueList.length})`]].map(([k, l]) => (
              <button key={k} className={`tab${activeTab === k ? " active" : ""}`} onClick={() => setActiveTab(k)}>{l}</button>
            ))}
          </div>
          {activeTab === "approvals" && (
            pendingL2.length === 0
              ? <div className="empty-state"><Mi icon="check_circle" /><div>No pending approvals</div></div>
              : <div className="tbl-wrap">
                <table>
                  <thead><tr><th>Ref</th><th>Employee</th><th>Category</th><th>Amount</th><th>Date</th><th>Status</th><th>Action</th></tr></thead>
                  <tbody>
                    {pendingL2.slice(0, 5).map((e) => (
                      <tr key={e.id}>
                        <td style={{ fontWeight: 700, color: "var(--accent)", fontFamily: "var(--font)" }}>{e.id}</td>
                        <td><div style={{ display: "flex", alignItems: "center", gap: 8 }}><RiAv initials={getInitials(e.employee)} color={nameColor(e.employee)} size={26} />{e.employee || "—"}</div></td>
                        <td><span className="cat-tag">{e.category}</span></td>
                        <td style={{ fontWeight: 700 }}>{fmtAmt(e.amount)}</td>
                        <td style={{ color: "var(--text3)", fontFamily: "var(--font2)" }}>{e.date}</td>
                        <td><Pill variant={statusVariant(e.status)}>{e.statusLabel || e.status}</Pill></td>
                        <td><div className="tbl-actions">
                          <button className="btn-icon btn-danger" title="Reject" onClick={() => onModal("reject", e.id)}><Mi icon="close" style={{ fontSize: 14 }} /></button>
                          <button className="btn-icon btn-success" title="Approve" onClick={() => onModal("approve", e.id)}><Mi icon="check" style={{ fontSize: 14 }} /></button>
                        </div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
          )}
          {activeTab === "reimb" && (
            pendingReimb.length === 0
              ? <div className="empty-state"><Mi icon="check_circle" /><div>No pending reimbursements</div></div>
              : <div className="tbl-wrap">
                <table>
                  <thead><tr><th>Employee</th><th>Ref</th><th>Amount</th><th>Category</th><th>Action</th></tr></thead>
                  <tbody>
                    {pendingReimb.slice(0, 5).map((e) => (
                      <tr key={e.id}>
                        <td><div style={{ display: "flex", alignItems: "center", gap: 8 }}><RiAv initials={getInitials(e.employee)} color={nameColor(e.employee)} size={26} />{e.employee || "—"}</div></td>
                        <td style={{ fontWeight: 700, color: "var(--accent)", fontFamily: "var(--font)" }}>{e.id}</td>
                        <td style={{ fontWeight: 700 }}>{fmtAmt(e.amount)}</td>
                        <td><span className="cat-tag">{e.category}</span></td>
                        <td><div className="tbl-actions"><button className="btn btn-sm btn-primary" onClick={() => onModal("reimburse", `${e.employee}|${fmtAmt(e.amount)}|${e.id}`)}>Process</button></div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
          )}
          {activeTab === "overdue-tab" && (
            overdueList.length === 0
              ? <div className="empty-state"><Mi icon="check_circle" /><div>No overdue bills</div></div>
              : <div className="tbl-wrap">
                <table>
                  <thead><tr><th>Ref</th><th>Bill</th><th>Amount</th><th>Due Date</th><th>Overdue</th><th>Action</th></tr></thead>
                  <tbody>
                    {overdueList.slice(0, 5).map((e) => (
                      <tr key={e.internalId}>
                        <td style={{ fontWeight: 700, color: "var(--red)", fontFamily: "var(--font)" }}>{e.internalId}</td>
                        <td className="td-wrap">{e.title}</td>
                        <td style={{ fontWeight: 700 }}>{fmtAmt(e.amount)}</td>
                        <td style={{ color: "var(--red)", fontFamily: "var(--font2)" }}>{fmtDate(e.dueDate)}</td>
                        <td><Pill variant="p-overdue">+{overdueDays(e.dueDate)}d</Pill></td>
                        <td><div className="tbl-actions"><button className="btn btn-sm btn-primary" onClick={() => onModal("mark-paid", e.internalId)}>Mark Paid</button></div></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
          )}
          <div style={{ padding: "10px 0", display: "flex", justifyContent: "flex-end" }}>
            <button className="btn-sm" style={{ fontSize: 12, background: "var(--surface)", border: "none" }} onClick={() => onNav(activeTab === "reimb" ? "reimbursements" : activeTab === "overdue-tab" ? "overdue" : "approvals")}>View All →</button>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div className="card">
            <div className="card-head">
              <div><div className="card-title">Reimbursement Queue</div><div className="card-sub">{pendingReimb.length} employee{pendingReimb.length !== 1 ? "s" : ""} pending payment</div></div>
              <button className="btn btn-sm btn-primary" onClick={() => onModal("process-all")}>Process All</button>
            </div>
            {pendingReimb.length === 0
              ? <div className="empty-state" style={{ padding: 20 }}><Mi icon="check_circle" /><div>No pending reimbursements</div></div>
              : pendingReimb.slice(0, 4).map((e) => (
                <div key={e.id} className="reimb-item" onClick={() => onModal("reimburse", `${e.employee}|${fmtAmt(e.amount)}|${e.id}`)}>
                  <RiAv initials={getInitials(e.employee)} color={nameColor(e.employee)} size={36} />
                  <div className="ri-info"><div className="ri-name">{e.employee || "—"}</div><div className="ri-det">{e.id} · {e.category}</div></div>
                  <div className="ri-right"><div className="ri-amt">{fmtAmt(e.amount)}</div></div>
                </div>
              ))
            }
            {pendingReimb.length > 0 && (
              <div style={{ paddingTop: 10, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: "var(--text2)" }}>Total: <span style={{ color: "var(--text)" }}>{fmtAmt(totalReimbPending)}</span></span>
                <button className="btn-sm" style={{ fontSize: 12, background: "var(--surface)", border: "none" }} onClick={() => onNav("reimbursements")}>Full Queue →</button>
              </div>
            )}
          </div>
          {pcAccount
            ? <div className="petty-card">
              <div className="petty-account">{pcAccount.name}</div>
              <div className="petty-balance">{fmtAmt(pcAccount.balance)}</div>
              <div className="petty-sub">Low balance alert at {fmtAmt(pcAccount.alertLevel)}</div>
              <div className="petty-bar-wrap"><div className="petty-bar-fill" style={{ width: `${pcPct}%` }} /></div>
              <div className="petty-meta">
                <div className="petty-meta-item"><div className="pm-val">{fmtAmt(pcAccount.maxBalance)}</div><div className="pm-lbl">Max Balance</div></div>
                {/* <div className="petty-meta-item"><div className="pm-val">{pcAccount.custodian || "—"}</div><div className="pm-lbl">Custodian</div></div> */}
                <div className="petty-meta-item"><div className="pm-val" style={{ color: "#FCA5A5" }}>{fmtAmt(pcAccount.alertLevel)}</div><div className="pm-lbl">Alert Level</div></div>
                <div className="petty-meta-item" style={{ zIndex: 2 }}>
                  <button style={{ background: "rgba(255,255,255,.15)", border: "1px solid rgba(255,255,255,.3)", borderRadius: 7, color: "#fff", fontSize: 12, fontWeight: 600, padding: "5px 12px", cursor: "pointer", fontFamily: "var(--font)" }} onClick={() => onModal("credit-petty")}>+ Credit</button>
                </div>
              </div>
            </div>
            : <div className="card" style={{ textAlign: "center", padding: 24 }}>
              <Mi icon="savings" style={{ fontSize: 32, color: "var(--text3)" }} />
              <div style={{ fontSize: 13, color: "var(--text3)", marginTop: 8 }}>Petty cash account not set up</div>
            </div>
          }
        </div>
      </div>

      <div className="three-col" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px" }}>
        <div className="card">
          <div className="card-head"><div className="card-title">Department Budget Usage</div><button className="btn-sm" style={{ fontSize: 12, background: "var(--surface)", border: "none" }} onClick={() => onNav("budgets")}>View All →</button></div>
          {budgetRows.length === 0
            ? <div className="empty-state" style={{ padding: 20 }}><Mi icon="account_balance_wallet" /><div>No budgets configured</div></div>
            : budgetRows.map((b) => {
              const pct = Number(b.allocatedAmount) > 0 ? Math.min(100, Math.round((Number(b.spentAmount || 0) / Number(b.allocatedAmount)) * 100)) : 0;
              return (
                <div key={b.id || b.department} className="dept-row">
                  <div className="dept-top"><span className="dept-name">{b.department}</span><span className="dept-pct" style={{ color: budgetTextCls(pct) }}>{pct}%</span></div>
                  <div className="dept-nums"><span style={{ fontSize: 11, color: "var(--text3)", fontFamily: "var(--font2)" }}>{fmtAmt(b.spentAmount)} of {fmtAmt(b.allocatedAmount)}</span></div>
                  <div className="prog-wrap"><div className={`prog-fill ${budgetPfCls(pct)}`} style={{ width: `${pct}%` }} /></div>
                </div>
              );
            })
          }
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div className="card">
            <div className="card-head"><div className="card-title">Utility Bills</div><button className="btn btn-sm btn-primary" onClick={() => onModal("add-utility")}><Mi icon="add" style={{ fontSize: 13 }} />Add</button></div>
            {utilityList.length === 0
              ? <div className="empty-state" style={{ padding: 20 }}><Mi icon="bolt" /><div>No utility bills</div></div>
              : utilityList.map((u) => (
                <div key={u.internalId} className="util-row">
                  <div className="util-icon" style={{ background: "var(--amber-bg)", color: "var(--amber)" }}><Mi icon="bolt" className="mi" /></div>
                  <div className="util-info"><div className="util-name">{u.title}</div><div className="util-month">{u.billMonth}{u.vendor ? ` · ${u.vendor}` : ""}</div></div>
                  <div className="util-right"><div className="util-amt">{fmtAmt(u.amount)}</div><div className="util-status" style={{ color: u.status === "Overdue" ? "var(--red)" : u.status === "Paid" ? "var(--green)" : "var(--amber)" }}>{u.status}</div></div>
                </div>
              ))
            }
          </div>
        </div>
        {/* <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div className="card">
            <div className="card-head"><div className="card-title">Active Policy Config</div><button className="btn btn-sm" onClick={() => onNav("policy")}><Mi icon="edit" style={{ fontSize: 13 }} />Edit</button></div>
            {[["Auto-Approve Threshold", "₹200"], ["Approval Workflow", "Two-Level"], ["Submission Window", "30 days"], ["Attachment Required", "≥ ₹500"], ["Reimbursement Cycle", "Every 7 days"], ["Currency", "INR (₹)"]].map(([k, v]) => (
              <div key={k} className="pol-item"><span className="pol-key">{k}</span><span className="pol-val">{v}</span></div>
            ))}
          </div>
        </div> */}
      </div>
    </>
  );
}

/* ─── Page: Reports ─────────────────────────────────────────── */
function ReportsPage({ onModal, showToast, analytics, adminStats, budgets }) {
  const total = analytics?.totalCount || 0;
  const totalReimbursed = Number(adminStats?.totalReimbursed || 0);
  const totalThisMonth  = Number(adminStats?.totalThisMonth  || 0);
  const pendingCount    = Number(adminStats?.pendingApproval || 0);
  const pendingReimb    = Number(adminStats?.pendingReimbCount || 0);

  const statusBreakdown = analytics?.statusBreakdown || {};
  const deptBreakdown   = analytics?.departmentBreakdown || [];
  const topEmployees    = analytics?.topEmployees || [];

  const totalStatusCount = Object.values(statusBreakdown).reduce((s, v) => s + Number(v), 0) || 1;

  const STATUS_META = [
    { key: "Pending L1",      label: "Pending L1",      color: "#f59e0b" },
    { key: "Pending L2",      label: "Pending L2",      color: "#f97316" },
    { key: "Info Requested",  label: "Info Requested",  color: "#6366f1" },
    { key: "Approved",        label: "Approved",        color: "#10b981" },
    { key: "Reimbursed",      label: "Reimbursed",      color: "#3b82f6" },
    { key: "Rejected",        label: "Rejected",        color: "#ef4444" },
  ];

  const monthBars = useMemo(() => {
    const now = new Date();
    const bars = Array.from({ length: 8 }, (_, i) => {
      const d = new Date(now.getFullYear(), now.getMonth() - (7 - i), 1);
      return { key: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`, label: d.toLocaleString("default", { month: "short" }), isCurrent: i === 7, total: 0 };
    });
    (analytics?.monthlyTotals || []).forEach(m => {
      const bar = bars.find(b => b.key === m.month);
      if (bar) bar.total = Number(m.total || 0);
    });
    const maxVal = Math.max(...bars.map(b => b.total), 1);
    return bars.map(b => ({ ...b, height: Math.max(4, Math.round((b.total / maxVal) * 100)) }));
  }, [analytics]);

  const catData = useMemo(() => {
    const breakdown = (analytics?.categoryBreakdown || []).slice(0, 6);
    const maxVal = Number(breakdown[0]?.total || 1);
    return breakdown.map(c => ({ name: c.category, total: Number(c.total || 0), pct: Math.round((Number(c.total || 0) / maxVal) * 100) }));
  }, [analytics]);

  const deptData = useMemo(() => {
    const maxVal = Number(deptBreakdown[0]?.total || 1);
    return deptBreakdown.slice(0, 8).map(d => ({ name: d.name, total: Number(d.total || 0), count: d.count, pct: Math.round((Number(d.total || 0) / maxVal) * 100) }));
  }, [deptBreakdown]);

  const budgetData = useMemo(() => {
    const now = new Date();
    const curPeriod = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
    const activeBudgets = (budgets || []).filter(b => b.period === curPeriod || !b.period);
    const totalAlloc = activeBudgets.reduce((s, b) => s + Number(b.allocatedAmount || 0), 0);
    const totalSpent = activeBudgets.reduce((s, b) => s + Number(b.spentAmount || 0), 0);
    const totalRemain = totalAlloc - totalSpent;
    const overBudget = activeBudgets.filter(b => Number(b.spentAmount || 0) > Number(b.allocatedAmount || 0)).length;
    const nearLimit = activeBudgets.filter(b => {
      const alloc = Number(b.allocatedAmount || 0);
      const spent = Number(b.spentAmount || 0);
      return alloc > 0 && spent <= alloc && (spent / alloc) >= 0.9;
    }).length;
    const rows = activeBudgets
      .map(b => {
        const alloc = Number(b.allocatedAmount || 0);
        const spent = Number(b.spentAmount || 0);
        const pct = alloc > 0 ? Math.min(100, Math.round((spent / alloc) * 100)) : 0;
        return { dept: b.department, cat: b.category || "Overall", alloc, spent, remain: alloc - spent, pct };
      })
      .sort((a, b) => b.pct - a.pct)
      .slice(0, 8);
    return { totalAlloc, totalSpent, totalRemain, overBudget, nearLimit, rows, count: activeBudgets.length };
  }, [budgets]);

  const REPORT_TYPES = [
    ["account_balance",  "var(--accent)",  "Budget Report",          "budget-report"],
    ["summarize",        "var(--text2)",   "Expense Summary",        "expense-summary"],
    ["payments",         "var(--green)",   "Reimbursement Statement","reimbursement"],
    ["pending_actions",  "var(--amber)",   "Pending Approvals",      "pending"],
    ["cancel",           "var(--red)",     "Rejected Expenses",      "rejected"],
    ["bolt",             "var(--teal)",    "Utility Bill History",   "utility"],
    ["shopping_cart",    "var(--orange)",  "Grocery Report",         "grocery"],
    ["corporate_fare",   "var(--cyan)",    "All Internal Expenses",  "internal"],
    ["savings",          "var(--violet)",  "Petty Cash Statement",   "petty-cash"],
    ["receipt_long",     "#64748b",        "All Expenses (Full)",    "all-expenses"],
  ];

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Reports & Analytics</div><div className="page-sub">Export and monitor expense trends · {total} total transactions</div></div>
        <button className="btn btn-primary" onClick={() => onModal("export", "expense-summary")}><Mi icon="file_download" style={{ fontSize: 14 }} />Export Report</button>
      </div>

      {/* KPI strip */}
      <div style={{ display: "flex", flexShrink: 0, background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 10 }}>
        {[
          { label: "Total This Month",      val: fmtAmt(totalThisMonth),                  color: "var(--accent)" },
          { label: "Total Transactions",    val: total,                                    color: "var(--text)" },
          { label: "Reimbursed YTD",        val: fmtAmt(totalReimbursed),                 color: "var(--green)" },
          { label: "Pending Approval",      val: pendingCount,                             color: pendingCount > 0 ? "var(--amber)" : "var(--text)" },
          { label: "Pending Reimb.",        val: pendingReimb,                             color: pendingReimb > 0 ? "var(--orange)" : "var(--text)" },
          { label: "Rejected",              val: Number(statusBreakdown["Rejected"] || 0), color: Number(statusBreakdown["Rejected"] || 0) > 0 ? "var(--red)" : "var(--text)" },
        ].map((m, i, arr) => (
          <div key={m.label} style={{ flex: 1, minWidth: 0, padding: "13px 10px", textAlign: "center", borderRight: i < arr.length - 1 ? "1px solid var(--border)" : "none" }}>
            <div style={{ fontSize: 17, fontWeight: 800, fontFamily: "var(--font2)", color: m.color, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{m.val}</div>
            <div style={{ fontSize: 10, color: "var(--text3)", marginTop: 3, textTransform: "uppercase", letterSpacing: ".4px", fontFamily: "var(--font2)" }}>{m.label}</div>
          </div>
        ))}
      </div>

      {/* Row 1: Monthly trend + Category */}
      <div className="three-col">
        <div className="card" style={{ gridColumn: "span 2" }}>
          <div className="card-head"><div className="card-title">Monthly Expense Trend</div><div className="card-sub">Last 8 months</div></div>
          <div className="chart-bar-wrap">
            {monthBars.map(b => (
              <div key={b.key} style={{ display: "flex", flexDirection: "column", alignItems: "center", flex: 1 }}>
                <div style={{ fontSize: 10, color: "var(--text3)", marginBottom: 4, fontFamily: "var(--font2)" }}>{b.total > 0 ? fmtAmt(b.total) : ""}</div>
                <div className="chart-bar" style={{ height: `${b.height}%`, background: b.isCurrent ? "var(--accent)" : "var(--accent-mid)", minHeight: 4 }} title={fmtAmt(b.total)} />
                <div className="chart-bar-label" style={b.isCurrent ? { fontWeight: 700, color: "var(--accent)" } : {}}>{b.label}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="card">
          <div className="card-head"><div className="card-title">Spend by Category</div></div>
          {catData.length === 0
            ? <div style={{ padding: 20, color: "var(--text3)", textAlign: "center", fontSize: 13 }}>No data</div>
            : <div style={{ display: "flex", flexDirection: "column", gap: 10, padding: "4px 0" }}>
              {catData.map(c => (
                <div key={c.name}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 4 }}>
                    <span style={{ color: "var(--text2)", fontWeight: 500 }}>{c.name}</span>
                    <span style={{ fontWeight: 700, fontFamily: "var(--font2)" }}>{fmtAmt(c.total)}</span>
                  </div>
                  <div style={{ height: 6, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${c.pct}%`, background: "var(--accent)", borderRadius: 4, transition: "width .4s" }} />
                  </div>
                </div>
              ))}
            </div>
          }
        </div>
      </div>

      {/* Row 2: Status breakdown + Department breakdown */}
      <div className="three-col">
        <div className="card">
          <div className="card-head"><div className="card-title">Status Distribution</div><div className="card-sub">{total} total expenses</div></div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10, padding: "4px 0" }}>
            {STATUS_META.map(s => {
              const cnt = Number(statusBreakdown[s.key] || 0);
              const pct = Math.round((cnt / totalStatusCount) * 100);
              return (
                <div key={s.key}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 4 }}>
                    <span style={{ color: "var(--text2)", fontWeight: 500 }}>{s.label}</span>
                    <span style={{ fontWeight: 700, fontFamily: "var(--font2)", color: s.color }}>{cnt} <span style={{ color: "var(--text3)", fontWeight: 400 }}>({pct}%)</span></span>
                  </div>
                  <div style={{ height: 6, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${pct}%`, background: s.color, borderRadius: 4, transition: "width .4s" }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="card" style={{ gridColumn: "span 2" }}>
          <div className="card-head"><div className="card-title">Department-wise Spend</div><div className="card-sub">Approved + active expenses</div></div>
          {deptData.length === 0
            ? <div style={{ padding: 20, color: "var(--text3)", textAlign: "center", fontSize: 13 }}>No data</div>
            : <div style={{ display: "flex", flexDirection: "column", gap: 10, padding: "4px 0" }}>
              {deptData.map(d => (
                <div key={d.name}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, marginBottom: 4 }}>
                    <span style={{ color: "var(--text2)", fontWeight: 600 }}>{d.name}</span>
                    <span style={{ display: "flex", gap: 12 }}>
                      <span style={{ color: "var(--text3)", fontFamily: "var(--font2)" }}>{d.count} expense{d.count !== 1 ? "s" : ""}</span>
                      <span style={{ fontWeight: 700, fontFamily: "var(--font2)" }}>{fmtAmt(d.total)}</span>
                    </span>
                  </div>
                  <div style={{ height: 7, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${d.pct}%`, background: "var(--accent)", borderRadius: 4, transition: "width .4s" }} />
                  </div>
                </div>
              ))}
            </div>
          }
        </div>
      </div>

      {/* Row 3: Budget Utilization */}
      <div className="three-col">
        <div className="card" style={{ gridColumn: "span 3" }}>
          <div className="card-head" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <div className="card-title">Budget Utilization — Current Month</div>
              <div className="card-sub">{budgetData.count} active budget{budgetData.count !== 1 ? "s" : ""} · Allocation vs Spend</div>
            </div>
            <button className="btn" style={{ fontSize: 12, padding: "5px 12px" }} onClick={() => onModal("export", "budget-report")}>
              <Mi icon="file_download" style={{ fontSize: 14 }} />Export Budget Report
            </button>
          </div>
          {/* Summary strip */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 12, marginBottom: 18, padding: "12px 0 16px", borderBottom: "1px solid var(--border)" }}>
            {[
              { label: "Total Allocated", val: fmtAmt(budgetData.totalAlloc), color: "var(--accent)" },
              { label: "Total Spent",     val: fmtAmt(budgetData.totalSpent),  color: "var(--amber)" },
              { label: "Remaining",       val: fmtAmt(budgetData.totalRemain), color: budgetData.totalRemain < 0 ? "var(--red)" : "var(--green)" },
              { label: "Over Budget",     val: budgetData.overBudget,           color: budgetData.overBudget > 0 ? "var(--red)" : "var(--text3)" },
              { label: "Near Limit (≥90%)", val: budgetData.nearLimit,         color: budgetData.nearLimit > 0 ? "var(--amber)" : "var(--text3)" },
            ].map(({ label, val, color }) => (
              <div key={label} style={{ textAlign: "center" }}>
                <div style={{ fontSize: 18, fontWeight: 800, fontFamily: "var(--font2)", color }}>{val}</div>
                <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 2 }}>{label}</div>
              </div>
            ))}
          </div>
          {/* Per-budget rows */}
          {budgetData.rows.length === 0
            ? <div style={{ padding: 20, color: "var(--text3)", textAlign: "center", fontSize: 13 }}>No budget data for current month</div>
            : <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {budgetData.rows.map(row => {
                const isOver = row.remain < 0;
                const isNear = !isOver && row.pct >= 90;
                const barColor = isOver ? "var(--red)" : isNear ? "#f59e0b" : "var(--accent)";
                return (
                  <div key={`${row.dept}-${row.cat}`}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12, marginBottom: 5 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
                        <span style={{ fontWeight: 600, color: "var(--text)" }}>{row.dept}</span>
                        <span style={{ fontSize: 11, color: "var(--text3)", background: "var(--surface2)", padding: "1px 7px", borderRadius: 10 }}>{row.cat}</span>
                        {isOver && <span style={{ fontSize: 10, fontWeight: 700, color: "#fff", background: "var(--red)", padding: "1px 6px", borderRadius: 10 }}>OVER</span>}
                        {isNear && !isOver && <span style={{ fontSize: 10, fontWeight: 700, color: "#fff", background: "#f59e0b", padding: "1px 6px", borderRadius: 10 }}>NEAR</span>}
                      </div>
                      <div style={{ display: "flex", gap: 16, fontFamily: "var(--font2)", flexShrink: 0 }}>
                        <span style={{ color: "var(--text3)" }}>Alloc: <strong style={{ color: "var(--text)" }}>{fmtAmt(row.alloc)}</strong></span>
                        <span style={{ color: "var(--text3)" }}>Spent: <strong style={{ color: barColor }}>{fmtAmt(row.spent)}</strong></span>
                        <span style={{ color: "var(--text3)" }}>Remain: <strong style={{ color: isOver ? "var(--red)" : "var(--green)" }}>{fmtAmt(row.remain)}</strong></span>
                        <span style={{ fontWeight: 700, color: barColor, minWidth: 38, textAlign: "right" }}>{row.pct}%</span>
                      </div>
                    </div>
                    <div style={{ height: 7, background: "var(--surface2)", borderRadius: 4, overflow: "hidden" }}>
                      <div style={{ height: "100%", width: `${Math.min(100, row.pct)}%`, background: barColor, borderRadius: 4, transition: "width .4s" }} />
                    </div>
                  </div>
                );
              })}
            </div>
          }
        </div>
      </div>

      {/* Row 4: Top employees + Download reports */}
      <div className="three-col">
        <div className="card">
          <div className="card-head"><div className="card-title">Top Employees by Spend</div><div className="card-sub">Approved expenses</div></div>
          {topEmployees.length === 0
            ? <div style={{ padding: 20, color: "var(--text3)", textAlign: "center", fontSize: 13 }}>No data</div>
            : <div style={{ display: "flex", flexDirection: "column", gap: 12, padding: "4px 0" }}>
              {topEmployees.map((e, i) => (
                <div key={e.name} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 24, height: 24, borderRadius: "50%", background: "var(--accent)", color: "#fff", fontSize: 11, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{i + 1}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{e.name}</div>
                    <div style={{ fontSize: 11, color: "var(--text3)", fontFamily: "var(--font2)" }}>{e.count} expense{e.count !== 1 ? "s" : ""}</div>
                  </div>
                  <div style={{ fontWeight: 800, fontSize: 13, fontFamily: "var(--font2)", color: "var(--accent)" }}>{fmtAmt(e.total)}</div>
                </div>
              ))}
            </div>
          }
        </div>
        <div className="card" style={{ gridColumn: "span 2" }}>
          <div className="card-head"><div className="card-title">Download Reports</div><div className="card-sub">All reports export as CSV — click to configure filters</div></div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))", gap: 10, padding: "4px 0" }}>
            {REPORT_TYPES.map(([icon, color, label, rtype]) => (
              <button key={rtype} className="btn" style={{ justifyContent: "flex-start", gap: 10 }} onClick={() => onModal("export", rtype)}>
                <Mi icon={icon} style={{ fontSize: 18, color }} />
                <span style={{ fontSize: 13 }}>{label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

/* ─── Page: All Expenses ─────────────────────────────────── */
const YEAR_OPTIONS = Array.from({ length: new Date().getFullYear() - 2023 }, (_, i) => new Date().getFullYear() - i);

function AllExpensesPage({ onModal, showToast, allExpenses, onRefresh }) {
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [filterCat, setFilterCat] = useState("All");
  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const rows = (allExpenses || []).filter(e => {
    const q = search.toLowerCase();
    const matchSearch = !q || (e.id || "").toLowerCase().includes(q) || (e.employee || "").toLowerCase().includes(q) || String(e.amount || "").includes(q);
    const matchStatus = filterStatus === "All" || e.status === filterStatus;
    const matchCat = filterCat === "All" || e.category === filterCat;
    return matchSearch && matchStatus && matchCat;
  });
  const totalPages = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
  const pageRows = rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
  const cats = [...new Set((allExpenses || []).map(e => e.category).filter(Boolean))].sort();

  const actionFor = (e) => {
    if (e.status === "Pending L2" || e.status === "Pending L1") return "approve-reject";
    if (e.status === "Approved") return "reimburse";
    if (e.status === "Info Requested") return "view";
    if (e.status === "Reimbursed") return "slip";
    return "view";
  };

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">All Expenses</div><div className="page-sub">{rows.length} expense{rows.length !== 1 ? "s" : ""}</div></div>
        <button className="btn btn-primary" onClick={() => onModal("new-expense")}><Mi icon="add" style={{ fontSize: 14 }} />New Expense</button>
      </div>
      <div className="filter-row">
        <div className="search-bar"><Mi icon="search" /><input type="text" placeholder="Search by name, ref, amount..." value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} /></div>
        <select className="form-control" style={{ width: "auto" }} value={filterStatus} onChange={e => { setFilterStatus(e.target.value); setPage(1); }}>
          <option value="All">All Status</option>
          {["Draft", "Pending L1", "Pending L2", "Info Requested", "Approved", "Reimbursed", "Rejected"].map(s => <option key={s}>{s}</option>)}
        </select>
        <select className="form-control" style={{ width: "auto" }} value={filterCat} onChange={e => { setFilterCat(e.target.value); setPage(1); }}>
          <option value="All">All Categories</option>
          {cats.map(c => <option key={c}>{c}</option>)}
        </select>
        <select className="form-control" style={{ width: "auto" }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); setPage(1); onRefresh(y); }}>
          {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <button className="btn" onClick={() => { setSearch(""); setFilterStatus("All"); setFilterCat("All"); setPage(1); showToast("Filters cleared", "t-info"); }}>Clear</button>
      </div>
      <div className="card" style={{ padding: 0 }}>
        <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table>
            <thead><tr><th>Ref</th><th>Employee</th><th>Category</th><th>Amount</th><th>Date</th><th>Project</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {pageRows.length === 0
                ? <tr><td colSpan={8} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No expenses found</td></tr>
                : pageRows.map((e) => {
                  const action = actionFor(e);
                  return (
                    <tr key={e.id}>
                      <td style={{ fontWeight: 700, color: "var(--accent)", fontFamily: "var(--font)" }}>{e.id}</td>
                      <td><div style={{ display: "flex", alignItems: "center", gap: 8 }}><RiAv initials={getInitials(e.employee)} color={nameColor(e.employee)} size={26} />{e.employee || "—"}</div></td>
                      <td><span className="cat-tag">{e.category}</span></td>
                      <td style={{ fontWeight: 700 }}>{fmtAmt(e.amount)}</td>
                      <td style={{ fontFamily: "var(--font2)", color: "var(--text3)" }}>{e.date}</td>
                      <td style={{ fontFamily: "var(--font2)" }}>{e.project || "—"}</td>
                      <td><Pill variant={statusVariant(e.status)}>{e.statusLabel || e.status}</Pill></td>
                      <td>
                        <div className="tbl-actions">
                          {action === "approve-reject" && <><button className="btn-icon btn-success" title="Approve" onClick={() => onModal("approve", e.id)}><Mi icon="check" style={{ fontSize: 14 }} /></button><button className="btn-icon btn-danger" title="Reject" onClick={() => onModal("reject", e.id)}><Mi icon="close" style={{ fontSize: 14 }} /></button></>}
                          {action === "reimburse" && <button className="btn btn-sm btn-primary" onClick={() => onModal("reimburse", `${e.employee}|${fmtAmt(e.amount)}|${e.id}`)}>Reimburse</button>}
                          {action === "slip" && <button className="btn btn-sm btn-primary" onClick={() => downloadSlip(e)}><Mi icon="download" style={{ fontSize: 13 }} />Slip</button>}
                          <button className="btn btn-sm" onClick={() => onModal("view-info", e.id)}>View</button>
                          {e.receiptBase64 && <button className="btn-icon" title="View Receipt" onClick={() => onModal("view-receipt", e.id)}><Mi icon="attach_file" style={{ fontSize: 15 }} /></button>}
                        </div>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        <Pager page={page} total={rows.length} onChange={setPage} label="expenses" />
      </div>
    </>
  );
}

/* ─── Page: Approvals ─────────────────────────────────────── */
function ApprovalsPage({ onModal, allExpenses, allClaims }) {
  const [page, setPage] = useState(1);
  const pendingExp = (allExpenses || []).filter(e => e.status === "Pending L2" || e.status === "Pending L1");
  const all = pendingExp.map(e => ({ ref: e.id, refColor: "var(--accent)", name: e.employee, type: e.category, amt: fmtAmt(e.amount), wait: e.age || "—", level: statusVariant(e.status), levelLabel: e.status, kind: "expense", receiptBase64: e.receiptBase64 }));
  const pageRows = all.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Approval Queue</div><div className="page-sub">{all.length} item{all.length !== 1 ? "s" : ""} awaiting admin action</div></div>
        {all.length > 0 && <button className="btn btn-success" onClick={() => onModal("bulk-approve")}><Mi icon="done_all" style={{ fontSize: 14 }} />Bulk Approve ({all.length})</button>}
      </div>
      {all.length > 0 && (
        <div className="alert-card ac-amber" style={{ marginBottom: 0 }}>
          <Mi icon="schedule" /><div><div className="ac-title">{all.length} approval{all.length !== 1 ? "s" : ""} pending</div><div className="ac-sub">Please review and action</div></div>
        </div>
      )}
      <div className="card" style={{ padding: 0 }}>
        <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table>
            <thead><tr><th>Ref</th><th>Employee</th><th>Type</th><th>Amount</th><th>Waiting</th><th>Level</th><th>Actions</th></tr></thead>
            <tbody>
              {all.length === 0
                ? <tr><td colSpan={7} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No pending approvals</td></tr>
                : pageRows.map((row) => (
                  <tr key={row.ref}>
                    <td style={{ fontWeight: 700, color: row.refColor, fontFamily: "var(--font)" }}>{row.ref}</td>
                    <td><div style={{ display: "flex", alignItems: "center", gap: 8 }}><RiAv initials={getInitials(row.name)} color={nameColor(row.name)} size={26} />{row.name || "—"}</div></td>
                    <td><span className="cat-tag">{row.type}</span></td>
                    <td style={{ fontWeight: 700 }}>{row.amt}</td>
                    <td><span style={{ color: "var(--text3)", fontFamily: "var(--font2)", fontSize: 12 }}>{row.wait}</span></td>
                    <td><Pill variant={row.level}>{row.levelLabel}</Pill></td>
                    <td><div className="tbl-actions">
                      <button className="btn btn-sm btn-danger" onClick={() => onModal("reject", row.ref)}>Reject</button>
                      <button className="btn btn-sm" onClick={() => onModal("view-info", row.ref)}>View</button>
                      <button className="btn btn-sm btn-success" onClick={() => onModal("approve", row.ref)}>Approve</button>
                      {row.receiptBase64 && <button className="btn-icon" title="View Receipt" onClick={() => onModal("view-receipt", row.ref)}><Mi icon="attach_file" style={{ fontSize: 15 }} /></button>}
                    </div></td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <Pager page={page} total={all.length} onChange={setPage} label="approvals" />
      </div>
    </>
  );
}

/* ─── Page: Reimbursements ───────────────────────────────── */
function ReimbursementsPage({ onModal, allExpenses, onRefresh }) {
  const [page, setPage] = useState(1);
  const [histPage, setHistPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const pending = (allExpenses || []).filter(e => e.status === "Approved");
  const totalPending = pending.reduce((s, e) => s + Number(e.amount || 0), 0);
  const reimbursed = (allExpenses || []).filter(e => e.status === "Reimbursed");
  const totalReimbursed = reimbursed.reduce((s, e) => s + Number(e.amount || 0), 0);
  const pageRows = pending.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
  const histRows = reimbursed.slice((histPage - 1) * PAGE_SIZE, histPage * PAGE_SIZE);

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Reimbursement Queue</div><div className="page-sub">{pending.length} employee{pending.length !== 1 ? "s" : ""} awaiting payment · Total {fmtAmt(totalPending)}</div></div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <select className="form-control" style={{ width: "auto" }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); setPage(1); setHistPage(1); onRefresh(y); }}>
            {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button className="btn btn-primary" onClick={() => onModal("process-all")}><Mi icon="payments" style={{ fontSize: 14 }} />Process All</button>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 13, flexShrink: 0 }}>
        {[
          { icon: "hourglass_top", stripe: "linear-gradient(90deg,#F59E0B,#FCD34D)", iconBg: "#FEF3C7", iconColor: "#92400E", chipBg: "#FEF3C7", chipColor: "#92400E", dot: "#F59E0B", chip: "Pending", val: String(pending.length), lbl: "Awaiting payment", hint: "Employees queued for payout" },
          { icon: "account_balance_wallet", stripe: "linear-gradient(90deg,#F43F5E,#FDA4AF)", iconBg: "#FFF1F2", iconColor: "#9F1239", chipBg: "#FFF1F2", chipColor: "#9F1239", dot: "#F43F5E", chip: "Due", val: fmtAmt(totalPending), lbl: "Total pending", hint: "Unprocessed reimbursements" },
          { icon: "check_circle", stripe: "linear-gradient(90deg,#10B981,#6EE7B7)", iconBg: "#ECFDF5", iconColor: "#065F46", chipBg: "#ECFDF5", chipColor: "#065F46", dot: "#10B981", chip: "Settled", val: fmtAmt(totalReimbursed), lbl: "Total reimbursed", hint: "Paid out this year" },
          { icon: "receipt_long", stripe: "linear-gradient(90deg,#6366F1,#A5B4FC)", iconBg: "#EEF2FF", iconColor: "#3730A3", chipBg: "#EEF2FF", chipColor: "#3730A3", dot: "#6366F1", chip: "Done", val: String(reimbursed.length), lbl: "Transactions done", hint: "Disbursements completed" },
        ].map((k) => (
          <div key={k.lbl} style={{ background: "var(--surface)", border: "0.5px solid var(--border)", borderRadius: 16, overflow: "hidden", position: "relative", display: "flex", flexDirection: "column" }}>
            <div style={{ height: 5, background: k.stripe }} />
            <div style={{ padding: "16px 18px 18px", flex: 1, display: "flex", flexDirection: "column" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
                <div style={{ width: 34, height: 34, borderRadius: 9, background: k.iconBg, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Mi icon={k.icon} style={{ fontSize: 17, color: k.iconColor }} />
                </div>
                <span style={{ fontSize: 10, fontWeight: 600, padding: "3px 9px", borderRadius: 20, letterSpacing: ".3px", background: k.chipBg, color: k.chipColor }}>{k.chip}</span>
              </div>
              {/* Watermark */}
              <div style={{ position: "absolute", bottom: -8, right: -4, fontSize: 72, opacity: .04, lineHeight: 1, pointerEvents: "none", color: "var(--text)" }}>
                <Mi icon={k.icon} style={{ fontSize: 72 }} />
              </div>
              <div style={{ fontSize: 30, fontWeight: 800, lineHeight: 1, letterSpacing: -1.5, color: "var(--text)", marginBottom: 5 }}>{k.val}</div>
              <div style={{ fontSize: 12, color: "var(--text3)" }}>{k.lbl}</div>
              <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 14, paddingTop: 12, borderTop: "1px solid var(--border)" }}>
                <div style={{ width: 6, height: 6, borderRadius: "50%", background: k.dot, flexShrink: 0 }} />
                <span style={{ fontSize: 11, color: "var(--text3)" }}>{k.hint}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="card" style={{ padding: 0 }}>
        <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table>
            <thead><tr><th>Employee</th><th>Ref</th><th>Category</th><th>Amount</th><th>Date</th><th>Action</th></tr></thead>
            <tbody>
              {pending.length === 0
                ? <tr><td colSpan={6} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No pending reimbursements</td></tr>
                : pageRows.map((e) => (
                  <tr key={e.id}>
                    <td><div style={{ display: "flex", alignItems: "center", gap: 8 }}><RiAv initials={getInitials(e.employee)} color={nameColor(e.employee)} size={30} /><div><div style={{ fontWeight: 600 }}>{e.employee || "—"}</div><div style={{ fontSize: 11, color: "var(--text3)", fontFamily: "var(--font2)" }}>{e.dept}</div></div></div></td>
                    <td style={{ fontWeight: 700, color: "var(--accent)", fontFamily: "var(--font)" }}>{e.id}</td>
                    <td><span className="cat-tag">{e.category}</span></td>
                    <td style={{ fontWeight: 800, fontSize: 15 }}>{fmtAmt(e.amount)}</td>
                    <td style={{ fontFamily: "var(--font2)", color: "var(--text3)" }}>{e.date}</td>
                    <td><div className="tbl-actions">
                      <button className="btn btn-sm" onClick={() => onModal("view-info", e.id)}>View</button>
                      <button className="btn btn-sm btn-primary" onClick={() => onModal("reimburse", `${e.employee}|${fmtAmt(e.amount)}|${e.id}`)}>Process</button>
                    </div></td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <Pager page={page} total={pending.length} onChange={setPage} label="reimbursements" />
      </div>

      {/* Reimbursement History */}
      <div className="card" style={{ padding: 0, marginTop: 8 }}>
        <div style={{ padding: "14px 18px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15 }}>Reimbursement History</div>
            <div style={{ fontSize: 12, color: "var(--text3)", marginTop: 2 }}>{reimbursed.length} completed · {fmtAmt(totalReimbursed)} total paid</div>
          </div>
        </div>
        <div className="tbl-wrap" style={{ border: "none" }}>
          <table>
            <thead><tr><th>Employee</th><th>Ref</th><th>Category</th><th>Amount</th><th>Txn Ref</th><th>Date</th><th>Action</th></tr></thead>
            <tbody>
              {reimbursed.length === 0
                ? <tr><td colSpan={7} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No reimbursement history yet</td></tr>
                : histRows.map((e) => (
                  <tr key={e.id}>
                    <td><div style={{ display: "flex", alignItems: "center", gap: 8 }}><RiAv initials={getInitials(e.employee)} color={nameColor(e.employee)} size={30} /><div><div style={{ fontWeight: 600 }}>{e.employee || "—"}</div><div style={{ fontSize: 11, color: "var(--text3)", fontFamily: "var(--font2)" }}>{e.dept}</div></div></div></td>
                    <td style={{ fontWeight: 700, color: "var(--accent)", fontFamily: "var(--font)" }}>{e.id}</td>
                    <td><span className="cat-tag">{e.category}</span></td>
                    <td style={{ fontWeight: 800, fontSize: 15, color: "var(--green)" }}>{fmtAmt(e.amount)}</td>
                    <td style={{ fontFamily: "var(--font2)", fontSize: 12, color: "var(--text3)" }}>{e.transactionRef || "—"}</td>
                    <td style={{ fontFamily: "var(--font2)", color: "var(--text3)" }}>{e.date}</td>
                    <td><div className="tbl-actions">
                      <button className="btn btn-sm" onClick={() => onModal("view-info", e.id)}>View</button>
                      <button className="btn btn-sm btn-primary" onClick={() => downloadSlip(e)}><Mi icon="download" style={{ fontSize: 13 }} />Slip</button>
                    </div></td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <Pager page={histPage} total={reimbursed.length} onChange={setHistPage} label="history" />
      </div>
    </>
  );
}

/* ─── Page: Claims ───────────────────────────────────────── */
function ClaimsPage({ onModal, showToast, allClaims, onRefresh }) {
  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const claims = allClaims || [];
  const pageRows = claims.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
  const actionFor = (c) => {
    if (c.status === "Pending" || c.status === "Pending L2") return "approve-reject";
    if (c.status === "Approved") return "reimburse";
    if (c.status === "Reimbursed") return "slip";
    return "view";
  };
  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Expense Claims</div><div className="page-sub">{claims.length} claim{claims.length !== 1 ? "s" : ""} · {year}</div></div>
        <select className="form-control" style={{ width: "auto" }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); setPage(1); onRefresh(y); }}>
          {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="card" style={{ padding: 0 }}>
        <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table>
            <thead><tr><th>Claim </th><th>Employee</th><th>Period</th><th>Expenses</th><th>Total Amount</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {claims.length === 0
                ? <tr><td colSpan={7} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No claims found</td></tr>
                : pageRows.map((c) => {
                  const action = actionFor(c);
                  return (
                    <tr key={c.id}>
                      <td style={{ fontWeight: 700, color: "var(--accent)", fontFamily: "var(--font)" }}>{c.id}</td>
                      <td><div style={{ display: "flex", alignItems: "center", gap: 8 }}><RiAv initials={getInitials(c.employee || c.title)} color={nameColor(c.employee || c.title)} size={26} />{c.employee || c.title || "—"}</div></td>
                      <td style={{ fontFamily: "var(--font2)" }}>{c.period || "—"}</td>
                      <td style={{ fontFamily: "var(--font2)" }}>{c.items} item{c.items !== 1 ? "s" : ""}</td>
                      <td style={{ fontWeight: 700 }}>{fmtAmt(c.total)}</td>
                      <td><Pill variant={statusVariant(c.status)}>{c.statusLabel || c.status}</Pill></td>
                      <td>
                        <div className="tbl-actions">
                          {action === "approve-reject" && <><button className="btn btn-sm btn-success" onClick={() => onModal("approve", c.id)}>Approve</button><button className="btn btn-sm btn-danger" onClick={() => onModal("reject", c.id)}>Reject</button></>}
                          {action === "reimburse" && <button className="btn btn-sm btn-primary" onClick={() => onModal("reimburse", `${c.employee || c.title}|${fmtAmt(c.total)}|${c.id}`)}>Reimburse</button>}
                          {action === "slip" && <button className="btn btn-sm btn-primary" onClick={() => downloadClaimSlip(c)}><Mi icon="download" style={{ fontSize: 13 }} />Slip</button>}
                          {action === "view" && <button className="btn btn-sm" onClick={() => onModal("view-claim", c.id)}>View</button>}
                        </div>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        <Pager page={page} total={claims.length} onChange={setPage} label="claims" />
      </div>
    </>
  );
}

/* ─── Page: Budgets ──────────────────────────────────────── */
function BudgetsPage({ onModal, showToast, budgets, onRefresh }) {
  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [histBudget, setHistBudget] = useState(null);
  const [histNotes, setHistNotes] = useState([]);
  const [histLoading, setHistLoading] = useState(false);

  const rows = budgets || [];
  const pageRows = rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const openHistory = async (b) => {
    setHistBudget(b);
    setHistNotes([]);
    setHistLoading(true);
    try {
      const token = localStorage.getItem("token");
      // Using the dedicated backend API endpoint for budget amount history
      const res = await fetch(`${API_BASE_URL}/api/budgets/${b.id}/history`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) setHistNotes(await res.json());
    } finally {
      setHistLoading(false);
    }
  };

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Budget Management</div><div className="page-sub">Department budget allocation · {rows.length} entries · {year}</div></div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <select className="form-control" style={{ width: "auto" }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); setPage(1); onRefresh(y); }}>
            {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button className="btn btn-primary" onClick={() => onModal("add-budget")}><Mi icon="add" style={{ fontSize: 14 }} />Add Budget</button>
        </div>
      </div>
      <div className="card" style={{ padding: 0 }}>
        <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table>
            <thead><tr><th>Department</th><th>Category</th><th>Period</th><th>Allocated</th><th>Spent</th><th>Utilization</th><th>Actions</th></tr></thead>
            <tbody>
              {rows.length === 0
                ? <tr><td colSpan={7} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No budgets configured</td></tr>
                : pageRows.map((b) => {
                  const pct = Number(b.allocatedAmount) > 0 ? Math.min(100, Math.round((Number(b.spentAmount || 0) / Number(b.allocatedAmount)) * 100)) : 0;
                  return (
                    <tr key={b.id || b.department}>
                      <td style={{ fontWeight: 600 }}>{b.department}</td>
                      <td><span className="cat-tag">{b.category || "Overall"}</span></td>
                      <td style={{ fontFamily: "var(--font2)" }}>{b.period || "—"}</td>
                      <td style={{ fontWeight: 700 }}>{fmtAmt(b.allocatedAmount)}</td>
                      <td style={{ fontWeight: 700, color: budgetTextCls(pct) }}>{fmtAmt(b.spentAmount)}</td>
                      <td>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <div className="prog-wrap" style={{ flex: 1, marginTop: 0 }}><div className={`prog-fill ${budgetPfCls(pct)}`} style={{ width: `${pct}%` }} /></div>
                          <span style={{ fontSize: 12, fontWeight: 700, color: budgetTextCls(pct), minWidth: 30 }}>{pct}%</span>
                        </div>
                      </td>
                      <td>
                        <div className="tbl-actions">
                          {/* <button className="btn btn-sm" onClick={() => onModal("add-budget", b)}>Edit</button> */}
                          <button className="btn btn-sm" style={{ background: "var(--accent-light)", color: "var(--accent)" }} onClick={() => openHistory(b)}>
                            <Mi icon="history" style={{ fontSize: 13, verticalAlign: "middle" }} /> History
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        <Pager page={page} total={rows.length} onChange={setPage} label="budgets" />
      </div>

      {/* Budget History Modal */}
      {histBudget && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 5000, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => setHistBudget(null)}>
          <div style={{ background: "var(--surface)", borderRadius: 16, width: 700, maxHeight: "85vh", display: "flex", flexDirection: "column", boxShadow: "0 8px 40px rgba(0,0,0,0.2)", overflow: "hidden" }} onClick={e => e.stopPropagation()}>


            {/* Header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "20px 24px", borderBottom: "1px solid var(--border)", flexShrink: 0 }}>
              <div>
                <div style={{ fontSize: 16, fontWeight: 800, color: "var(--text)" }}>Budget History</div>
                <div style={{ fontSize: 12, color: "var(--text3)", fontFamily: "var(--font2)", marginTop: 3 }}>
                  {histBudget.department} · {histBudget.category || "Overall"} · {histBudget.period}
                </div>
              </div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => { setHistBudget(null); onModal("add-budget", histBudget); }}
                >
                  <Mi icon="edit" style={{ fontSize: 13 }} /> Edit
                </button>
                <button className="btn btn-sm" style={{ padding: "2px 10px" }} onClick={() => setHistBudget(null)}>✕</button>
              </div>
            </div>

            {/* Summary strip */}
            {!histLoading && histNotes.length > 0 && (() => {
              const updates = histNotes.filter(n => n.action === "UPDATED" && n.fieldName === "allocatedAmount");
              const netChange = updates.reduce((s, n) => s + (parseFloat(n.newValue) - parseFloat(n.oldValue)), 0);
              return (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12, padding: "14px 24px", borderBottom: "1px solid var(--border)", flexShrink: 0 }}>
                  {[
                    ["Current Allocated", fmtAmt(histBudget.allocatedAmount), "var(--text)"],
                    ["Total Changes", `${histNotes.length} event${histNotes.length !== 1 ? "s" : ""}`, "var(--text)"],
                    ["Net Change", `${netChange >= 0 ? "+" : ""}${fmtAmt(netChange)}`, netChange >= 0 ? "var(--green)" : "var(--red)"],
                  ].map(([label, val, color]) => (
                    <div key={label} style={{ background: "var(--surface2)", borderRadius: 8, padding: "10px 14px" }}>
                      <div style={{ fontSize: 11, color: "var(--text3)", marginBottom: 4 }}>{label}</div>
                      <div style={{ fontSize: 17, fontWeight: 700, color }}>{val}</div>
                    </div>
                  ))}
                </div>
              );
            })()}

            {/* Table */}
            <div style={{ overflowY: "auto", flex: 1 }}>
              {histLoading ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "52px 24px", gap: 16 }}>
                  <div style={{ position: "relative", width: 44, height: 44 }}>
                    <div style={{ width: 44, height: 44, borderRadius: "50%", border: "3px solid var(--border2)", borderTopColor: "var(--accent)", animation: "adm-spin .65s linear infinite" }} />
                    <div style={{ position: "absolute", inset: 8, borderRadius: "50%", background: "var(--accent-light)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <Mi icon="history" style={{ fontSize: 13, color: "var(--accent)" }} />
                    </div>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text)", marginBottom: 4 }}>Fetching history</div>
                    <div style={{ fontSize: 12, color: "var(--text3)", fontFamily: "var(--font2)" }}>Loading budget change records…</div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 8, width: "100%", maxWidth: 480, marginTop: 8 }}>
                    {[100, 85, 70, 90].map((w, i) => (
                      <div key={i} style={{ display: "flex", gap: 12, alignItems: "center" }}>
                        <div style={{ width: 72, height: 10, borderRadius: 6, background: "var(--border)", opacity: .6, animation: `adm-spin ${1 + i * .15}s linear infinite` }} />
                        <div style={{ width: `${w}%`, height: 10, borderRadius: 6, background: "var(--border)", opacity: .4 }} />
                        <div style={{ width: 48, height: 10, borderRadius: 6, background: "var(--border)", opacity: .5, flexShrink: 0 }} />
                      </div>
                    ))}
                  </div>
                </div>
              ) : histNotes.length === 0 ? (
                <div style={{ textAlign: "center", padding: 48, color: "var(--text3)" }}>No amount Allocation history available</div>
              ) : (
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13, fontFamily: "var(--font2)" }}>
                  <thead>
                    <tr style={{ background: "var(--surface2)", position: "sticky", top: 0, zIndex: 1 }}>
                      {["Date & Time", "Event", "Old Amount", "New Amount", "Change", "Changed By"].map(h => (
                        <th key={h} style={{ padding: "9px 16px", textAlign: h === "Old Amount" || h === "New Amount" || h === "Change" ? "right" : "left", fontSize: 11, fontWeight: 700, color: "var(--text2)", textTransform: "uppercase", letterSpacing: ".5px", borderBottom: "1px solid var(--border)", whiteSpace: "nowrap" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {histNotes.map((n, i) => {
                      const isCreated = n.action === "CREATED";
                      const isAmtUpdate = n.action === "UPDATED" && n.fieldName === "allocatedAmount";
                      const diff = isAmtUpdate && n.oldValue != null && n.newValue != null
                        ? parseFloat(n.newValue) - parseFloat(n.oldValue) : null;

                      let badgeBg, badgeColor, badgeIcon, badgeLabel;
                      if (isCreated) {
                        badgeBg = "var(--accent-light)"; badgeColor = "var(--accent)";
                        badgeIcon = "add_circle"; badgeLabel = "Created";
                      } else if (isAmtUpdate && diff >= 0) {
                        badgeBg = "var(--green-bg)"; badgeColor = "var(--green)";
                        badgeIcon = "trending_up"; badgeLabel = "Increased";
                      } else if (isAmtUpdate && diff < 0) {
                        badgeBg = "var(--red-bg)"; badgeColor = "var(--red)";
                        badgeIcon = "trending_down"; badgeLabel = "Decreased";
                      } else {
                        badgeBg = "var(--surface2)"; badgeColor = "var(--text2)";
                        badgeIcon = "edit"; badgeLabel = "Updated";
                      }

                      const ts = n.changedAt
                        ? new Date(n.changedAt).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }).split(", ")
                        : ["—", ""];

                      return (
                        <tr key={n.id} style={{ borderBottom: "1px solid var(--border)" }}>
                          <td style={{ padding: "12px 16px", whiteSpace: "nowrap" }}>
                            <div style={{ fontSize: 12, color: "var(--text)" }}>{ts[0]}</div>
                            <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 2 }}>{ts[1]}</div>
                          </td>
                          <td style={{ padding: "12px 16px" }}>
                            <span style={{ display: "inline-flex", alignItems: "center", gap: 5, background: badgeBg, color: badgeColor, fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20 }}>
                              <Mi icon={badgeIcon} style={{ fontSize: 13 }} />{badgeLabel}
                            </span>
                          </td>
                          <td style={{ padding: "12px 16px", textAlign: "right", fontFamily: "var(--font)", fontSize: 12, color: "var(--text3)", textDecoration: isAmtUpdate ? "line-through" : "none" }}>
                            {isAmtUpdate && n.oldValue != null ? fmtAmt(n.oldValue) : "—"}
                          </td>
                          <td style={{ padding: "12px 16px", textAlign: "right", fontFamily: "var(--font)", fontSize: 12, fontWeight: 700, color: "var(--text)" }}>
                            {isCreated ? fmtAmt(histBudget.allocatedAmount) : isAmtUpdate && n.newValue != null ? fmtAmt(n.newValue) : "—"}
                          </td>
                          <td style={{ padding: "12px 16px", textAlign: "right" }}>
                            {diff !== null ? (
                              <span style={{ fontWeight: 700, fontSize: 12, color: diff >= 0 ? "var(--green)" : "var(--red)" }}>
                                {diff >= 0 ? "+" : "−"}{fmtAmt(Math.abs(diff))}
                              </span>
                            ) : isCreated ? (
                              <span style={{ fontSize: 12, color: "var(--text3)" }}>Initial</span>
                            ) : "—"}
                          </td>
                          <td style={{ padding: "12px 16px", fontSize: 12, color: "var(--text)" }}>{n.changedBy || "—"}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>

            {/* Footer */}
            <div style={{ padding: "14px 24px", borderTop: "1px solid var(--border)", display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
              <button className="btn btn-sm" onClick={() => setHistBudget(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

/* ─── Page: Categories ───────────────────────────────────── */
function CategoriesPage({ onModal, showToast, expenseCategories, onRefresh }) {
  const [page, setPage] = useState(1);
  const rows = expenseCategories || [];
  const pageRows = rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const toggleActive = async (c) => {
    const token = localStorage.getItem("token");
    const h = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
    try {
      let res;
      if (c.active) {
        res = await fetch(`${API_BASE_URL}/api/expense-categories/${c.id}`, { method: "DELETE", headers: h });
      } else {
        res = await fetch(`${API_BASE_URL}/api/expense-categories/${c.id}`, {
          method: "PUT", headers: h,
          body: JSON.stringify({ name: c.name, active: true }),
        });
      }
      if (res.ok) {
        showToast(c.active ? "Category deactivated" : "Category activated", c.active ? "t-amber" : "t-success");
        if (onRefresh) onRefresh();
      } else {
        showToast("Failed to update category", "t-error");
      }
    } catch { showToast("Network error", "t-error"); }
  };

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Expense Categories</div><div className="page-sub">Employee expense category master · {rows.length} categories</div></div>
        <button className="btn btn-primary" onClick={() => onModal("add-category")}><Mi icon="add" style={{ fontSize: 14 }} />Add Category</button>
      </div>
      <div className="card" style={{ padding: 0 }}>
        <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table>
            <thead><tr><th>Sr.no</th><th>Category Name</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {rows.length === 0
                ? <tr><td colSpan={4} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No categories configured</td></tr>
                : pageRows.map((c, i) => (
                  <tr key={c.id || c.name}>
                    <td style={{ color: "var(--text3)", fontFamily: "var(--font2)" }}>{(page - 1) * PAGE_SIZE + i + 1}</td>
                    <td style={{ fontWeight: 600 }}>{c.name}</td>
                    <td><Pill variant={c.active ? "p-approved" : "p-rejected"}>{c.active ? "Active" : "Inactive"}</Pill></td>
                    <td>
                      <div className="tbl-actions">
                        <button className="btn btn-sm" onClick={() => onModal("add-category", c)}>Edit</button>
                        {c.active
                          ? <button className="btn btn-sm btn-danger" onClick={() => toggleActive(c)}>Deactivate</button>
                          : <button className="btn btn-sm btn-success" onClick={() => toggleActive(c)}>Activate</button>}
                      </div>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <Pager page={page} total={rows.length} onChange={setPage} label="categories" />
      </div>
    </>
  );
}

/* ─── Page: Internal Expenses ───────────────────────────── */
function InternalExpensesPage({ onModal, showToast, internalExpenses, intCategories, onRefresh }) {
  const [activeTab, setActiveTab] = useState("expenses");
  const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState("All");
  const [filterStatus, setFilterStatus] = useState("All");
  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());

  /* ── Access-control state ── */
  const [permissions, setPermissions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [permsLoaded, setPermsLoaded] = useState(false);
  const [showGrantModal, setShowGrantModal] = useState(false);
  const [editingPerm, setEditingPerm] = useState(null);
  const [grantForm, setGrantForm] = useState({ employeeId: "", allowedTypes: [], allowedCategoryIds: [] });

  const loadPermissions = async () => {
    const token = localStorage.getItem("token");
    const h = { Authorization: `Bearer ${token}` };
    const [pr, er] = await Promise.all([
      fetch(`${API_BASE_URL}/api/employee-internal-permissions`, { headers: h }),
      fetch(`${API_BASE_URL}/api/employees/active`, { headers: h }),
    ]);
    if (pr.ok) setPermissions(await pr.json());
    if (er.ok) { const d = await er.json(); setEmployees(Array.isArray(d) ? d : d.content || []); }
    setPermsLoaded(true);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "access-control" && !permsLoaded) loadPermissions();
  };

  const openGrant = (perm) => {
    if (perm) {
      setEditingPerm(perm);
      setGrantForm({
        employeeId: String(perm.employeeId),
        allowedTypes: perm.allowedTypes ? perm.allowedTypes.split(",").map(s => s.trim()).filter(Boolean) : [],
        allowedCategoryIds: perm.allowedCategoryIds ? perm.allowedCategoryIds.split(",").map(s => s.trim()).filter(Boolean) : [],
      });
    } else {
      setEditingPerm(null);
      setGrantForm({ employeeId: "", allowedTypes: [], allowedCategoryIds: [] });
    }
    setShowGrantModal(true);
  };

  const handleGrantSubmit = async () => {
    if (!grantForm.employeeId) { showToast("Select an employee", "error"); return; }
    if (grantForm.allowedTypes.length === 0) { showToast("Select at least one type", "error"); return; }
    const token = localStorage.getItem("token");
    const emp = employees.find(e => String(e.id) === String(grantForm.employeeId));
    const body = {
      employeeId: Number(grantForm.employeeId),
      employeeName: emp ? `${emp.firstName || ""} ${emp.lastName || ""}`.trim() : "",
      employeeEmail: emp?.email || "",
      allowedTypes: grantForm.allowedTypes.join(","),
      allowedCategoryIds: grantForm.allowedCategoryIds.join(","),
    };
    const url = editingPerm
      ? `${API_BASE_URL}/api/employee-internal-permissions/${editingPerm.id}`
      : `${API_BASE_URL}/api/employee-internal-permissions`;
    const r = await fetch(url, {
      method: editingPerm ? "PUT" : "POST",
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (r.ok) {
      showToast(editingPerm ? "Permission updated" : "Access granted", "success");
      setShowGrantModal(false);
      loadPermissions();
    } else { showToast(await r.text() || "Failed", "error"); }
  };

  const handleToggle = async (perm) => {
    const token = localStorage.getItem("token");
    await fetch(`${API_BASE_URL}/api/employee-internal-permissions/${perm.id}/toggle`, { method: "PATCH", headers: { Authorization: `Bearer ${token}` } });
    loadPermissions();
  };

  const handleRevoke = async (perm) => {
    if (!window.confirm(`Revoke access for ${perm.employeeName}?`)) return;
    const token = localStorage.getItem("token");
    const r = await fetch(`${API_BASE_URL}/api/employee-internal-permissions/${perm.id}`, { method: "DELETE", headers: { Authorization: `Bearer ${token}` } });
    if (r.ok) { showToast("Access revoked", "success"); loadPermissions(); }
  };

  const toggleType = (t) => setGrantForm(f => {
    const removing = f.allowedTypes.includes(t);
    const newTypes = removing ? f.allowedTypes.filter(x => x !== t) : [...f.allowedTypes, t];
    // when removing a type, also drop its categories; when adding, keep existing selections
    const removedCatIds = removing
      ? new Set((intCategories || []).filter(c => c.type === t).map(c => String(c.id)))
      : null;
    return {
      ...f,
      allowedTypes: newTypes,
      allowedCategoryIds: removing
        ? f.allowedCategoryIds.filter(id => !removedCatIds.has(id))
        : f.allowedCategoryIds,
    };
  });
  const toggleCat = (id) => setGrantForm(f => ({ ...f, allowedCategoryIds: f.allowedCategoryIds.includes(String(id)) ? f.allowedCategoryIds.filter(x => x !== String(id)) : [...f.allowedCategoryIds, String(id)] }));

  const allTypes = [...new Set((intCategories || []).map(c => c.type).filter(Boolean))].sort();
  const filteredCatsForGrant = (intCategories || []).filter(c => grantForm.allowedTypes.includes(c.type));

  /* ── Expenses tab ── */
  const rows = (internalExpenses || []).filter(e => {
    const q = search.toLowerCase();
    const matchSearch = !q || (e.internalId || "").toLowerCase().includes(q) || (e.title || "").toLowerCase().includes(q) || (e.vendor || "").toLowerCase().includes(q);
    const matchType = filterType === "All" || e.type === filterType;
    const matchStatus = filterStatus === "All" || e.status === filterStatus;
    return matchSearch && matchType && matchStatus;
  });
  const pageRows = rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const actionFor = (e) => {
    if (e.status === "Pending") return "approve-reject";
    if (e.status === "Paid") return "receipt";
    if (e.status === "Overdue" || e.status === "Approved") return "mark-paid";
    return "view";
  };

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Internal Expenses</div><div className="page-sub">Company operational spend</div></div>
        <div style={{ display: "flex", gap: 8 }}>
          {activeTab === "expenses" && <button className="btn btn-primary" onClick={() => onModal("new-internal")}><Mi icon="add" style={{ fontSize: 14 }} />New Internal Expense</button>}
          {activeTab === "access-control" && <button className="btn btn-primary" onClick={() => openGrant(null)}><Mi icon="person_add" style={{ fontSize: 14 }} />Grant Access</button>}
        </div>
      </div>

      {/* Tab bar */}
      <div style={{ display: "flex", gap: 4, borderBottom: "1px solid var(--border)", marginBottom: 4 }}>
        {[{ key: "expenses", label: "Expenses" }, { key: "access-control", label: "Manage Access" }].map(tab => (
          <button key={tab.key} onClick={() => handleTabChange(tab.key)} style={{ padding: "8px 18px", border: "none", background: "none", cursor: "pointer", fontSize: 13, fontFamily: "var(--font)", fontWeight: activeTab === tab.key ? 700 : 400, color: activeTab === tab.key ? "var(--accent)" : "var(--text2)", borderBottom: activeTab === tab.key ? "2px solid var(--accent)" : "2px solid transparent", marginBottom: -1 }}>{tab.label}</button>
        ))}
      </div>

      {/* ── Expenses tab ── */}
      {activeTab === "expenses" && <>
        <div className="filter-row">
          <div className="search-bar"><Mi icon="search" /><input type="text" placeholder="Search internal expenses..." value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} /></div>
          <select className="form-control" style={{ width: "auto" }} value={filterType} onChange={e => { setFilterType(e.target.value); setPage(1); }}>
            <option value="All">All Types</option>
            {allTypes.map(t => <option key={t} value={t}>{t.charAt(0) + t.slice(1).toLowerCase()}</option>)}
          </select>
          <select className="form-control" style={{ width: "auto" }} value={filterStatus} onChange={e => { setFilterStatus(e.target.value); setPage(1); }}>
            <option value="All">All Status</option>
            {["Draft", "Pending", "Approved", "Paid", "Overdue"].map(s => <option key={s}>{s}</option>)}
          </select>
          <select className="form-control" style={{ width: "auto" }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); setPage(1); onRefresh(y); }}>
            {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button className="btn" onClick={() => { setSearch(""); setFilterType("All"); setFilterStatus("All"); setPage(1); }}>Clear</button>
        </div>
        <div className="card" style={{ padding: 0 }}>
          <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
            <table>
              <thead><tr><th>Ref</th><th>Title</th><th>Type</th><th>Employee</th><th>Vendor</th><th>Amount</th><th>Bill Month</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {rows.length === 0
                  ? <tr><td colSpan={9} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No internal expenses found</td></tr>
                  : pageRows.map((e) => {
                    const action = actionFor(e);
                    return (
                      <tr key={e.internalId}>
                        <td style={{ fontWeight: 700, color: e.status === "Overdue" ? "var(--red)" : "var(--violet)", fontFamily: "var(--font)" }}>{e.internalId}</td>
                        <td className="td-wrap" style={{ fontWeight: 600 }}>{e.title}</td>
                        <td><span className="cat-tag">{e.type ? e.type.charAt(0) + e.type.slice(1).toLowerCase() : "—"}</span></td>
                        <td style={{ fontFamily: "var(--font2)", fontSize: 12 }}>{e.forEmployeeName || <span style={{ color: "var(--text3)" }}>Company</span>}</td>
                        <td style={{ fontFamily: "var(--font2)" }}>{e.vendor || "—"}</td>
                        <td style={{ fontWeight: 700 }}>{fmtAmt(e.amount)}</td>
                        <td style={{ fontFamily: "var(--font2)" }}>{e.billMonth || "—"}</td>
                        <td><Pill variant={statusVariant(e.status)}>{e.status}</Pill></td>
                        <td>
                          <div className="tbl-actions">
                            {action === "approve-reject" && <><button className="btn btn-sm btn-success" onClick={() => onModal("approve", e.internalId)}>Approve</button><button className="btn btn-sm btn-danger" onClick={() => onModal("reject", e.internalId)}>Reject</button></>}
                            {action === "receipt" && <button className="btn btn-sm" onClick={() => onModal("view-int-slip", e.internalId)}>Receipt</button>}
                            {action === "mark-paid" && <button className="btn btn-sm btn-primary" onClick={() => onModal("mark-paid", e.internalId)}>Mark Paid</button>}
                            {action === "view" && <button className="btn btn-sm" onClick={() => { }}>View</button>}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
          <Pager page={page} total={rows.length} onChange={setPage} label="records" />
        </div>
      </>}

      {/* ── Access Control tab ── */}
      {activeTab === "access-control" && <>
        <div className="card" style={{ padding: 0 }}>
          <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
            <table>
              <thead><tr><th>Employee</th><th>Allowed Types</th><th>Categories</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {!permsLoaded
                  ? <tr><td colSpan={5} style={{ textAlign: "center", padding: 40 }}><div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }}><div className="adm-spinner" style={{ width: 28, height: 28 }} /><span style={{ fontSize: 13, color: "var(--text3)" }}>Loading permissions...</span></div></td></tr>
                  : permissions.length === 0
                    ? <tr><td colSpan={5} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No access permissions granted yet</td></tr>
                    : permissions.map(p => (
                      <tr key={p.id}>
                        <td>
                          <div style={{ fontWeight: 600, fontSize: 13 }}>{p.employeeName || "—"}</div>
                        </td>
                        <td>
                          <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                            {(p.allowedTypes || "").split(",").filter(Boolean).map(t => (
                              <span key={t} className="cat-tag" style={{ fontSize: 11 }}>{t.charAt(0) + t.slice(1).toLowerCase()}</span>
                            ))}
                          </div>
                        </td>
                        <td style={{ fontSize: 12, color: "var(--text2)", fontFamily: "var(--font2)" }}>
                          {p.allowedCategoryIds ? `${p.allowedCategoryIds.split(",").filter(Boolean).length} categories` : "All"}
                        </td>
                        <td><Pill variant={p.active ? "success" : "default"}>{p.active ? "Active" : "Revoked"}</Pill></td>
                        <td>
                          <div className="tbl-actions">
                            <button className="btn btn-sm" onClick={() => openGrant(p)}>Edit</button>
                            <button className="btn btn-sm btn-amber" onClick={() => handleToggle(p)}>{p.active ? "Disable" : "Enable"}</button>
                            <button className="btn btn-sm btn-danger" onClick={() => handleRevoke(p)}>Revoke</button>
                          </div>
                        </td>
                      </tr>
                    ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </>}

      {/* ── Grant / Edit Access Modal ── */}
      {showGrantModal && (
        <div className="modal-overlay" onClick={() => setShowGrantModal(false)}>
          <div className="modal" style={{ maxWidth: 560, minHeight: 560, maxHeight: "88vh", display: "flex", flexDirection: "column" }} onClick={e => e.stopPropagation()}>
            <div className="modal-head">
              <span className="modal-title">{editingPerm ? "Edit Access" : "Grant Internal Expense Access"}</span>
              <button className="btn-ghost" onClick={() => setShowGrantModal(false)}><Mi icon="close" /></button>
            </div>
            <div className="modal-body" style={{ display: "flex", flexDirection: "column", gap: 16, overflowY: "auto", flex: 1 }}>
              {/* Note */}
              <div style={{ display: "flex", alignItems: "flex-start", gap: 8, background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#1d4ed8" }}>
                <Mi icon="info" style={{ fontSize: 16, marginTop: 1 }} />
                <span>This access can only be granted to employees with the <strong>User</strong> role. No Managers — select employee properly.</span>
              </div>
              {/* Employee */}
              {!editingPerm && (
                <ModalFG label="Employee *">
                  <EmployeeDropdown
                    employees={employees.filter(e => !permissions.some(p => String(p.employeeId) === String(e.id || e.employeeId)))}
                    value={grantForm.employeeId}
                    onChange={val => setGrantForm(f => ({ ...f, employeeId: String(val) }))}
                  />
                </ModalFG>
              )}
              {editingPerm && (
                <div style={{ background: "var(--surface2)", borderRadius: 8, padding: "10px 14px", fontSize: 13 }}>
                  <span style={{ fontWeight: 600 }}>{editingPerm.employeeName}</span>
                </div>
              )}

              {/* Allowed Types */}
              <div className="form-group">
                <label className="form-label">Allowed Types <span style={{ color: "var(--red)" }}>*</span></label>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {allTypes.map(t => (
                    <label key={t} style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 13, background: grantForm.allowedTypes.includes(t) ? "var(--accent-light)" : "var(--surface2)", border: `1px solid ${grantForm.allowedTypes.includes(t) ? "var(--accent-mid)" : "var(--border)"}`, borderRadius: 7, padding: "5px 12px" }}>
                      <input type="checkbox" checked={grantForm.allowedTypes.includes(t)} onChange={() => toggleType(t)} style={{ accentColor: "var(--accent)" }} />
                      {t.charAt(0) + t.slice(1).toLowerCase()}
                    </label>
                  ))}
                  {allTypes.length === 0 && <span style={{ color: "var(--text3)", fontSize: 13 }}>No types found — add Internal Categories first</span>}
                </div>
              </div>

              {/* Allowed Categories (filtered by selected types) */}
              {filteredCatsForGrant.length > 0 && (
                <div className="form-group">
                  <label className="form-label">Allowed Categories <span style={{ color: "var(--text3)", fontWeight: 400 }}>(leave all unchecked = all categories allowed)</span></label>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {filteredCatsForGrant.map(c => (
                      <label key={c.id} style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 13, background: grantForm.allowedCategoryIds.includes(String(c.id)) ? "var(--violet-bg)" : "var(--surface2)", border: `1px solid ${grantForm.allowedCategoryIds.includes(String(c.id)) ? "var(--violet-bd)" : "var(--border)"}`, borderRadius: 7, padding: "5px 12px" }}>
                        <input type="checkbox" checked={grantForm.allowedCategoryIds.includes(String(c.id))} onChange={() => toggleCat(c.id)} style={{ accentColor: "var(--violet)" }} />
                        {c.name} <span style={{ color: "var(--text3)", fontSize: 11 }}>({c.type})</span>
                      </label>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="modal-foot">
              <button className="btn" onClick={() => setShowGrantModal(false)}>Cancel</button>
              <button className="btn btn-primary" onClick={handleGrantSubmit}>{editingPerm ? "Save Changes" : "Grant Access"}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

/* ─── Page: Utility Bills ────────────────────────────────── */
function UtilityBillsPage({ onModal, showToast, internalExpenses, onRefresh }) {
  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const utils = (internalExpenses || []).filter(e => e.type === "UTILITY");
  const pageRows = utils.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
  const today = new Date();
  const weekEnd = new Date(today); weekEnd.setDate(weekEnd.getDate() + 7);

  const overdueList = utils.filter(e => e.status === "Overdue");
  const overdueAmt = overdueList.reduce((s, e) => s + Number(e.amount || 0), 0);
  const dueThisWeek = utils.filter(e => {
    if (!e.dueDate || e.status === "Paid") return false;
    const d = new Date(e.dueDate);
    return d >= today && d <= weekEnd;
  });
  const dueThisWeekAmt = dueThisWeek.reduce((s, e) => s + Number(e.amount || 0), 0);
  const currMonth = today.toISOString().slice(0, 7);
  const paidThisMonth = utils.filter(e => e.status === "Paid" && e.paidDate && e.paidDate.slice(0, 7) === currMonth);
  const paidAmt = paidThisMonth.reduce((s, e) => s + Number(e.amount || 0), 0);

  const TYPE_ICON = { ELECTRICITY: { icon: "bolt", color: "var(--amber)" }, INTERNET: { icon: "wifi", color: "var(--cyan)" }, WATER: { icon: "water_drop", color: "#0369A1" }, GAS: { icon: "local_fire_department", color: "var(--orange)" }, PHONE: { icon: "phone", color: "#0369A1" } };
  const utilIcon = (cat) => TYPE_ICON[(cat || "").toUpperCase()] || { icon: "electric_bolt", color: "var(--text3)" };

  const actionFor = (e) => {
    if (e.status === "Overdue" || e.status === "Approved") return "mark-paid";
    if (e.status === "Pending") return "approve";
    if (e.status === "Paid") return "receipt";
    return "view";
  };

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Utility Bills</div><div className="page-sub">Track electricity, water, internet and gas bills · {utils.length} record{utils.length !== 1 ? "s" : ""}</div></div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <select className="form-control" style={{ width: "auto" }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); setPage(1); onRefresh(y); }}>
            {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button className="btn btn-primary" onClick={() => onModal("add-utility")}><Mi icon="add" style={{ fontSize: 14 }} />Add Utility Bill</button>
        </div>
      </div>
      <div className="kpi-grid" style={{ gridTemplateColumns: "repeat(3,1fr)" }}>
        <div className="kpi kpi-red"><div className="kpi-top"><span className="kpi-label">Overdue Bills</span><div className="kpi-icon ki-red"><Mi icon="warning" /></div></div><div className="kpi-val">{overdueList.length}</div><div className="kpi-trend">{fmtAmt(overdueAmt)} at risk</div></div>
        <div className="kpi kpi-amber"><div className="kpi-top"><span className="kpi-label">Due This Week</span><div className="kpi-icon ki-amber"><Mi icon="schedule" /></div></div><div className="kpi-val">{dueThisWeek.length}</div><div className="kpi-trend">{fmtAmt(dueThisWeekAmt)} due soon</div></div>
        <div className="kpi kpi-green"><div className="kpi-top"><span className="kpi-label">Paid This Month</span><div className="kpi-icon ki-green"><Mi icon="check_circle" /></div></div><div className="kpi-val">{fmtAmt(paidAmt)}</div><div className="kpi-trend">{paidThisMonth.length} bill{paidThisMonth.length !== 1 ? "s" : ""} settled</div></div>
      </div>
      <div className="card" style={{ padding: 0 }}>
        <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table>
            <thead><tr><th>Type</th><th>Provider</th><th>Period</th><th>Amount</th><th>Due Date</th><th>Status</th><th>Action</th></tr></thead>
            <tbody>
              {utils.length === 0
                ? <tr><td colSpan={7} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No utility bills found</td></tr>
                : pageRows.map((e) => {
                  const action = actionFor(e);
                  const { icon, color } = utilIcon(e.category);
                  const duePast = e.dueDate && new Date(e.dueDate) < today && e.status !== "Paid";
                  return (
                    <tr key={e.internalId}>
                      <td><div style={{ display: "flex", alignItems: "center", gap: 8 }}><Mi icon={icon} style={{ fontSize: 18, color }} />{e.category || e.title || "Utility"}</div></td>
                      <td style={{ fontFamily: "var(--font2)" }}>{e.vendor || "—"}</td>
                      <td style={{ fontFamily: "var(--font2)" }}>{e.billMonth || "—"}</td>
                      <td style={{ fontWeight: 700 }}>{fmtAmt(e.amount)}</td>
                      <td style={{ color: duePast ? "var(--red)" : e.status === "Paid" ? "var(--text3)" : "var(--amber)", fontFamily: "var(--font2)" }}>{fmtDate(e.dueDate)}</td>
                      <td><Pill variant={statusVariant(e.status)}>{e.status}</Pill></td>
                      <td>
                        <div className="tbl-actions">
                          {action === "mark-paid" && <button className="btn btn-sm btn-primary" onClick={() => onModal("mark-paid", e.internalId)}>Mark Paid</button>}
                          {action === "approve" && <button className="btn btn-sm btn-success" onClick={() => onModal("approve", e.internalId)}>Approve</button>}
                          {action === "receipt" && <button className="btn btn-sm" onClick={() => onModal("view-int-slip", e.internalId)}>Receipt</button>}
                          {action === "view" && <button className="btn btn-sm" onClick={() => { }}>View</button>}
                        </div>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        <Pager page={page} total={utils.length} onChange={setPage} label="bills" />
      </div>
    </>
  );
}

/* ─── Page: Grocery ─────────────────────────────────────── */
function GroceryPage({ onModal, internalExpenses, onRefresh }) {
  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const rows = (internalExpenses || []).filter(e => e.type === "GROCERY");
  const pageRows = rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const actionFor = (e) => {
    if (e.status === "Pending") return "approve";
    if (e.status === "Approved") return "mark-paid";
    return "view";
  };

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Office Grocery</div><div className="page-sub">Office supplies & consumables tracking · {rows.length} record{rows.length !== 1 ? "s" : ""}</div></div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <select className="form-control" style={{ width: "auto" }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); setPage(1); onRefresh(y); }}>
            {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button className="btn btn-primary" onClick={() => onModal("add-grocery")}><Mi icon="add" style={{ fontSize: 14 }} />Add Grocery</button>
        </div>
      </div>
      <div className="card" style={{ padding: 0 }}>
        <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table>
            <thead><tr><th>Ref</th><th>Description</th><th>Vendor</th><th>Amount</th><th>Date</th><th>Paid By</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {rows.length === 0
                ? <tr><td colSpan={8} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No grocery records found</td></tr>
                : pageRows.map((r) => {
                  const action = actionFor(r);
                  return (
                    <tr key={r.internalId}>
                      <td style={{ fontWeight: 700, color: "var(--violet)", fontFamily: "var(--font)" }}>{r.internalId}</td>
                      <td className="td-wrap" style={{ fontWeight: 600 }}>{r.title}</td>
                      <td style={{ fontFamily: "var(--font2)" }}>{r.vendor || "—"}</td>
                      <td style={{ fontWeight: 700 }}>{fmtAmt(r.amount)}</td>
                      <td style={{ fontFamily: "var(--font2)" }}>{fmtDate(r.paidDate || r.dueDate)}</td>
                      <td style={{ fontFamily: "var(--font2)" }}>{r.paidBy || "—"}</td>
                      <td><Pill variant={statusVariant(r.status)}>{r.status}</Pill></td>
                      <td>
                        <div className="tbl-actions">
                          {action === "view" && <button className="btn btn-sm" onClick={() => onModal("view-info", r.internalId)}>View</button>}
                          {action === "approve" && <button className="btn btn-sm btn-success" onClick={() => onModal("approve", r.internalId)}>Approve</button>}
                          {action === "mark-paid" && <button className="btn btn-sm btn-primary" onClick={() => onModal("mark-paid", r.internalId)}>Mark Paid</button>}
                        </div>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        <Pager page={page} total={rows.length} onChange={setPage} label="records" />
      </div>
    </>
  );
}

/* ─── Page: Overdue ─────────────────────────────────────── */
function OverduePage({ onModal, showToast, internalExpenses }) {
  const [page, setPage] = useState(1);
  const rows = (internalExpenses || []).filter(e => e.status === "Overdue");
  const totalAtRisk = rows.reduce((s, e) => s + Number(e.amount || 0), 0);
  const pageRows = rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Overdue Bills</div><div className="page-sub">{rows.length} bill{rows.length !== 1 ? "s" : ""} past due date · {fmtAmt(totalAtRisk)} at risk of late fee</div></div>
        <button className="btn btn-danger" onClick={() => showToast("Escalation emails sent to Finance team", "t-amber")}><Mi icon="mail" style={{ fontSize: 14 }} />Escalate All</button>
      </div>
      {rows.length > 0 && (
        <div className="alert-card ac-red"><Mi icon="error_outline" /><div><div className="ac-title">Immediate Action Required</div><div className="ac-sub">{rows.length} bill{rows.length !== 1 ? "s are" : " is"} overdue. Late fees may be applicable. Please process payment immediately.</div></div></div>
      )}
      <div className="card" style={{ padding: 0 }}>
        <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table>
            <thead><tr><th>Ref</th><th>Bill</th><th>Provider</th><th>Amount</th><th>Due Date</th><th>Overdue By</th><th>Actions</th></tr></thead>
            <tbody>
              {rows.length === 0
                ? <tr><td colSpan={7} style={{ textAlign: "center", padding: 32, color: "var(--green)" }}>No overdue bills — all caught up!</td></tr>
                : pageRows.map((e) => {
                  const days = overdueDays(e.dueDate);
                  return (
                    <tr key={e.internalId}>
                      <td style={{ fontWeight: 700, color: "var(--red)", fontFamily: "var(--font)" }}>{e.internalId}</td>
                      <td className="td-wrap" style={{ fontWeight: 600 }}>{e.title}</td>
                      <td style={{ fontFamily: "var(--font2)" }}>{e.vendor || "—"}</td>
                      <td style={{ fontWeight: 700, color: "var(--red)" }}>{fmtAmt(e.amount)}</td>
                      <td style={{ fontFamily: "var(--font2)", color: "var(--red)" }}>{fmtDate(e.dueDate)}</td>
                      <td><Pill variant="p-overdue">{days > 0 ? `${days} day${days !== 1 ? "s" : ""}` : "Today"}</Pill></td>
                      <td><div className="tbl-actions"><button className="btn btn-sm btn-primary" onClick={() => onModal("mark-paid", e.internalId)}>Mark Paid</button></div></td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        <Pager page={page} total={rows.length} onChange={setPage} label="overdue bills" />
      </div>
    </>
  );
}

/* ─── Page: Petty Cash ───────────────────────────────────── */
function PettyCashPage({ onModal, pettyCash, onRefresh }) {
  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const account = pettyCash?.account || {};
  const transactions = pettyCash?.transactions || [];
  const txPageRows = transactions.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
  const balance = Number(account.balance || 0);
  const maxBal = Number(account.maxBalance || 1);
  const alertLvl = Number(account.alertLevel || 0);
  const balPct = Math.min(100, Math.round((balance / maxBal) * 100));

  const currMonth = new Date().toISOString().slice(0, 7);
  const spentThisMonth = transactions
    .filter(t => t.type === "Debit" && (t.transactionDate || "").slice(0, 7) === currMonth)
    .reduce((s, t) => s + Number(t.amount || 0), 0);
  const lastCredit = transactions.find(t => t.type === "Credit");

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Petty Cash</div><div className="page-sub">{account.name || "Main Office"} account · Custodian: {account.custodian || "—"}</div></div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <select className="form-control" style={{ width: "auto" }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); setPage(1); onRefresh(y); }}>
            {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button className="btn btn-primary" onClick={() => onModal("credit-petty")}><Mi icon="add" style={{ fontSize: 14 }} />Credit Cash</button>
        </div>
      </div>
      <div className="petty-card">
        <div className="petty-account">{account.name || "Main Office Petty Cash"}</div>
        <div className="petty-balance">{fmtAmt(balance)}</div>
        <div className="petty-sub">Low balance alert at {fmtAmt(alertLvl)} · Max {fmtAmt(maxBal)}</div>
        <div className="petty-bar-wrap"><div className="petty-bar-fill" style={{ width: `${balPct}%` }} /></div>
        <div className="petty-meta">
          <div className="petty-meta-item"><div className="pm-val">{fmtAmt(maxBal)}</div><div className="pm-lbl">Max Balance</div></div>
          <div className="petty-meta-item"><div className="pm-val">{fmtAmt(spentThisMonth)}</div><div className="pm-lbl">Spent This Month</div></div>
          <div className="petty-meta-item"><div className="pm-val" style={{ color: "#FCA5A5" }}>{fmtAmt(alertLvl)}</div><div className="pm-lbl">Alert Level</div></div>
          <div className="petty-meta-item"><div className="pm-val">{lastCredit ? fmtAmt(lastCredit.amount) : "—"}</div><div className="pm-lbl">Last Credit</div></div>
        </div>
      </div>
      <div className="card" style={{ padding: 0 }}>
        <div className="card-head" style={{ padding: "14px 18px 0" }}><div className="card-title">Transaction History</div></div>
        <div className="tbl-wrap" style={{ border: "none" }}>
          <table>
            <thead><tr><th>Date</th><th>Type</th><th>Description</th><th>Linked To</th><th>Amount</th><th>Balance After</th><th>By</th></tr></thead>
            <tbody>
              {transactions.length === 0
                ? <tr><td colSpan={7} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No transactions recorded</td></tr>
                : txPageRows.map((t, i) => {
                  const isCredit = t.type === "Credit";
                  return (
                    <tr key={i}>
                      <td style={{ fontFamily: "var(--font2)" }}>{fmtDate(t.transactionDate)}</td>
                      <td><Pill variant={isCredit ? "p-approved" : "p-rejected"}>{t.type}</Pill></td>
                      <td style={{ fontFamily: "var(--font2)" }}>{t.description || "—"}</td>
                      <td style={{ fontFamily: "var(--font)" }}>{t.linkedRef || "—"}</td>
                      <td style={{ fontWeight: 700, color: isCredit ? "var(--green)" : "var(--red)" }}>{isCredit ? "+" : "-"}{fmtAmt(t.amount)}</td>
                      <td style={{ fontWeight: 600 }}>{fmtAmt(t.balanceAfter)}</td>
                      <td style={{ fontFamily: "var(--font2)" }}>{t.performedBy || "—"}</td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        <Pager page={page} total={transactions.length} onChange={setPage} label="transactions" />
      </div>
    </>
  );
}

/* ─── Page: Recurring ────────────────────────────────────── */
/* ─── Page: Int. Categories ──────────────────────────────── */
function IntCategoriesPage({ onModal, showToast, intCategories, onRefresh }) {
  const [page, setPage] = useState(1);
  const cats = intCategories || [];
  const pageRows = cats.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
  const toggleActive = async (id, currentActive) => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/internal-categories/${id}/toggle`, {
        method: "PATCH", headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (res.ok) { showToast(currentActive ? "Category deactivated" : "Category activated", currentActive ? "t-amber" : "t-success"); onRefresh(); }
      else showToast("Failed to update category", "t-error");
    } catch { showToast("Error updating category", "t-error"); }
  };

  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Internal Categories</div><div className="page-sub">Operational expense category master · {(intCategories || []).length} categories</div></div>
        <button className="btn btn-primary" onClick={() => onModal("add-int-category")}><Mi icon="add" style={{ fontSize: 14 }} />Add Category</button>
      </div>
      <div className="card" style={{ padding: 0 }}>
        <div className="tbl-wrap" style={{ border: "none", borderRadius: "var(--radius)" }}>
          <table>
            <thead><tr><th>Name</th><th>Type</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {cats.length === 0
                ? <tr><td colSpan={4} style={{ textAlign: "center", padding: 32, color: "var(--text3)" }}>No internal categories found</td></tr>
                : pageRows.map((c) => (
                  <tr key={c.id || c.code}>
                    <td style={{ fontWeight: 600 }}>{c.name}</td>
                    <td><span className="cat-tag">{c.type ? c.type.charAt(0) + c.type.slice(1).toLowerCase() : "—"}</span></td>
                    <td><Pill variant={c.active ? "p-approved" : "p-rejected"}>{c.active ? "Active" : "Inactive"}</Pill></td>
                    <td>
                      <div className="tbl-actions">
                        <button className="btn btn-sm" onClick={() => onModal("add-int-category", c)}>Edit</button>
                        {c.active
                          ? <button className="btn btn-sm btn-danger" onClick={() => toggleActive(c.id, true)}>Deactivate</button>
                          : <button className="btn btn-sm btn-success" onClick={() => toggleActive(c.id, false)}>Activate</button>}
                      </div>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <Pager page={page} total={cats.length} onChange={setPage} label="categories" />
      </div>
    </>
  );
}

/* ─── Page: Permissions ──────────────────────────────────── */
const PERM_ROWS = [
  ["Submit Own Expenses", true, true, true, true],
  ["View Own Expenses", true, true, true, true],
  ["View Team Expenses", false, true, true, true],
  ["View All Expenses", false, false, true, true],
  ["L1 Approve (Manager)", false, true, false, true],
  ["L2 Approve (HR/Finance)", false, false, true, true],
  ["Reject Expense", false, true, true, true],
  ["Process Reimbursement", false, false, true, true],
  ["Manage Categories", false, false, true, true],
  ["Manage Budgets", false, false, true, true],
  ["Manage Policy", false, false, false, true],
  ["View Reports", false, false, true, true],
  ["Export Reports", false, false, true, true],
  ["Create Internal Expense", false, false, true, true],
  ["Approve Internal Expense", false, false, false, true],
  ["Petty Cash Management", false, false, true, true],
  ["Recurring Schedules", false, false, true, true],
  ["Permissions Config", false, false, false, true],
];

/* ─── Page: System Notes ──────────────────────────────────── */
function SystemNotesPage({ activityLog, onRefresh }) {
  const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterAction, setFilterAction] = useState("");
  const [page, setPage] = useState(1);

  const items = activityLog?.items || [];
  const totalFromServer = activityLog?.total || 0;

  const actionLabel = (n) => {
    if (n.action === "CREATED") {
      if (n.entityType === "CLAIM") return "Claim Created";
      if (n.entityType === "BUDGET") return "Budget Created";
      if (n.entityType === "EXPENSE_CATEGORY") return "Category Created";
      if (n.entityType === "INTERNAL_CATEGORY") return "Int. Category Created";
      if (n.entityType === "INTERNAL_EXPENSE") return "Int. Expense Created";
      if (n.entityType === "INTERNAL_PERMISSION") return "Access Granted";
      return "Submitted";
    }
    if (n.fieldName === "status") {
      const v = n.newValue || "";
      if (v === "Pending L2") return "Manager Approved";
      if (v === "Approved") return "Admin Approved";
      if (v === "Rejected") return "Rejected";
      if (v === "Reimbursed") return "Reimbursed";
      if (v === "Info Requested") return "Info Requested";
      if (v === "Paid") return "Marked Paid";
    }
    if (n.fieldName === "active" && n.newValue === "false") return "Deactivated";
    if (n.fieldName === "active" && n.newValue === "true") return "Activated";
    if (n.fieldName === "allocatedAmount") return "Budget Updated";
    return n.action === "UPDATED" ? `Updated ${n.fieldName || ""}` : n.action;
  };

  const actionColor = (n) => {
    if (n.action === "CREATED") return "var(--accent)";
    const v = n.newValue || "";
    if (v === "Approved" || v === "Paid") return "var(--green)";
    if (v === "Reimbursed") return "var(--teal)";
    if (v === "Rejected") return "var(--red)";
    if (v === "Info Requested") return "var(--amber)";
    if (v === "Pending L2") return "var(--violet)";
    if (n.fieldName === "active" && v === "false") return "var(--red)";
    if (n.fieldName === "active" && v === "true") return "var(--green)";
    return "var(--text3)";
  };

  const fmtTs = (ts) => {
    if (!ts) return "—";
    try {
      return new Date(ts).toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
    } catch { return ts; }
  };

  const filtered = items.filter(n => {
    const q = search.toLowerCase();
    const matchSearch = !q || (n.entityDisplayId || "").toLowerCase().includes(q)
      || (n.employeeName || "").toLowerCase().includes(q)
      || (n.entityTitle || "").toLowerCase().includes(q)
      || (n.changedBy || "").toLowerCase().includes(q);
    const matchType = !filterType || n.entityType === filterType;
    const matchAction = !filterAction || actionLabel(n) === filterAction;
    return matchSearch && matchType && matchAction;
  });

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const pageRows = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const typeColors = {
    EXPENSE: "var(--accent)",
    CLAIM: "var(--violet)",
    BUDGET: "var(--teal)",
    EXPENSE_CATEGORY: "var(--amber)",
    INTERNAL_CATEGORY: "var(--green)",
    INTERNAL_EXPENSE: "var(--orange)",
    INTERNAL_PERMISSION: "#7c3aed",
  };
  const stats = [
    { label: "Total Events", val: totalFromServer, icon: "history", tone: "blue" },
    { label: "Submitted", val: items.filter(n => n.action === "CREATED" && n.entityType === "EXPENSE").length, icon: "send", tone: "violet" },
    { label: "Approved", val: items.filter(n => n.newValue === "Approved" || n.newValue === "Pending L2").length, icon: "check_circle", tone: "green" },
    { label: "Rejected", val: items.filter(n => n.newValue === "Rejected").length, icon: "cancel", tone: "red" },
    { label: "Reimbursed", val: items.filter(n => n.newValue === "Reimbursed").length, icon: "payments", tone: "teal" },
  ];

  return (
    <>
      <div className="page-header">
        <div>
          <div className="page-title">System Notes</div>
          <div className="page-sub">Full audit trail of all expense activity · {totalFromServer} total events</div>
        </div>
        <button className="btn" onClick={() => { onRefresh(); setPage(1); }}><Mi icon="refresh" style={{ fontSize: 14 }} />Refresh</button>
      </div>

      <div className="kpi-grid" style={{ gridTemplateColumns: "repeat(5,1fr)" }}>
        {stats.map(s => (
          <div key={s.label} className={`kpi kpi-${s.tone}`} style={{ cursor: "default" }}>
            <div className="kpi-top">
              <div className="kpi-label">{s.label}</div>
              <div className={`kpi-icon ki-${s.tone}`}><Mi icon={s.icon} /></div>
            </div>
            <div className="kpi-val">{s.val}</div>
          </div>
        ))}
      </div>

      <div className="card" style={{ padding: 0 }}>
        <div className="filter-row" style={{ padding: "12px 16px", borderBottom: "1px solid var(--border)" }}>
          <div className="search-bar"><Mi icon="search" /><input type="text" placeholder="Search by expense ID, employee, title, actor..." value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} /></div>
          <select className="form-control" style={{ width: "auto" }} value={filterType} onChange={e => { setFilterType(e.target.value); setPage(1); }}>
            <option value="">All Types</option>
            <option value="EXPENSE">Expense</option>
            <option value="CLAIM">Claim</option>
            <option value="INTERNAL_EXPENSE">Internal Expense</option>
            <option value="BUDGET">Budget</option>
            <option value="EXPENSE_CATEGORY">Expense Category</option>
            <option value="INTERNAL_CATEGORY">Internal Category</option>
            <option value="INTERNAL_PERMISSION">Manage Access</option>
          </select>
          <select className="form-control" style={{ width: "auto" }} value={filterAction} onChange={e => { setFilterAction(e.target.value); setPage(1); }}>
            <option value="">All Actions</option>
            {["Submitted", "Claim Created", "Int. Expense Created", "Budget Created", "Category Created", "Int. Category Created", "Manager Approved", "Admin Approved", "Rejected", "Reimbursed", "Marked Paid", "Info Requested", "Budget Updated", "Deactivated", "Activated"].map(a => <option key={a}>{a}</option>)}
          </select>
          <button className="btn" onClick={() => { setSearch(""); setFilterType(""); setFilterAction(""); setPage(1); }}>Clear</button>
        </div>

        <div className="tbl-wrap" style={{ border: "none", borderRadius: 0 }}>
          <table>
            <thead>
              <tr>
                <th style={{ position: "sticky", top: 0, zIndex: 2, background: "var(--surface2)" }}>Timestamp</th>
                <th style={{ position: "sticky", top: 0, zIndex: 2, background: "var(--surface2)" }}>Entity</th>
                <th style={{ position: "sticky", top: 0, zIndex: 2, background: "var(--surface2)" }}>Title</th>
                <th style={{ position: "sticky", top: 0, zIndex: 2, background: "var(--surface2)" }}>Employee</th>
                <th style={{ position: "sticky", top: 0, zIndex: 2, background: "var(--surface2)" }}>Amount</th>
                <th style={{ position: "sticky", top: 0, zIndex: 2, background: "var(--surface2)" }}>Event</th>
                <th style={{ position: "sticky", top: 0, zIndex: 2, background: "var(--surface2)" }}>Details</th>
                <th style={{ position: "sticky", top: 0, zIndex: 2, background: "var(--surface2)" }}>Actor</th>
              </tr>
            </thead>
            <tbody>
              {pageRows.length === 0
                ? <tr><td colSpan={8} style={{ textAlign: "center", padding: 40, color: "var(--text3)" }}>No activity found</td></tr>
                : pageRows.map(n => (
                  <tr key={n.id}>
                    <td style={{ whiteSpace: "nowrap", color: "var(--text3)", fontSize: 12 }}>{fmtTs(n.changedAt)}</td>
                    <td>
                      <span style={{ background: typeColors[n.entityType] || "var(--surface3)", color: "#fff", borderRadius: 5, padding: "2px 7px", fontSize: 10, fontWeight: 700, letterSpacing: ".4px", marginRight: 6 }}>
                        {n.entityType}
                      </span>
                      <span style={{ fontFamily: "DM Sans,sans-serif", fontWeight: 700, color: "var(--accent)", fontSize: 12 }}>{n.entityDisplayId || `#${n.entityId}`}</span>
                    </td>
                    <td style={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{n.entityTitle || "—"}</td>
                    <td>{n.employeeName || "—"}</td>
                    <td style={{ fontWeight: 600 }}>{n.entityAmount != null ? `₹${Number(n.entityAmount).toLocaleString("en-IN")}` : "—"}</td>
                    <td>
                      <span style={{ background: actionColor(n) + "22", color: actionColor(n), border: `1px solid ${actionColor(n)}55`, borderRadius: 6, padding: "2px 9px", fontSize: 12, fontWeight: 600, whiteSpace: "nowrap" }}>
                        {actionLabel(n)}
                      </span>
                    </td>
                    <td style={{ fontSize: 12, color: "var(--text2)" }}>
                      {n.action === "UPDATED" && n.oldValue && n.newValue
                        ? <span><span style={{ color: "var(--red)", textDecoration: "line-through" }}>{n.oldValue}</span>{" → "}<span style={{ color: "var(--green)" }}>{n.newValue}</span></span>
                        : n.action === "CREATED" ? <span style={{ color: "var(--text3)" }}>New record</span> : "—"}
                    </td>
                    <td style={{ fontSize: 12, color: "var(--text2)" }}>{n.changedBy || "—"}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px", borderTop: "1px solid var(--border)" }}>
          <span style={{ fontSize: 12, color: "var(--text3)", fontFamily: "DM Sans,sans-serif" }}>
            {filtered.length === 0 ? "0 events" : `Showing ${(page - 1) * PAGE_SIZE + 1}–${Math.min(page * PAGE_SIZE, filtered.length)} of ${filtered.length} events`}
          </span>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <button className="btn btn-sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span style={{ fontSize: 12, color: "var(--text2)", minWidth: 90, textAlign: "center", fontFamily: "DM Sans,sans-serif" }}>Page {page} of {totalPages}</span>
            <button className="btn btn-sm" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        </div>
      </div>
    </>
  );
}

function PermissionsPage({ showToast }) {
  const [perms, setPerms] = useState(() => PERM_ROWS.map(([, ...checks]) => [...checks]));
  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Permissions</div><div className="page-sub">Role-based access control for expense module</div></div>
        <button className="btn btn-primary" onClick={() => showToast("Permissions saved", "t-success")}><Mi icon="save" style={{ fontSize: 14 }} />Save Permissions</button>
      </div>
      <div className="card">
        <table className="perm-table">
          <thead><tr><th>Feature / Page</th><th style={{ textAlign: "center" }}>USER</th><th style={{ textAlign: "center" }}>MANAGER</th><th style={{ textAlign: "center" }}>HR</th><th style={{ textAlign: "center" }}>ADMIN</th></tr></thead>
          <tbody>
            {PERM_ROWS.map(([label], ri) => (
              <tr key={label}>
                <td style={{ fontSize: 13, fontFamily: "var(--font2)" }}>{label}</td>
                {perms[ri].map((checked, ci) => (
                  <td key={ci} style={{ textAlign: "center" }}>
                    <Toggle checked={checked} onChange={() => { setPerms(p => p.map((row, r) => r === ri ? row.map((v, c) => c === ci ? !v : v) : row)); showToast("Permission updated", "t-success"); }} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

/* ─── Page: Coming Soon ──────────────────────────────────── */
function ComingSoonPage({ title = "Coming Soon" }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 420, gap: 20, textAlign: "center" }}>
      <div style={{ width: 80, height: 80, borderRadius: "50%", background: "var(--accent-light)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Mi icon="construction" style={{ fontSize: 38, color: "var(--accent)" }} />
      </div>
      <div>
        <div style={{ fontSize: 22, fontWeight: 800, color: "var(--text)", marginBottom: 8 }}>{title}</div>
        <div style={{ fontSize: 14, color: "var(--text3)", fontFamily: "var(--font2)", maxWidth: 340, lineHeight: 1.6 }}>
          This section is under development and will be available soon. Stay tuned!
        </div>
      </div>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "var(--amber-bg, #fef3c7)", color: "#92400e", border: "1px solid #fcd34d", borderRadius: 20, padding: "5px 16px", fontSize: 12, fontWeight: 600 }}>
        <Mi icon="schedule" style={{ fontSize: 15 }} /> In Progress
      </span>
    </div>
  );
}

/* ─── Page: Settings ─────────────────────────────────────── */
function SettingsPage({ showToast }) {
  const [notifs, setNotifs] = useState({ submitted: true, approval: true, budget: true, overdue: true, petty: true });
  return (
    <>
      <div className="page-header">
        <div><div className="page-title">Settings</div><div className="page-sub">System configuration & preferences</div></div>
        <button className="btn btn-primary" onClick={() => showToast("Settings saved successfully", "t-success")}><Mi icon="save" style={{ fontSize: 14 }} />Save Settings</button>
      </div>
      <div className="two-col">
        <div className="card">
          <div className="card-head"><div className="card-title">Notification Settings</div></div>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {[
              ["submitted", "Email on expense submitted"],
              ["approval", "Email on approval required"],
              ["budget", "Budget alert at 80%"],
              ["overdue", "Overdue bill alerts"],
              ["petty", "Petty cash low balance alerts"],
            ].map(([key, label]) => (
              <div key={key} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span style={{ fontSize: 13, fontFamily: "var(--font2)" }}>{label}</span>
                <Toggle checked={notifs[key]} onChange={() => { setNotifs(p => ({ ...p, [key]: !p[key] })); showToast("Setting updated", "t-success"); }} />
              </div>
            ))}
          </div>
        </div>
        <div className="card">
          <div className="card-head"><div className="card-title">General Settings</div></div>
          <div className="modal-body">
            <div className="form-group"><label>Default Currency</label><select className="form-control"><option>INR (₹)</option><option>USD ($)</option><option>EUR (€)</option></select></div>
            <div className="form-group"><label>Timezone</label><select className="form-control"><option>Asia/Kolkata (IST)</option><option>UTC</option></select></div>
            <div className="form-group"><label>Fiscal Year Start</label><select className="form-control"><option>April (Indian FY)</option><option>January</option></select></div>
            <div className="form-group"><label>Date Format</label><select className="form-control"><option>DD/MM/YYYY</option><option>MM/DD/YYYY</option><option>YYYY-MM-DD</option></select></div>
          </div>
        </div>
      </div>
    </>
  );
}

/* ─── Employee Dropdown (custom scrollable) ──────────────── */
function EmployeeDropdown({ employees, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered = (employees || []).filter(e =>
    `${e.firstName} ${e.lastName}`.toLowerCase().includes(search.toLowerCase())
  );
  const selected = (employees || []).find(e => String(e.id) === String(value));

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <div
        className="form-control"
        style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", userSelect: "none" }}
        onClick={() => setOpen(o => !o)}
      >
        <span style={{ color: selected ? "var(--text)" : "var(--text3)", fontSize: 13 }}>
          {selected ? `${selected.firstName} ${selected.lastName}` : "— Select Employee —"}
        </span>
        <Mi icon={open ? "expand_less" : "expand_more"} style={{ fontSize: 18, color: "var(--text3)", flexShrink: 0 }} />
      </div>
      {open && (
        <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "var(--surface)", border: "1px solid var(--border2)", borderRadius: 10, boxShadow: "0 4px 24px rgba(0,0,0,.12)", zIndex: 999, overflow: "hidden" }}>
          <div style={{ padding: "8px 10px", borderBottom: "1px solid var(--border)" }}>
            <input
              className="form-control"
              style={{ fontSize: 13 }}
              placeholder="Search employee..."
              value={search}
              autoFocus
              onChange={e => setSearch(e.target.value)}
              onClick={e => e.stopPropagation()}
            />
          </div>
          <div style={{ maxHeight: 200, overflowY: "auto" }}>
            {filtered.length === 0
              ? <div style={{ padding: "12px 14px", color: "var(--text3)", fontSize: 13 }}>No employees found</div>
              : filtered.map(e => {
                const isSelected = String(e.id) === String(value);
                return (
                  <div
                    key={e.id}
                    style={{ padding: "9px 14px", cursor: "pointer", fontSize: 13, background: isSelected ? "var(--accent-light)" : "transparent", color: isSelected ? "var(--accent)" : "var(--text)", fontWeight: isSelected ? 600 : 400 }}
                    onMouseEnter={ev => { if (!isSelected) ev.currentTarget.style.background = "var(--surface2)"; }}
                    onMouseLeave={ev => { if (!isSelected) ev.currentTarget.style.background = "transparent"; }}
                    onClick={() => { onChange(e.id); setOpen(false); setSearch(""); }}
                  >
                    {e.firstName} {e.lastName}
                  </div>
                );
              })
            }
          </div>
        </div>
      )}
    </div>
  );
}

function DeptDropdown({ departments, value, onChange, placeholder = "— Select —" }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filtered = (departments || []).filter(d => d.toLowerCase().includes(search.toLowerCase()));

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <div
        className="form-control"
        style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", userSelect: "none" }}
        onClick={() => setOpen(o => !o)}
      >
        <span style={{ color: value ? "var(--text)" : "var(--text3)", fontSize: 13 }}>
          {value || placeholder}
        </span>
        <Mi icon={open ? "expand_less" : "expand_more"} style={{ fontSize: 18, color: "var(--text3)", flexShrink: 0 }} />
      </div>
      {open && (
        <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "var(--surface)", border: "1px solid var(--border2)", borderRadius: 10, boxShadow: "0 4px 24px rgba(0,0,0,.12)", zIndex: 999, overflow: "hidden" }}>
          <div style={{ padding: "8px 10px", borderBottom: "1px solid var(--border)" }}>
            <input
              className="form-control"
              style={{ fontSize: 13 }}
              placeholder="Search department..."
              value={search}
              autoFocus
              onChange={e => setSearch(e.target.value)}
              onClick={e => e.stopPropagation()}
            />
          </div>
          <div style={{ maxHeight: 200, overflowY: "auto" }}>
            {filtered.length === 0
              ? <div style={{ padding: "12px 14px", color: "var(--text3)", fontSize: 13 }}>No departments found</div>
              : filtered.map(d => {
                const isSelected = d === value;
                return (
                  <div
                    key={d}
                    style={{ padding: "9px 14px", cursor: "pointer", fontSize: 13, background: isSelected ? "var(--accent-light)" : "transparent", color: isSelected ? "var(--accent)" : "var(--text)", fontWeight: isSelected ? 600 : 400 }}
                    onMouseEnter={ev => { if (!isSelected) ev.currentTarget.style.background = "var(--surface2)"; }}
                    onMouseLeave={ev => { if (!isSelected) ev.currentTarget.style.background = "transparent"; }}
                    onClick={() => { onChange(d); setOpen(false); setSearch(""); }}
                  >
                    {d}
                  </div>
                );
              })
            }
          </div>
        </div>
      )}
    </div>
  );
}

/* ─── Modal helpers (defined outside to prevent flicker) ─── */
function ModalShell({ title, size, children, footer, onClose }) {
  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={`modal${size ? " " + size : ""}`}>
        <div className="modal-head">
          <div className="modal-title">{title}</div>
          <button className="modal-close" onClick={onClose}><Mi icon="close" style={{ fontSize: 16 }} /></button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-foot">{footer}</div>}
      </div>
    </div>
  );
}
function ModalInfoBox({ children }) { return <div className="modal-info-box">{children}</div>; }
function ModalFG({ label, children }) { return <div className="form-group"><label>{label}</label>{children}</div>; }
function ModalFR({ children }) { return <div className="form-row">{children}</div>; }

/* ─── Modal System ───────────────────────────────────────── */
function ModalSystem({ modal, closeModal, showToast, decrement, allExpenses, allClaims, pettyCash, expenseCategories, intCategories, internalExpenses, onRefresh, handleApprove, handleReject, handleReimburse, handleRequestInfo, onModal, budgets }) {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [departments, setDepartments] = useState([]);
  const [budgetDept, setBudgetDept] = useState("");
  const reqInfoRef = useRef();
  const catNameRef = useRef();
  const txnRefRef = useRef();
  const markPaidTxnRef = useRef();
  const markPaidModeRef = useRef();
  const exportFromRef = useRef();
  const exportToRef = useRef();
  const [exportReportType, setExportReportType] = useState("");
  const [exportDept, setExportDept] = useState("");
  const [exportCat, setExportCat] = useState("");
  const [exportStatus, setExportStatus] = useState("");
  const [exportPeriod, setExportPeriod] = useState("");
  const intCatNameRef = useRef();
  const intCatTypeRef = useRef();

  const intExpTitleRef = useRef();
  const intExpTypeRef = useRef();
  const intExpCategoryRef = useRef();
  const intExpAmountRef = useRef();
  const intExpVendorRef = useRef();
  const intExpDueDateRef = useRef();
  const intExpNotesRef = useRef();

  const utilVendorRef = useRef();
  const utilCategoryRef = useRef();
  const utilAmountRef = useRef();
  const utilDueDateRef = useRef();
  const utilPeriodRef = useRef();
  const utilAccountRef = useRef();

  const creditAmountRef = useRef();
  const creditDateRef = useRef();
  const creditDescRef = useRef();
  const creditSourceRef = useRef();

  const titleRef = useRef();
  const categoryRef = useRef();
  const amountRef = useRef();
  const expDateRef = useRef();
  const paymentRef = useRef();
  const projectRef = useRef();
  const descRef = useRef();
  const receiptRef = useRef();

  const budgetDeptRef = useRef();
  const budgetCatRef = useRef();
  const budgetAmtRef = useRef();
  const budgetPeriodRef = useRef();
  const budgetNotesRef = useRef();

  const grocTitleRef = useRef();
  const grocCatRef = useRef();
  const grocVendorRef = useRef();
  const grocAmtRef = useRef();
  const grocDateRef = useRef();
  const grocBillRef = useRef();
  const grocNotesRef = useRef();

  // Stable Shell — useMemo so reference is preserved across re-renders (prevents flicker)
  const Shell = useMemo(() => (p) => <ModalShell {...p} onClose={closeModal} />, [closeModal]);
  const InfoBox = ModalInfoBox;
  const FG = ModalFG;
  const FR = ModalFR;

  const distinctTypes = [...new Set((intCategories || []).map(c => c.type).filter(Boolean))].sort();
  const [customType, setCustomType] = useState("");
  const [selectedCatType, setSelectedCatType] = useState("");
  const [selectedIntType, setSelectedIntType] = useState("");

  useEffect(() => {
    if (!modal || modal.type !== "add-int-category") return;
    setSelectedCatType(modal.data?.type || "");
    setCustomType("");
  }, [modal?.type, modal?.data]);

  useEffect(() => {
    if (!modal || modal.type !== "new-internal") return;
    setSelectedIntType("");
  }, [modal?.type]);

  useEffect(() => {
    if (modal?.type === "add-budget") {
      setBudgetDept(modal?.data?.department || "");
    }
  }, [modal?.type, modal?.data?.department]);

  useEffect(() => {
    if (modal?.type === "export") {
      setExportReportType(modal?.data || "expense-summary");
      setExportDept("");
      setExportCat("");
      setExportStatus("");
      const now = new Date();
      setExportPeriod(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`);
    }
  }, [modal?.type, modal?.data]);

  useEffect(() => {
    if (!modal || !["new-expense", "add-budget", "export", "filter", "new-internal"].includes(modal.type)) return;
    setSelectedEmployee("");
    const token = localStorage.getItem("token");
    if (!token) return;
    fetch(`${API_BASE_URL}/api/employees/active`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { const l = Array.isArray(d) ? d : d.content || []; setEmployees(l); })
      .catch(() => { });

    const fetchDepartments = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/departments/all`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error();
        const data = await res.json();
        setDepartments(Array.isArray(data) ? data.map(d => d.name || d).sort() : []);
      } catch { showToast("Failed to load departments", "t-error"); }
    };
    fetchDepartments();
  }, [modal?.type, showToast]);

  if (!modal) return null;
  const { type, data } = modal;

  const pendingReimb = (allExpenses || []).filter(e => e.status === "Approved");
  const processAllTotal = pendingReimb.reduce((s, e) => s + Number(e.amount || 0), 0);
  const pcAccount = pettyCash?.account || {};

  const doApprove = async () => {
    const isInternal = (data || "").startsWith("INT-");
    const isClaim = (data || "").startsWith("CLM-");
    if (isInternal) {
      closeModal();
      try {
        const h = { Authorization: `Bearer ${localStorage.getItem("token")}` };
        const res = await fetch(`${API_BASE_URL}/api/internal-expenses/${data}/approve`, { method: "PATCH", headers: h });
        if (!res.ok) { const t = await res.text(); showToast(t || "Failed to approve", "t-error"); return; }
        showToast("Internal expense approved", "t-success");
        if (onRefresh) onRefresh();
      } catch { showToast("Failed to approve", "t-error"); }
    } else if (isClaim) {
      closeModal();
      try {
        const h = { Authorization: `Bearer ${localStorage.getItem("token")}` };
        const res = await fetch(`${API_BASE_URL}/api/expense-claims/${data}/approve`, { method: "PATCH", headers: h });
        if (!res.ok) { const t = await res.text(); showToast(t || "Failed to approve claim", "t-error"); return; }
        showToast("Claim approved", "t-success");
        if (onRefresh) onRefresh();
      } catch { showToast("Failed to approve claim", "t-error"); }
    } else {
      const expense = (allExpenses || []).find(e => e.id === data);
      const isL2 = expense?.status === "Pending L2";
      closeModal();
      try {
        await handleApprove(data, isL2);
        decrement("approvals");
        if (onRefresh) onRefresh();
      } catch { showToast("Failed to approve expense", "t-error"); }
    }
  };
  const doReject = async () => {
    const r = document.getElementById("reject-reason");
    if (r && !r.value.trim()) { showToast("Please provide a rejection reason", "t-error"); r.focus(); return; }
    const reason = r?.value?.trim() || "Rejected by admin";
    const isInternal = (data || "").startsWith("INT-");
    const isClaim = (data || "").startsWith("CLM-");
    if (isInternal) {
      closeModal();
      try {
        const h = { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" };
        const res = await fetch(`${API_BASE_URL}/api/internal-expenses/${data}/reject`, { method: "PATCH", headers: h, body: JSON.stringify({ reason }) });
        if (!res.ok) { const t = await res.text(); showToast(t || "Failed to reject", "t-error"); return; }
        showToast("Internal expense rejected", "t-info");
        if (onRefresh) onRefresh();
      } catch { showToast("Failed to reject", "t-error"); }
    } else if (isClaim) {
      closeModal();
      try {
        const h = { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" };
        const res = await fetch(`${API_BASE_URL}/api/expense-claims/${data}/reject`, { method: "PATCH", headers: h, body: JSON.stringify({ reason }) });
        if (!res.ok) { const t = await res.text(); showToast(t || "Failed to reject claim", "t-error"); return; }
        showToast("Claim rejected", "t-info");
        if (onRefresh) onRefresh();
      } catch { showToast("Failed to reject claim", "t-error"); }
    } else {
      closeModal();
      try {
        await handleReject(data, reason);
        decrement("approvals");
        if (onRefresh) onRefresh();
      } catch { showToast("Failed to reject expense", "t-error"); }
    }
  };
  const doReimburse = async () => {
    const parts = (data || "").split("|");
    const expId = parts[2] || parts[0];
    const txnRef = txnRefRef.current?.value?.trim() || "";
    closeModal();
    try { await handleReimburse(expId, txnRef || undefined); decrement("reimbursements"); }
    catch (err) { showToast(err?.message || "Failed to process reimbursement", "t-error"); }
  };
  const doRequestInfo = async () => {
    const message = reqInfoRef.current?.value?.trim();
    if (!message) { showToast("Please specify what information is required", "t-error"); return; }
    closeModal();
    try { await handleRequestInfo(data, message); }
    catch { showToast("Failed to send info request", "t-error"); }
  };
  const doExport = async () => {
    const reportType = exportReportType || data || "expense-summary";
    const token = localStorage.getItem("token");
    let url, filename;
    if (reportType === "budget-report") {
      const params = new URLSearchParams();
      if (exportPeriod) params.append("period", exportPeriod);
      if (exportDept) params.append("department", exportDept);
      url = `${API_BASE_URL}/api/budgets/export?${params}`;
      filename = `budget-report-${exportPeriod || "all"}.csv`;
    } else {
      const from = exportFromRef.current?.value || "";
      const to = exportToRef.current?.value || "";
      const params = new URLSearchParams({ type: reportType });
      if (from) params.append("from", from);
      if (to) params.append("to", to);
      if (exportDept) params.append("department", exportDept);
      if (exportCat) params.append("category", exportCat);
      if (exportStatus) params.append("status", exportStatus);
      url = `${API_BASE_URL}/api/expenses/export?${params}`;
      filename = `${reportType}-${new Date().toISOString().slice(0, 10)}.csv`;
    }
    try {
      const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) { showToast("Export failed", "t-error"); return; }
      const blob = await res.blob();
      const objUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objUrl;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(objUrl);
      closeModal();
      showToast("CSV downloaded", "t-success");
    } catch { showToast("Export failed", "t-error"); }
  };
  const doProcessAll = () => { closeModal(); showToast(`${pendingReimb.length} reimbursement${pendingReimb.length !== 1 ? "s" : ""} processed — ${fmtAmt(processAllTotal)} via NEFT`, "t-success"); };
  const doBulkApprove = async () => {
    const pendingL2Exp = (allExpenses || []).filter(e => e.status === "Pending L2");
    const pendingL1Exp = (allExpenses || []).filter(e => e.status === "Pending L1");
    const pendingClms = (allClaims || []).filter(c => c.status === "Pending" || c.status === "Pending L2");
    closeModal();
    const h = { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" };
    let approved = 0, failed = 0;
    for (const e of pendingL2Exp) {
      try { const res = await fetch(`${API_BASE_URL}/api/expenses/${e.id}/approve?l2=true`, { method: "PATCH", headers: h }); res.ok ? approved++ : failed++; }
      catch { failed++; }
    }
    for (const e of pendingL1Exp) {
      try { const res = await fetch(`${API_BASE_URL}/api/expenses/${e.id}/approve?l2=false`, { method: "PATCH", headers: h }); res.ok ? approved++ : failed++; }
      catch { failed++; }
    }
    for (const c of pendingClms) {
      try { const res = await fetch(`${API_BASE_URL}/api/expense-claims/${c.id}/approve`, { method: "PATCH", headers: h }); res.ok ? approved++ : failed++; }
      catch { failed++; }
    }
    if (failed === 0) showToast(`${approved} item${approved !== 1 ? "s" : ""} approved successfully`, "t-success");
    else showToast(`${approved} approved, ${failed} failed — check individual items`, "t-amber");
    if (onRefresh) onRefresh();
  };
  const doCreditPetty = async () => {
    const amount = creditAmountRef.current?.value;
    const date = creditDateRef.current?.value;
    const desc = creditDescRef.current?.value?.trim();
    const source = creditSourceRef.current?.value?.trim();

    if (!amount || Number(amount) <= 0) { showToast("Enter a valid credit amount", "t-error"); return; }

    try {
      const h = { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" };
      const body = {
        amount: Number(amount),
        transactionDate: date || new Date().toISOString().slice(0, 10),
        description: desc || "Petty Cash Credit",
        linkedRef: source || null,
        type: "Credit"
      };
      const res = await fetch(`${API_BASE_URL}/api/petty-cash/credit`, {
        method: "POST", headers: h, body: JSON.stringify(body)
      });
      if (!res.ok) { const text = await res.text(); showToast(text || "Failed to credit petty cash", "t-error"); return; }
      closeModal();
      showToast(`Petty cash credited ₹${Number(amount).toLocaleString("en-IN")}`, "t-success");
      if (onRefresh) onRefresh();
    } catch (err) { showToast("Network error", "t-error"); }
  };
  const doMarkPaid = async () => {
    const txnRef = markPaidTxnRef.current?.value?.trim() || null;
    const paymentMode = markPaidModeRef.current?.value || "COMPANY_ACCOUNT";
    const expense = internalExpenses?.find(e => e.internalId === data);
    closeModal();
    try {
      const h = { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" };
      const res = await fetch(`${API_BASE_URL}/api/internal-expenses/${data}/mark-paid`, {
        method: "PATCH", headers: h,
        body: JSON.stringify({ transactionRef: txnRef, paymentMode }),
      });
      if (!res.ok) { const t = await res.text(); showToast(t || "Failed to mark as paid", "t-error"); return; }
      decrement("overdue");

      // Automatically deduct from Petty Cash if selected
      if (paymentMode === "PETTY_CASH" && expense) {
        const debitRes = await fetch(`${API_BASE_URL}/api/petty-cash/debit`, {
          method: "POST", headers: h,
          body: JSON.stringify({
            amount: expense.amount,
            description: `Paid internal expense: ${expense.title}`,
            linkedRef: data,
            transactionDate: new Date().toISOString().slice(0, 10)
          }),
        });
        if (!debitRes.ok) {
          showToast(`${data} marked as Paid, but failed to deduct Petty Cash`, "t-amber");
        } else {
          showToast(`${data} marked as Paid & Petty Cash debited`, "t-success");
        }
      } else {
        showToast(`${data} marked as Paid`, "t-success");
      }

      if (onRefresh) onRefresh();
    } catch { showToast("Failed to mark as paid", "t-error"); }
  };

  const doSaveNewExpense = async () => {
    const title = titleRef.current?.value?.trim();
    const categoryId = categoryRef.current?.value;
    const amount = amountRef.current?.value;
    const expenseDate = expDateRef.current?.value;
    const paymentMode = paymentRef.current?.value;
    const project = projectRef.current?.value?.trim();
    const description = descRef.current?.value?.trim();
    const receiptFile = receiptRef.current?.files?.[0];

    if (!title) { showToast("Title is required", "t-error"); return; }
    if (!categoryId) { showToast("Category is required", "t-error"); return; }
    if (!amount || Number(amount) <= 0) { showToast("Valid amount is required", "t-error"); return; }
    if (!expenseDate) { showToast("Expense date is required", "t-error"); return; }
    if (receiptFile && receiptFile.size > 1048576) { showToast("File must be 1 MB or less", "t-error"); return; }

    let receiptBase64 = null;
    let receiptFileName = null;
    if (receiptFile) {
      receiptBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(receiptFile);
      });
      receiptFileName = receiptFile.name;
    }

    const token = localStorage.getItem("token");
    const fd = new FormData();
    fd.append("title", title);
    fd.append("categoryId", categoryId);
    fd.append("amount", amount);
    fd.append("expenseDate", expenseDate);
    fd.append("paymentMode", paymentMode || "PERSONAL_CARD");
    if (project) fd.append("project", project);
    if (description) fd.append("description", description);
    if (receiptBase64) fd.append("receiptBase64", receiptBase64);
    if (receiptFileName) fd.append("receiptFileName", receiptFileName);
    if (selectedEmployee) fd.append("employeeId", selectedEmployee);

    try {
      const res = await fetch(`${API_BASE_URL}/api/expenses`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: fd,
      });
      const text = await res.text();
      if (res.ok) {
        closeModal();
        showToast("Expense submitted successfully", "t-success");
        if (onRefresh) onRefresh();
      } else {
        showToast(text || "Failed to save expense", "t-error");
      }
    } catch {
      showToast("Network error — please try again", "t-error");
    }
  };

  const doSaveCategory = async () => {
    const name = catNameRef.current?.value?.trim();
    if (!name) { showToast("Category name is required", "t-error"); return; }
    const token = localStorage.getItem("token");
    const h = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
    const isEdit = data && data.id;
    try {
      const res = await fetch(
        isEdit ? `${API_BASE_URL}/api/expense-categories/${data.id}` : `${API_BASE_URL}/api/expense-categories`,
        { method: isEdit ? "PUT" : "POST", headers: h, body: JSON.stringify({ name, active: true }) }
      );
      const text = await res.text();
      if (res.ok) {
        closeModal();
        showToast(isEdit ? "Category updated" : "Category created", "t-success");
        if (onRefresh) onRefresh();
      } else { showToast(text || "Failed to save category", "t-error"); }
    } catch { showToast("Network error", "t-error"); }
  };

  const doSaveIntCategory = async () => {
    const name = intCatNameRef.current?.value?.trim();
    if (!name) { showToast("Category name is required", "t-error"); return; }
    if (selectedCatType === "__OTHER__" && !customType.trim()) { showToast("Please enter a custom type name", "t-error"); return; }
    const token = localStorage.getItem("token");
    const h = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
    const isEdit = data && data.id;
    const body = {
      code: data?.code || name.toUpperCase().replace(/\s+/g, "_").slice(0, 20),
      name,
      type: (selectedCatType === "__OTHER__" ? customType.trim().toUpperCase() : intCatTypeRef.current?.value) || null,
      active: true,
    };
    try {
      const res = await fetch(
        isEdit ? `${API_BASE_URL}/api/internal-categories/${data.id}` : `${API_BASE_URL}/api/internal-categories`,
        { method: isEdit ? "PUT" : "POST", headers: h, body: JSON.stringify(body) }
      );
      const text = await res.text();
      if (res.ok) { closeModal(); showToast(isEdit ? "Category updated" : "Category created", "t-success"); if (onRefresh) onRefresh(); }
      else showToast(text || "Failed to save category", "t-error");
    } catch { showToast("Network error", "t-error"); }
  };

  const doSaveNewInternal = async () => {
    const title = intExpTitleRef.current?.value?.trim();
    const type = intExpTypeRef.current?.value;
    const amount = intExpAmountRef.current?.value;
    if (!title) { showToast("Title is required", "t-error"); return; }
    if (!type) { showToast("Type is required", "t-error"); return; }
    if (!amount || Number(amount) <= 0) { showToast("Valid amount is required", "t-error"); return; }
    const token = localStorage.getItem("token");
    const selEmp = employees.find(e => String(e.employeeId || e.id) === String(selectedEmployee));
    const body = {
      title,
      type,
      category: intExpCategoryRef.current?.value?.trim() || null,
      amount: Number(amount),
      vendor: intExpVendorRef.current?.value?.trim() || null,
      dueDate: intExpDueDateRef.current?.value || null,
      notes: intExpNotesRef.current?.value?.trim() || null,
      forEmployeeId: selEmp ? (selEmp.employeeId || selEmp.id) : null,
      forEmployeeName: selEmp ? (selEmp.name || `${selEmp.firstName || ""} ${selEmp.lastName || ""}`.trim()) : null,
    };
    try {
      const res = await fetch(`${API_BASE_URL}/api/internal-expenses`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const text = await res.text();
      if (res.ok) { closeModal(); showToast("Internal expense created", "t-success"); if (onRefresh) onRefresh(); }
      else showToast(text || "Failed to create internal expense", "t-error");
    } catch { showToast("Network error — please try again", "t-error"); }
  };

  const doSaveUtility = async () => {
    const vendor = utilVendorRef.current?.value?.trim();
    const category = utilCategoryRef.current?.value;
    const amount = utilAmountRef.current?.value;
    const dueDate = utilDueDateRef.current?.value;
    const period = utilPeriodRef.current?.value?.trim();
    const accountNo = utilAccountRef.current?.value?.trim();

    if (!vendor) { showToast("Vendor name is required", "t-error"); return; }
    if (!amount || Number(amount) <= 0) { showToast("Valid amount is required", "t-error"); return; }

    const token = localStorage.getItem("token");
    const title = `${category.charAt(0) + category.slice(1).toLowerCase()} Bill${period ? ` — ${period}` : ""}`;

    const body = {
      title, type: "UTILITY", category: category, amount: Number(amount),
      vendor: vendor || null, dueDate: dueDate || null, billMonth: period || null,
      notes: accountNo ? `Account/Meter No: ${accountNo}` : null,
    };

    try {
      const res = await fetch(`${API_BASE_URL}/api/internal-expenses`, {
        method: "POST", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const text = await res.text();
      if (res.ok) { closeModal(); showToast("Utility bill added", "t-success"); if (onRefresh) onRefresh(); }
      else showToast(text || "Failed to add utility bill", "t-error");
    } catch { showToast("Network error — please try again", "t-error"); }
  };

  const doSaveGrocery = async () => {
    const title = grocTitleRef.current?.value?.trim();
    const category = grocCatRef.current?.value?.trim();
    const vendor = grocVendorRef.current?.value?.trim();
    const amount = grocAmtRef.current?.value;
    const purchaseDate = grocDateRef.current?.value;
    const billNo = grocBillRef.current?.value?.trim();
    const notes = grocNotesRef.current?.value?.trim();

    if (!title) { showToast("Description is required", "t-error"); return; }
    if (!amount || Number(amount) <= 0) { showToast("Valid amount is required", "t-error"); return; }

    const token = localStorage.getItem("token");
    const body = {
      title,
      type: "GROCERY",
      category: category || null,
      vendor: vendor || null,
      amount: Number(amount),
      dueDate: purchaseDate || null,
      notes: [billNo ? `Bill No: ${billNo}` : null, notes || null].filter(Boolean).join(" | ") || null,
    };

    try {
      const res = await fetch(`${API_BASE_URL}/api/internal-expenses`, {
        method: "POST", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const text = await res.text();
      if (res.ok) { closeModal(); showToast("Grocery entry added", "t-success"); if (onRefresh) onRefresh(); }
      else showToast(text || "Failed to add grocery entry", "t-error");
    } catch { showToast("Network error — please try again", "t-error"); }
  };

  const doSaveBudget = async () => {
    const department = budgetDept;
    const category = budgetCatRef.current?.value;
    const allocatedAmount = budgetAmtRef.current?.value;
    const period = budgetPeriodRef.current?.value?.trim();
    const notes = budgetNotesRef.current?.value?.trim();

    if (!department) { showToast("Department is required", "t-error"); return; }
    if (!allocatedAmount || Number(allocatedAmount) <= 0) { showToast("Valid allocated amount is required", "t-error"); return; }
    if (!period) { showToast("Period is required", "t-error"); return; }

    const token = localStorage.getItem("token");
    const isEdit = data && data.id;
    const body = {
      department,
      category: category || null,
      period,
      allocatedAmount: Number(allocatedAmount),
      notes: notes || null
    };

    try {
      const res = await fetch(isEdit ? `${API_BASE_URL}/api/budgets/${data.id}` : `${API_BASE_URL}/api/budgets`, {
        method: isEdit ? "PUT" : "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const text = await res.text();
      if (res.ok) { closeModal(); showToast(isEdit ? "Budget updated" : "Budget created", "t-success"); if (onRefresh) onRefresh(); }
      else showToast(text || "Failed to save budget", "t-error");
    } catch { showToast("Network error — please try again", "t-error"); }
  };

  const doSave = () => { closeModal(); showToast("Saved successfully", "t-success"); };

  if (type === "approve") {
    const exp = (allExpenses || []).find(e => e.id === data);
    const claim = (allClaims || []).find(c => c.id === data);
    const target = exp || claim;

    let budgetWarnings = [];
    let isOverBudget = false;

    // Parse "MMM yyyy" (e.g. "Apr 2026") → "2026-04"
    const parsePeriod = (p) => {
      if (!p) return null;
      const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      const parts = p.split(" ");
      if (parts.length < 2) return null;
      const mi = MONTHS.indexOf(parts[0]);
      return mi === -1 ? null : `${parts[1]}-${String(mi + 1).padStart(2, "0")}`;
    };

    if (exp) {
      const dept = exp.dept;
      const amt = Number(exp.amount || 0);
      // Match budget to the expense's own month, not the current month
      const expPeriod = exp.date ? exp.date.substring(0, 7) : null;
      const specificBudget = (budgets || []).find(b =>
        b.department === dept &&
        b.category === exp.category &&
        (!expPeriod || b.period === expPeriod)
      );
      const overallBudget = (budgets || []).find(b =>
        b.department === dept &&
        (!b.category || b.category === "Overall") &&
        (!expPeriod || b.period === expPeriod)
      );
      const relevantBudget = specificBudget || overallBudget;
      if (relevantBudget && Number(relevantBudget.allocatedAmount) > 0) {
        const allocated = Number(relevantBudget.allocatedAmount);
        const spent = Number(relevantBudget.spentAmount || 0);
        if (spent + amt > allocated) {
          isOverBudget = true;
          budgetWarnings.push(`${relevantBudget.category || "Overall"} budget for ${relevantBudget.department} (${relevantBudget.period}): Budget ${fmtAmt(allocated)}, Already spent ${fmtAmt(spent)}, This expense ${fmtAmt(amt)} → New total ${fmtAmt(spent + amt)}`);
        }
      }
    } else if (claim) {
      const claimAmt = Number(claim.total || 0);
      const dept = claim.dept;
      // Match budget to the claim's own month
      const claimPeriod = parsePeriod(claim.period);

      if (dept) {
        const deptBudgets = (budgets || []).filter(b =>
          b.department === dept &&
          Number(b.allocatedAmount) > 0 &&
          (!claimPeriod || b.period === claimPeriod)
        );
        deptBudgets.forEach(b => {
          const allocated = Number(b.allocatedAmount);
          const spent = Number(b.spentAmount || 0);
          if (spent + claimAmt > allocated) {
            isOverBudget = true;
            budgetWarnings.push(`${b.category || "Overall"} budget for ${b.department} (${b.period}): Budget ${fmtAmt(allocated)}, Already spent ${fmtAmt(spent)}, This claim ${fmtAmt(claimAmt)} → New total ${fmtAmt(spent + claimAmt)}`);
          }
        });
      }
    }

    return (
      <Shell title={<span style={{ color: "var(--green)" }}>✓ Approve {exp ? "Expense" : "Claim"}</span>}
        footer={<>
          <button className="btn btn-success" onClick={doApprove} disabled={isOverBudget} style={isOverBudget ? { opacity: 0.5, cursor: "not-allowed" } : {}}>
            <Mi icon="check_circle" style={{ fontSize: 15 }} />Confirm
          </button>
          <button className="btn" onClick={closeModal}>Cancel</button>
        </>}>
        <InfoBox>Approving: <strong>{data}</strong></InfoBox>
        {budgetWarnings.length > 0 && (
          <div style={{ display: "flex", gap: 10, padding: "12px 14px", background: "var(--red-bg, #fef2f2)", border: "1px solid var(--red-bd, #fca5a5)", borderRadius: 8, color: "var(--red)" }}>
            <Mi icon="warning" style={{ fontSize: 20, flexShrink: 0, marginTop: 2 }} />
            <div>
              <div style={{ fontWeight: 700, marginBottom: 6 }}>Budget Exceeded — Cannot Approve</div>
              {budgetWarnings.map((w, i) => (
                <div key={i} style={{ fontSize: 12, fontWeight: 500, lineHeight: 1.6, paddingLeft: 4, borderLeft: "2px solid var(--red-bd, #fca5a5)", marginBottom: i < budgetWarnings.length - 1 ? 6 : 0 }}>{w}</div>
              ))}
            </div>
          </div>
        )}
        <div>
          <FG label="Approval Comments (optional)">
            <textarea className="form-control" rows={3} placeholder="Add comments for the employee..." />
          </FG>
        </div>
        <div className="form-note">The employee will be notified via email upon approval.</div>
      </Shell>
    );
  }

  if (type === "reject") return (
    <Shell title={<span style={{ color: "var(--red)" }}>✗ Reject Expense</span>}
      footer={<><button className="btn btn-danger" onClick={doReject}><Mi icon="cancel" style={{ fontSize: 15 }} />Confirm </button><button className="btn" onClick={closeModal}>Cancel</button></>}>
      <InfoBox>Rejecting: <strong>{data}</strong></InfoBox>
      <FG label="Rejection Reason *"><textarea id="reject-reason" className="form-control" rows={3} placeholder="Provide a clear reason for rejection..." /></FG>
      <div className="form-note">The employee will be notified and may resubmit with corrections.</div>
    </Shell>
  );

  if (type === "reimburse") {
    const [emp = "Employee", amt = "₹0", ref = "REF"] = (data || "").split("|");
    const initials = emp.split(" ").map((w) => w[0]).join("").slice(0, 2);
    return (
      <Shell title="Process Reimbursement"
        footer={<><button className="btn btn-primary" onClick={doReimburse}><Mi icon="payments" style={{ fontSize: 15 }} />Process Payment</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
        <div className="modal-emp-row">
          <RiAv initials={initials} color="av-blue" size={40} />
          <div><div style={{ fontWeight: 700, fontSize: 14 }}>{emp}</div><div style={{ fontSize: 12, color: "var(--text3)", fontFamily: "var(--font2)" }}>{ref}</div></div>
          <div style={{ marginLeft: "auto", fontSize: 28, fontWeight: 800, color: "var(--text)" }}>{amt}</div>
        </div>
        <FR><FG label="Payment Mode"><select className="form-control"><option>BANK_TRANSFER (NEFT)</option><option>BANK_TRANSFER (IMPS)</option><option>CHEQUE</option><option>CASH</option></select></FG>
          <FG label="Payment Date"><input type="date" className="form-control" defaultValue={new Date().toISOString().slice(0, 10)} /></FG></FR>
        <FG label="Transaction Reference"><input ref={txnRefRef} type="text" className="form-control" placeholder="UTR number or cheque no." /></FG>
        <FG label="Remarks (optional)"><input type="text" className="form-control" placeholder="Internal note..." /></FG>
      </Shell>
    );
  }

  if (type === "view-slip") {
    const expense = (allExpenses || []).find(e => e.id === data);
    const claim = !expense ? ((allClaims || []).find(c => c.id === data)) : null;

    const downloadSlipPDF = (rows, filename, banner) => {
      const today = new Date().toLocaleDateString("en-IN");
      const rowsHtml = rows.map(([l, v]) =>
        `<td style="padding:10px 14px;vertical-align:top;width:50%">
           <div style="font-size:9px;color:#8E91A8;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;font-family:Arial,sans-serif">${l}</div>
           <div style="font-weight:600;font-size:12px;color:#13152B;font-family:Arial,sans-serif">${v}</div>
         </td>`
      );
      const tableRows = [];
      for (let i = 0; i < rowsHtml.length; i += 2) {
        tableRows.push(`<tr>${rowsHtml[i]}${rowsHtml[i + 1] || "<td></td>"}</tr>`);
      }
      const container = document.createElement("div");
      container.style.cssText = "position:absolute;left:0;top:0;width:640px;background:#fff;z-index:-1";
      container.innerHTML = `
        <div style="font-family:Arial,sans-serif;width:640px;background:#fff">
          <table style="width:100%;border-collapse:collapse">
            <tr>
              <td style="background:#2041CC;padding:18px 24px;vertical-align:top">
                <div style="font-size:20px;font-weight:800;color:#fff">Reimbursement Slip</div>
                <div style="font-size:11px;color:#C4CEFF;margin-top:4px">Generated: ${today}</div>
              </td>
              <td style="background:#2041CC;padding:18px 24px;text-align:right;vertical-align:top">
                <span style="background:#EEF1FF;color:#2041CC;padding:5px 14px;border-radius:20px;font-size:11px;font-weight:700;display:inline-block">REIMBURSED</span>
              </td>
            </tr>
          </table>
          <div style="border:1px solid #DDE0EE;border-top:none;padding:20px">
            <table style="width:100%;border-collapse:collapse">${tableRows.join("")}</table>
            <div style="background:#F0FDF4;border:1px solid #86EFAC;border-radius:8px;padding:12px 16px;color:#166634;font-weight:700;text-align:center;font-size:13px;margin-top:16px">&#10003; ${banner}</div>
          </div>
        </div>
      `;
      document.body.appendChild(container);
      html2canvas(container, { scale: 2, useCORS: true, backgroundColor: "#ffffff", width: 640, windowWidth: 640 })
        .then(canvas => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
          const pageWidth = pdf.internal.pageSize.getWidth();
          const imgHeight = (canvas.height * pageWidth) / canvas.width;
          pdf.addImage(imgData, "PNG", 0, 0, pageWidth, imgHeight);
          pdf.save(`${filename}.pdf`);
          showToast("Slip downloaded", "t-success");
        })
        .finally(() => document.body.removeChild(container));
    };

    if (expense) {
      return (
        <Shell title="Reimbursement Slip"
          footer={<><button className="btn btn-primary" onClick={() => downloadSlipPDF([["Expense ID", expense.id], ["Employee", expense.employee || "—"], ["Title", expense.title || "—"], ["Category", expense.category || "—"], ["Amount", fmtAmt(expense.amount)], ["Expense Date", expense.date || "—"], ["Reimbursement Date", fmtDate(expense.reimbursedAt || expense.paidDate) !== "—" ? fmtDate(expense.reimbursedAt || expense.paidDate) : new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })], ["Payment Mode", expense.payment || "—"], ["Transaction Ref", expense.transactionRef || "—"]], expense.id || "reimbursement-slip", "Expense reimbursed successfully")}><Mi icon="download" style={{ fontSize: 15 }} />Download PDF</button><button className="btn" onClick={closeModal}>Close</button></>}>
          <div style={{ padding: "4px 0" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid var(--accent)", paddingBottom: 12, marginBottom: 16 }}>
              <div><div style={{ fontWeight: 800, fontSize: 18, color: "var(--accent)" }}>Reimbursement Slip</div><div style={{ fontSize: 12, color: "var(--text3)", fontFamily: "var(--font2)", marginTop: 2 }}>Generated {new Date().toLocaleDateString("en-IN")}</div></div>
              <Pill variant="p-reimbursed">Reimbursed</Pill>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 20px", fontSize: 13 }}>
              {[["Expense ID", expense.id], ["Employee", expense.employee || "—"], ["Title", expense.title || "—"], ["Category", expense.category || "—"], ["Amount", fmtAmt(expense.amount)], ["Expense Date", expense.date || "—"], ["Reimbursement Date", fmtDate(expense.reimbursedAt || expense.paidDate) !== "—" ? fmtDate(expense.reimbursedAt || expense.paidDate) : new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })], ["Payment Mode", expense.payment || "—"], ["Transaction Ref", expense.transactionRef || "—"]].map(([l, v]) => (<div key={l}><div style={{ fontSize: 10, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 2 }}>{l}</div><div style={{ fontWeight: 600 }}>{v}</div></div>
              ))}
            </div>
            <div style={{ marginTop: 14, padding: "10px 14px", background: "var(--green-bg)", border: "1px solid var(--green-bd)", borderRadius: 8, color: "var(--green)", fontWeight: 700, textAlign: "center", fontSize: 13 }}>✓ Expense reimbursed successfully</div>
          </div>
        </Shell>
      );
    }

    if (claim) {
      return (
        <Shell title="Reimbursement Slip"
          footer={<><button className="btn btn-primary" onClick={() => downloadSlipPDF([["Claim ID", claim.id], ["Employee", claim.employee || "—"], ["Title", claim.title || "—"], ["Period", claim.period || "—"], ["Total Amount", fmtAmt(claim.total)], ["Items", String(claim.items || "—")], ["Reimbursement Date", fmtDate(claim.reimbursedAt || claim.paidDate) !== "—" ? fmtDate(claim.reimbursedAt || claim.paidDate) : new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })]], claim.id || "claim-slip", "Claim reimbursed successfully")}><Mi icon="download" style={{ fontSize: 15 }} />Download PDF</button><button className="btn" onClick={closeModal}>Close</button></>}>
          <div style={{ padding: "4px 0" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid var(--accent)", paddingBottom: 12, marginBottom: 16 }}>
              <div><div style={{ fontWeight: 800, fontSize: 18, color: "var(--accent)" }}>Reimbursement Slip</div><div style={{ fontSize: 12, color: "var(--text3)", fontFamily: "var(--font2)", marginTop: 2 }}>Generated {new Date().toLocaleDateString("en-IN")}</div></div>
              <Pill variant="p-reimbursed">Reimbursed</Pill>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 20px", fontSize: 13 }}>
              {[["Claim ID", claim.id], ["Employee", claim.employee || "—"], ["Title", claim.title || "—"], ["Period", claim.period || "—"], ["Total Amount", fmtAmt(claim.total)], ["Items", String(claim.items || "—")], ["Reimbursement Date", fmtDate(claim.reimbursedAt || claim.paidDate) !== "—" ? fmtDate(claim.reimbursedAt || claim.paidDate) : new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })]].map(([l, v]) => (<div key={l}><div style={{ fontSize: 10, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 2 }}>{l}</div><div style={{ fontWeight: 600 }}>{v}</div></div>
              ))}
            </div>
            <div style={{ marginTop: 14, padding: "10px 14px", background: "var(--green-bg)", border: "1px solid var(--green-bd)", borderRadius: 8, color: "var(--green)", fontWeight: 700, textAlign: "center", fontSize: 13 }}>✓ Claim reimbursed successfully</div>
          </div>
        </Shell>
      );
    }

    return (
      <Shell title="Reimbursement Slip" footer={<><button className="btn" onClick={closeModal}>Close</button></>}>
        <div style={{ padding: 24, textAlign: "center", color: "var(--text3)" }}>Slip data not found.</div>
      </Shell>
    );
  }

  if (type === "view-claim") {
    const claim = (allClaims || []).find(c => c.id === data);
    if (!claim) return (
      <Shell title="Claim Details" footer={<button className="btn" onClick={closeModal}>Close</button>}>
        <div style={{ padding: 24, textAlign: "center", color: "var(--text3)" }}>Claim not found.</div>
      </Shell>
    );
    return (
      <Shell title="Claim Details" footer={<button className="btn" onClick={closeModal}>Close</button>}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid var(--border)" }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: 18, color: "var(--accent)" }}>{claim.title || "Expense Claim"}</div>
            <div style={{ fontSize: 12, color: "var(--text3)", fontFamily: "var(--font2)", marginTop: 2 }}>{claim.id}</div>
          </div>
          <Pill variant={statusVariant(claim.status)}>{claim.statusLabel || claim.status}</Pill>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 20px", fontSize: 13 }}>
          {[["Employee", claim.employee || "—"], ["Period", claim.period || "—"], ["Total Amount", fmtAmt(claim.total)], ["Expenses", `${claim.items || 0} item${claim.items !== 1 ? "s" : ""}`], ["Status", claim.statusLabel || claim.status || "—"]].map(([l, v]) => (
            <div key={l}><div style={{ fontSize: 10, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 3 }}>{l}</div><div style={{ fontWeight: 600 }}>{v}</div></div>
          ))}
          {claim.notes && <div style={{ gridColumn: "span 2" }}><div style={{ fontSize: 10, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 3 }}>Notes</div><div style={{ fontWeight: 500, whiteSpace: "pre-wrap", color: "var(--text2)" }}>{claim.notes}</div></div>}
        </div>
        {claim.rejectionReason && (
          <div style={{ display: "flex", gap: 10, padding: "12px 14px", background: "var(--red-bg, #fef2f2)", border: "1px solid var(--red-bd, #fca5a5)", borderRadius: 8, marginTop: 16, color: "var(--red)" }}>
            <Mi icon="cancel" /><div><div style={{ fontWeight: 600, marginBottom: 2 }}>Rejection Reason</div><div style={{ color: "var(--text2)", fontWeight: 400 }}>{claim.rejectionReason}</div></div>
          </div>
        )}
      </Shell>
    );
  }

  if (type === "view-int-slip") {
    const ie = (internalExpenses || []).find(e => e.internalId === data);

    const downloadIntPDF = () => {
      if (!ie) return;
      const today = new Date().toLocaleDateString("en-IN");
      const rows = [
        ["Bill / Ref", ie.internalId || "—"],
        ["Title", ie.title || "—"],
        ["Type", ie.type ? ie.type.charAt(0) + ie.type.slice(1).toLowerCase() : "—"],
        ["Vendor", ie.vendor || "—"],
        ["Amount", fmtAmt(ie.amount)],
        ["Bill Month", ie.billMonth || "—"],
        ["Due Date", fmtDate(ie.dueDate)],
        ["Paid Date", fmtDate(ie.paidDate)],
        ["Transaction Ref", ie.transactionRef || "—"],
        ["Notes", ie.notes || "—"],
      ];
      const rowsHtml = rows.map(([l, v]) =>
        `<td style="padding:10px 14px;vertical-align:top;width:50%">
           <div style="font-size:9px;color:#8E91A8;text-transform:uppercase;letter-spacing:.5px;margin-bottom:3px;font-family:Arial,sans-serif">${l}</div>
           <div style="font-weight:600;font-size:12px;color:#13152B;font-family:Arial,sans-serif">${v}</div>
         </td>`
      );
      const tableRows = [];
      for (let i = 0; i < rowsHtml.length; i += 2) {
        tableRows.push(`<tr>${rowsHtml[i]}${rowsHtml[i + 1] || "<td></td>"}</tr>`);
      }
      const container = document.createElement("div");
      container.style.cssText = "position:absolute;left:0;top:0;width:640px;background:#fff;z-index:-1";
      container.innerHTML = `
        <div style="font-family:Arial,sans-serif;width:640px;background:#fff">
          <table style="width:100%;border-collapse:collapse">
            <tr>
              <td style="background:#2041CC;padding:18px 24px;vertical-align:top">
                <div style="font-size:20px;font-weight:800;color:#fff">Payment Receipt</div>
                <div style="font-size:11px;color:#C4CEFF;margin-top:4px">Generated: ${today}</div>
              </td>
              <td style="background:#2041CC;padding:18px 24px;text-align:right;vertical-align:top">
                <span style="background:#EEF1FF;color:#2041CC;padding:5px 14px;border-radius:20px;font-size:11px;font-weight:700;display:inline-block">PAID</span>
              </td>
            </tr>
          </table>
          <div style="border:1px solid #DDE0EE;border-top:none;padding:20px">
            <table style="width:100%;border-collapse:collapse">${tableRows.join("")}</table>
            <div style="background:#F0FDF4;border:1px solid #86EFAC;border-radius:8px;padding:12px 16px;color:#166634;font-weight:700;text-align:center;font-size:13px;margin-top:16px">&#10003; Bill paid successfully</div>
          </div>
        </div>
      `;
      document.body.appendChild(container);
      html2canvas(container, { scale: 2, useCORS: true, backgroundColor: "#ffffff", width: 640, windowWidth: 640 })
        .then(canvas => {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
          const pageWidth = pdf.internal.pageSize.getWidth();
          const imgHeight = (canvas.height * pageWidth) / canvas.width;
          pdf.addImage(imgData, "PNG", 0, 0, pageWidth, imgHeight);
          pdf.save(`${ie.internalId || "receipt"}.pdf`);
          showToast("Receipt downloaded", "t-success");
        })
        .finally(() => document.body.removeChild(container));
    };

    if (!ie) return (
      <Shell title="Payment Receipt" footer={<><button className="btn" onClick={closeModal}>Close</button></>}>
        <div style={{ padding: 24, textAlign: "center", color: "var(--text3)" }}>Receipt data not found.</div>
      </Shell>
    );

    return (
      <Shell title="Payment Receipt"
        footer={<><button className="btn btn-primary" onClick={downloadIntPDF}><Mi icon="download" style={{ fontSize: 15 }} />Download PDF</button><button className="btn" onClick={closeModal}>Close</button></>}>
        <div style={{ padding: "4px 0" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid var(--accent)", paddingBottom: 12, marginBottom: 16 }}>
            <div><div style={{ fontWeight: 800, fontSize: 18, color: "var(--accent)" }}>Payment Receipt</div><div style={{ fontSize: 12, color: "var(--text3)", fontFamily: "var(--font2)", marginTop: 2 }}>Generated {new Date().toLocaleDateString("en-IN")}</div></div>
            <Pill variant="p-reimbursed">Paid</Pill>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 20px", fontSize: 13 }}>
            {[["Bill / Ref", ie.internalId], ["Title", ie.title || "—"], ["Type", ie.type ? ie.type.charAt(0) + ie.type.slice(1).toLowerCase() : "—"], ["Vendor", ie.vendor || "—"], ["Amount", fmtAmt(ie.amount)], ["Bill Month", ie.billMonth || "—"], ["Due Date", fmtDate(ie.dueDate)], ["Paid Date", fmtDate(ie.paidDate)], ["Transaction Ref", ie.transactionRef || "—"], ["Notes", ie.notes || "—"]].map(([l, v]) => (
              <div key={l}><div style={{ fontSize: 10, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 2 }}>{l}</div><div style={{ fontWeight: 600 }}>{v}</div></div>
            ))}
          </div>
          <div style={{ marginTop: 14, padding: "10px 14px", background: "var(--green-bg)", border: "1px solid var(--green-bd)", borderRadius: 8, color: "var(--green)", fontWeight: 700, textAlign: "center", fontSize: 13 }}>✓ Bill paid successfully</div>
        </div>
      </Shell>
    );
  }

  if (type === "view-receipt") {
    const exp = (allExpenses || []).find(e => e.id === data);
    if (!exp || !exp.receiptBase64) return (
      <Shell title="Receipt" footer={<><button className="btn" onClick={closeModal}>Close</button></>}>
        <div style={{ padding: 24, textAlign: "center", color: "var(--text3)" }}>No document attached to this expense.</div>
      </Shell>
    );
    const rawBase64 = exp.receiptBase64;
    let dataUri = rawBase64;
    if (!rawBase64.startsWith("data:")) {
      const ext = (exp.receiptFileName || "").split(".").pop().toLowerCase();
      const mime = ext === "pdf" ? "application/pdf" : ext === "png" ? "image/png" : "image/jpeg";
      dataUri = `data:${mime};base64,${rawBase64}`;
    }
    const isImage = dataUri.startsWith("data:image/");
    const isPDF = dataUri.startsWith("data:application/pdf");
    return (
      <Shell title={`Receipt — ${exp.receiptFileName || exp.id}`} size="modal-lg"
        footer={<>
          <a href={dataUri} download={exp.receiptFileName || "receipt"} className="btn btn-primary"><Mi icon="download" style={{ fontSize: 15 }} />Download</a>
          <button className="btn" onClick={closeModal}>Close</button>
        </>}>
        {isImage && (
          <div style={{ textAlign: "center", padding: "4px 0" }}>
            <img src={dataUri} alt="Receipt" style={{ maxWidth: "100%", maxHeight: 480, borderRadius: 8, border: "1px solid var(--border)" }} />
          </div>
        )}
        {isPDF && (
          <iframe src={dataUri} title="Receipt PDF" style={{ width: "100%", height: 480, border: "1px solid var(--border)", borderRadius: 8 }} />
        )}
        {!isImage && !isPDF && (
          <div style={{ textAlign: "center", padding: 32 }}>
            <Mi icon="insert_drive_file" style={{ fontSize: 48, color: "var(--text3)" }} />
            <div style={{ marginTop: 8, fontWeight: 600 }}>{exp.receiptFileName || "Document"}</div>
            <div style={{ fontSize: 12, color: "var(--text3)", marginTop: 4 }}>Use the Download button to view this file.</div>
          </div>
        )}
      </Shell>
    );
  }

  if (type === "bulk-approve") {
    const baL2 = (allExpenses || []).filter(e => e.status === "Pending L2");
    const baL1 = (allExpenses || []).filter(e => e.status === "Pending L1");
    const baClm = (allClaims || []).filter(c => c.status === "Pending" || c.status === "Pending L2");
    const baTotal = [...baL2, ...baL1].reduce((s, e) => s + Number(e.amount || 0), 0);
    const rowStyle = { display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", background: "var(--surface2)", borderRadius: 8, fontSize: 13 };
    return (
      <Shell title={`Bulk Approve (${baL2.length + baL1.length + baClm.length} items)`}
        footer={<><button className="btn btn-success" onClick={doBulkApprove}><Mi icon="done_all" style={{ fontSize: 15 }} />Approve All</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
        <InfoBox>Review the pending items below. All will be approved in one action.</InfoBox>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {baL2.length > 0 && (
            <div style={rowStyle}>
              <Mi icon="task_alt" style={{ color: "var(--accent)", fontSize: 18 }} />
              <span style={{ fontWeight: 600, minWidth: 28 }}>{baL2.length}</span>
              <span style={{ color: "var(--text2)", flex: 1 }}>Expense{baL2.length !== 1 ? "s" : ""} awaiting L2 (Admin) approval</span>
              <span style={{ fontWeight: 600 }}>{fmtAmt(baL2.reduce((s, e) => s + Number(e.amount || 0), 0))}</span>
            </div>
          )}
          {baL1.length > 0 && (
            <div style={rowStyle}>
              <Mi icon="pending_actions" style={{ color: "var(--amber)", fontSize: 18 }} />
              <span style={{ fontWeight: 600, minWidth: 28 }}>{baL1.length}</span>
              <span style={{ color: "var(--text2)", flex: 1 }}>Expense{baL1.length !== 1 ? "s" : ""} awaiting L1 (Manager) approval</span>
              <span style={{ fontWeight: 600 }}>{fmtAmt(baL1.reduce((s, e) => s + Number(e.amount || 0), 0))}</span>
            </div>
          )}
          {baClm.length > 0 && (
            <div style={rowStyle}>
              <Mi icon="receipt_long" style={{ color: "var(--violet)", fontSize: 18 }} />
              <span style={{ fontWeight: 600, minWidth: 28 }}>{baClm.length}</span>
              <span style={{ color: "var(--text2)", flex: 1 }}>Expense claim{baClm.length !== 1 ? "s" : ""} pending review</span>
              <span style={{ fontWeight: 600 }}>—</span>
            </div>
          )}
          {(baL2.length + baL1.length + baClm.length) === 0 && (
            <div style={{ textAlign: "center", color: "var(--text3)", padding: 20 }}>No pending items to approve.</div>
          )}
        </div>
        {(baL2.length + baL1.length) > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 14px", borderTop: "1px solid var(--border)", marginTop: 4, fontWeight: 700, fontSize: 14 }}>
            <span>Total Amount</span>
            <span style={{ color: "var(--accent)" }}>{fmtAmt(baTotal)}</span>
          </div>
        )}
      </Shell>
    );
  }

  if (type === "process-all") return (
    <Shell title="Process All Reimbursements"
      footer={<><button className="btn btn-primary" onClick={doProcessAll}><Mi icon="payments" style={{ fontSize: 15 }} />Process All ({fmtAmt(processAllTotal)})</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
      <InfoBox>This will process payments for all <strong>{pendingReimb.length}</strong> approved employee{pendingReimb.length !== 1 ? "s" : ""}. Total: <strong>{fmtAmt(processAllTotal)}</strong></InfoBox>
      <FR><FG label="Payment Mode"><select className="form-control"><option>BANK_TRANSFER (NEFT)</option><option>BANK_TRANSFER (IMPS)</option></select></FG>
        <FG label="Payment Date"><input type="date" className="form-control" defaultValue={new Date().toISOString().slice(0, 10)} /></FG></FR>
      <FG label="Batch Reference"><input type="text" className="form-control" placeholder="Batch UTR or reference..." /></FG>
    </Shell>
  );

  if (type === "credit-petty") return (
    <Shell title="Credit Petty Cash"
      footer={<><button className="btn btn-success" onClick={doCreditPetty}><Mi icon="add_circle" style={{ fontSize: 15 }} />Save</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
      <InfoBox>Account: <strong>{pcAccount.name || "Petty Cash"}</strong> · Current balance: <strong>{fmtAmt(pcAccount.balance)}</strong></InfoBox>
      <FR><FG label="Credit Amount (₹)"><input ref={creditAmountRef} type="number" className="form-control" placeholder="Enter amount" min="0" step="0.01" /></FG>
        <FG label="Credit Date"><input ref={creditDateRef} type="date" className="form-control" defaultValue={new Date().toISOString().slice(0, 10)} /></FG></FR>
      <FG label="Description"><input ref={creditDescRef} type="text" className="form-control" placeholder="e.g. Monthly top-up from company account" /></FG>
      <FG label="Source Account"><input ref={creditSourceRef} type="text" className="form-control" placeholder="Company bank account / reference" /></FG>
    </Shell>
  );

  if (type === "mark-paid") return (
    <Shell title="Mark Bill as Paid"
      footer={<><button className="btn btn-primary" onClick={doMarkPaid}><Mi icon="check_circle" style={{ fontSize: 15 }} />Save</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
      <InfoBox>Marking as PAID: <strong>{data}</strong></InfoBox>
      <FR><FG label="Payment Mode"><select ref={markPaidModeRef} className="form-control"><option value="COMPANY_ACCOUNT">COMPANY_ACCOUNT</option><option value="NEFT">NEFT</option><option value="UPI">UPI</option><option value="CHEQUE">CHEQUE</option><option value="PETTY_CASH">PETTY_CASH</option></select></FG>
        <FG label="Paid Date"><input type="date" className="form-control" defaultValue={new Date().toISOString().slice(0, 10)} /></FG></FR>
      <FG label="Transaction Reference"><input ref={markPaidTxnRef} type="text" className="form-control" placeholder="UTR / transaction ID..." /></FG>
      <FG label="Remarks"><input type="text" className="form-control" placeholder="Optional note..." /></FG>
    </Shell>
  );

  if (type === "new-expense") return (
    <Shell title="New Employee Expense" size="modal-lg"
      footer={<><button className="btn btn-primary" onClick={doSaveNewExpense}><Mi icon="send" style={{ fontSize: 15 }} />Save</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
      <FR><FG label="Title *"><input ref={titleRef} type="text" className="form-control" placeholder="e.g. Client visit — Mumbai" /></FG>
        <FG label="Category *">
          <select ref={categoryRef} className="form-control">
            <option value="">— Select Category —</option>
            {(expenseCategories || []).filter(c => c.active).map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </FG></FR>
      <FR><FG label="Amount (₹) *"><input ref={amountRef} type="number" className="form-control" placeholder="0.00" min="0" /></FG>
        <FG label="Expense Date *"><input ref={expDateRef} type="date" className="form-control" defaultValue={new Date().toISOString().slice(0, 10)} /></FG></FR>
      <FR><FG label="Payment Mode"><select ref={paymentRef} className="form-control"><option value="PERSONAL_CARD">Personal Card</option><option value="CASH">Cash</option><option value="COMPANY_CARD">Company Card</option><option value="UPI">UPI</option></select></FG>
        <FG label="Project (optional)"><input ref={projectRef} type="text" className="form-control" placeholder="Project name (optional)" /></FG></FR>
      <FG label="Employee">
        <EmployeeDropdown employees={employees} value={selectedEmployee} onChange={setSelectedEmployee} />
      </FG>
      <FG label="Description / Notes"><textarea ref={descRef} className="form-control" rows={3} placeholder="Add details about the expense..." /></FG>
      <FG label="Attach Receipt (max 1 MB)"><input ref={receiptRef} type="file" className="form-control" accept="image/*,.pdf" onChange={e => { const f = e.target.files?.[0]; if (f && f.size > 1048576) { showToast("File must be 1 MB or less", "t-error"); e.target.value = ""; } }} /></FG>
    </Shell>
  );

  if (type === "new-internal") {
    const filteredIntCats = (intCategories || []).filter(c => c.active && (!selectedIntType || c.type === selectedIntType));
    return (
      <Shell title="New Internal Expense" size="modal-lg"
        footer={<><button className="btn btn-primary" onClick={doSaveNewInternal}><Mi icon="save" style={{ fontSize: 15 }} />Save</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
        <FG label="Title *">
          <input ref={intExpTitleRef} type="text" className="form-control" placeholder="e.g. Office Electricity Bill — May 2026" />
        </FG>
        <ModalFR>
          <FG label="Type *">
            <select ref={intExpTypeRef} className="form-control" value={selectedIntType}
              onChange={e => { setSelectedIntType(e.target.value); if (intExpCategoryRef.current) intExpCategoryRef.current.value = ""; }}>
              <option value="" disabled>— Select type —</option>
              {distinctTypes.length > 0
                ? distinctTypes.map(t => <option key={t} value={t}>{t.charAt(0) + t.slice(1).toLowerCase()}</option>)
                : ["UTILITY", "GROCERY", "RENT", "MAINTENANCE", "MISC"].map(t => <option key={t} value={t}>{t.charAt(0) + t.slice(1).toLowerCase()}</option>)
              }
            </select>
          </FG>
          <FG label="Category">
            <select ref={intExpCategoryRef} className="form-control" defaultValue="">
              <option value="">— None —</option>
              {filteredIntCats.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
            </select>
          </FG>
        </ModalFR>
        <ModalFR>
          <FG label="Amount (₹) *">
            <input ref={intExpAmountRef} type="number" className="form-control" placeholder="0.00" min="0" step="0.01" />
          </FG>
          <FG label="Vendor">
            <input ref={intExpVendorRef} type="text" className="form-control" placeholder="Vendor name" />
          </FG>
        </ModalFR>
        <FG label="Due Date">
          <input ref={intExpDueDateRef} type="date" className="form-control" />
        </FG>
        <FG label="Employee (optional)">
          <EmployeeDropdown employees={employees} value={selectedEmployee} onChange={setSelectedEmployee} />
        </FG>
        <FG label="Notes">
          <textarea ref={intExpNotesRef} className="form-control" rows={3} placeholder="Additional details..." />
        </FG>
      </Shell>
    );
  }

  if (type === "add-utility") return (
    <Shell title="Add Utility Bill"
      footer={<><button className="btn btn-primary" onClick={doSaveUtility}>Save</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
      <FG label="Vendor *"><input ref={utilVendorRef} type="text" className="form-control" placeholder="Vendor name" /></FG>
      <FR><FG label="Type"><select ref={utilCategoryRef} className="form-control"><option value="ELECTRICITY">Electricity</option><option value="INTERNET">Internet</option><option value="WATER">Water</option><option value="GAS">Gas</option><option value="PHONE">Landline</option></select></FG>
        <FG label="Amount (₹) *"><input ref={utilAmountRef} type="number" className="form-control" min="0" step="0.01" /></FG></FR>
      <FR><FG label="Due Date"><input ref={utilDueDateRef} type="date" className="form-control" /></FG>
        <FG label="Period"><input ref={utilPeriodRef} type="text" className="form-control" placeholder="e.g. May 2026" /></FG></FR>
      <FG label="Meter / Account No."><input ref={utilAccountRef} type="text" className="form-control" placeholder="Meter or account reference" /></FG>
    </Shell>
  );

  if (type === "add-grocery") {
    const grocCats = (intCategories || []).filter(c => c.type === "GROCERY");
    return (
      <Shell title="Add Grocery / Supplies"
        footer={<><button className="btn btn-primary" onClick={doSaveGrocery}>Save</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
        <FG label="Description *"><input ref={grocTitleRef} type="text" className="form-control" placeholder="e.g. Office snacks, Cleaning supplies" /></FG>
        <FR>
          <FG label="Category">
            <select ref={grocCatRef} className="form-control">
              <option value="">— Select —</option>
              {grocCats.length > 0
                ? grocCats.map(c => <option key={c.id} value={c.name}>{c.name}</option>)
                : ["Groceries", "Stationery", "Cleaning", "Beverages", "Miscellaneous"].map(c => <option key={c} value={c}>{c}</option>)
              }
            </select>
          </FG>
          <FG label="Vendor / Store"><input ref={grocVendorRef} type="text" className="form-control" placeholder="Store or vendor name" /></FG>
        </FR>
        <FR>
          <FG label="Amount (₹) *"><input ref={grocAmtRef} type="number" className="form-control" min="0" step="0.01" /></FG>
          <FG label="Purchase Date"><input ref={grocDateRef} type="date" className="form-control" /></FG>
        </FR>
        {/* <FG label="Bill / Invoice No."><input ref={grocBillRef} type="text" className="form-control" placeholder="Optional bill reference" /></FG> */}
        <FG label="Notes"><textarea ref={grocNotesRef} className="form-control" rows={2} placeholder="Additional notes" /></FG>
      </Shell>
    );
  }

  if (type === "add-category") return (
    <Shell title={data?.id ? "Edit Category" : "Add Category"}
      footer={<><button className="btn btn-primary" onClick={doSaveCategory}><Mi icon="save" style={{ fontSize: 15 }} />{data?.id ? "Update" : "Create"}</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
      <FG label="Category Name">
        <input ref={catNameRef} type="text" className="form-control" placeholder="e.g. Travel" defaultValue={data?.name || ""} />
      </FG>
    </Shell>
  );

  if (type === "add-int-category") return (
    <Shell title={data?.id ? "Edit Internal Category" : "Add Internal Category"}
      footer={<><button className="btn btn-primary" onClick={doSaveIntCategory}><Mi icon="save" style={{ fontSize: 15 }} />{data?.id ? "Update" : "Create"}</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
      <FG label="Name *">
        <input ref={intCatNameRef} type="text" className="form-control" placeholder="e.g. Electricity, Health Insurance" defaultValue={data?.name || ""} />
      </FG>
      <FG label="Type">
        <select ref={intCatTypeRef} className="form-control"
          value={selectedCatType || data?.type || ""}
          onChange={e => setSelectedCatType(e.target.value)}>
          <option value="">— Select type —</option>
          {distinctTypes.length > 0
            ? distinctTypes.map(t => <option key={t} value={t}>{t.charAt(0) + t.slice(1).toLowerCase()}</option>)
            : ["UTILITY", "RENT", "MAINTENANCE", "GROCERY", "MISC"].map(t => <option key={t} value={t}>{t.charAt(0) + t.slice(1).toLowerCase()}</option>)
          }
          <option value="__OTHER__">Other (custom)...</option>
        </select>
        {selectedCatType === "__OTHER__" && (
          <input type="text" className="form-control" style={{ marginTop: 6 }}
            placeholder="Enter new type e.g. BENEFIT"
            value={customType} onChange={e => setCustomType(e.target.value.toUpperCase())} />
        )}
      </FG>
    </Shell>
  );

  if (type === "add-budget") {
    const activeCats = (expenseCategories || []).filter(c => c.active);
    return (
      <Shell title={data?.id ? "Edit Budget" : "Add Budget"}
        footer={<><button className="btn btn-primary" onClick={doSaveBudget}><Mi icon="save" style={{ fontSize: 15 }} />Save</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
        <FR>
          <FG label="Department">
            <DeptDropdown departments={departments} value={budgetDept} onChange={setBudgetDept} />
          </FG>
          <FG label="Category (optional)">
            <select ref={budgetCatRef} className="form-control" defaultValue={data?.category || ""}>
              <option value="">Select</option>
              {activeCats.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
            </select>
          </FG>
        </FR>
        <FR><FG label="Allocated (₹)"><input ref={budgetAmtRef} type="number" className="form-control" defaultValue={data?.allocatedAmount || ""} min="0" step="0.01" /></FG>
          <FG label="Period"><input ref={budgetPeriodRef} type="month" className="form-control" defaultValue={data?.period || new Date().toISOString().slice(0, 7)} /></FG></FR>
        <FG label="Notes (optional)"><textarea ref={budgetNotesRef} className="form-control" rows={2} placeholder="Budget notes..." defaultValue={data?.notes || ""} /></FG>
      </Shell>
    );
  }


  if (type === "request-info") return (
    <Shell title="Request More Information"
      footer={<><button className="btn btn-primary" onClick={doRequestInfo}><Mi icon="send" style={{ fontSize: 15 }} />Send Request</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
      <InfoBox>Requesting info for: <strong>{data}</strong></InfoBox>
      <FG label="Information Required"><textarea ref={reqInfoRef} className="form-control" rows={4} placeholder="Specify what additional info or documents are needed..." /></FG>
    </Shell>
  );

  if (type === "delegate") return (
    <Shell title="Delegate Approval"
      footer={<><button className="btn btn-primary" onClick={doSave}>Delegate</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
      <InfoBox>Delegating: <strong>{data}</strong></InfoBox>
      <FG label="Delegate To"><select className="form-control"><option>Ravi Sharma (Finance Manager)</option><option>Aditi Patil (HR Head)</option><option>Sanjay Kulkarni (Operations Head)</option></select></FG>
      <FG label="Notes"><textarea className="form-control" rows={3} placeholder="Reason for delegation..." /></FG>
    </Shell>
  );

  if (type === "view-info") {
    const exp = (allExpenses || []).find(e => e.id === data);
    const intExp = (internalExpenses || []).find(e => e.internalId === data);

    if (intExp) {
      return (
        <Shell title="Internal Expense Details"
          footer={<>
            {intExp.status === "Paid" && <button className="btn btn-primary" onClick={() => onModal("view-int-slip", intExp.internalId)}><Mi icon="receipt" style={{ fontSize: 15 }} />View Receipt</button>}
            <button className="btn" onClick={closeModal}>Close</button>
          </>}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "1px solid var(--border)", paddingBottom: 12, marginBottom: 16 }}>
            <div><div style={{ fontWeight: 800, fontSize: 18, color: "var(--accent)" }}>{intExp.title || "Internal Expense"}</div><div style={{ fontSize: 12, color: "var(--text3)", fontFamily: "var(--font2)", marginTop: 2 }}>{intExp.internalId}</div></div>
            <Pill variant={statusVariant(intExp.status)}>{intExp.status}</Pill>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 20px", fontSize: 13 }}>
            {[["Type", intExp.type ? intExp.type.charAt(0) + intExp.type.slice(1).toLowerCase() : "—"], ["Category", intExp.category || "—"], ["Vendor", intExp.vendor || "—"], ["Amount", fmtAmt(intExp.amount)], ["Bill Month", intExp.billMonth || "—"], ["Due Date", fmtDate(intExp.dueDate)], ["Paid Date", fmtDate(intExp.paidDate)], ["Transaction Ref", intExp.transactionRef || "—"]].map(([l, v]) => (
              <div key={l}><div style={{ fontSize: 10, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 2 }}>{l}</div><div style={{ fontWeight: 600 }}>{v}</div></div>
            ))}
            <div style={{ gridColumn: "span 2" }}><div style={{ fontSize: 10, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 2 }}>Notes</div><div style={{ fontWeight: 600, whiteSpace: "pre-wrap" }}>{intExp.notes || "—"}</div></div>
          </div>
        </Shell>
      );
    }
    if (exp) {
      const mgr = exp.approvedByManager || "Manager";
      const admin = exp.approvedByAdmin || "Admin";
      const txnRef = exp.transactionRef || "—";
      const s = exp.status || "";
      const isReimb = s === "Reimbursed";
      const isApproved = s === "Approved";
      const isRejected = s === "Rejected";
      const isInfo = s === "Info Requested";
      const isPendingL2 = s === "Pending L2";

      const trailSteps = isReimb ? [
        { color: "var(--green)", icon: "check", label: "Submitted", sub: fmtDate(exp.date) },
        { color: "var(--green)", icon: "check", label: "L1 Approved", sub: mgr },
        { color: "var(--green)", icon: "check", label: "L2 Approved", sub: admin },
        { color: "var(--green)", icon: "check", label: "Reimbursed", sub: `Ref: ${txnRef}` },
      ] : isApproved ? [
        { color: "var(--green)", icon: "check", label: "Submitted", sub: fmtDate(exp.date) },
        { color: "var(--green)", icon: "check", label: "L1 Approved", sub: mgr },
        { color: "var(--green)", icon: "check", label: "L2 Approved", sub: admin },
        { color: "var(--violet)", icon: "schedule", label: "Reimbursement", sub: "Scheduled" },
      ] : isRejected ? [
        { color: "var(--green)", icon: "check", label: "Submitted", sub: fmtDate(exp.date) },
        { color: "var(--red)", icon: "cancel", label: "Rejected", sub: mgr },
      ] : isInfo ? [
        { color: "var(--green)", icon: "check", label: "Submitted", sub: fmtDate(exp.date) },
        { color: "var(--amber)", icon: "info", label: "Clarification Requested", sub: mgr },
        { color: "#ccc", icon: "hourglass_empty", label: "L2 Review", sub: "Not started" },
        { color: "#ccc", icon: "payments", label: "Reimbursement", sub: "Pending" },
      ] : isPendingL2 ? [
        { color: "var(--green)", icon: "check", label: "Submitted", sub: fmtDate(exp.date) },
        { color: "var(--green)", icon: "check", label: "L1 Approved", sub: mgr },
        { color: "var(--amber)", icon: "schedule", label: "L2 Review", sub: "Pending" },
        { color: "#ccc", icon: "payments", label: "Reimbursement", sub: "Pending" },
      ] : [
        { color: "var(--green)", icon: "check", label: "Submitted", sub: fmtDate(exp.date) },
        { color: "var(--amber)", icon: "schedule", label: "L1 Review", sub: "Pending" },
        { color: "#ccc", icon: "hourglass_empty", label: "L2 Review", sub: "Not started" },
        { color: "#ccc", icon: "payments", label: "Reimbursement", sub: "Pending" },
      ];

      const receiptBlock = (() => {
        if (!exp.receiptFileName) return null;
        if (!exp.receiptBase64) return (
          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: 8 }}>
            <Mi icon="attach_file" style={{ fontSize: 22, color: "var(--text3)" }} />
            <span style={{ fontSize: 13, color: "var(--text2)" }}>{exp.receiptFileName}</span>
          </div>
        );
        const ext = exp.receiptFileName.split(".").pop().toLowerCase();
        const isImg = ["jpg", "jpeg", "png"].includes(ext);
        const mime = isImg ? `image/${ext === "jpg" ? "jpeg" : ext}` : "application/pdf";
        const dataUrl = exp.receiptBase64.startsWith("data:") ? exp.receiptBase64 : `data:${mime};base64,${exp.receiptBase64}`;
        return isImg ? (
          <div>
            <img src={dataUrl} alt={exp.receiptFileName} style={{ maxWidth: "100%", maxHeight: 280, borderRadius: 8, border: "1px solid var(--border)", objectFit: "contain", display: "block" }} />
            <a href={dataUrl} download={exp.receiptFileName} className="btn btn-sm" style={{ marginTop: 8, display: "inline-flex", gap: 4, textDecoration: "none" }}>
              <Mi icon="download" style={{ fontSize: 13 }} />Download
            </a>
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: 8 }}>
            <Mi icon="picture_as_pdf" style={{ color: "var(--red)", fontSize: 30 }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{exp.receiptFileName}</div>
              <div style={{ fontSize: 11, color: "var(--text3)" }}>PDF Document</div>
            </div>
            <a href={dataUrl} download={exp.receiptFileName} className="btn btn-sm btn-primary" style={{ textDecoration: "none", display: "inline-flex", gap: 4 }}>
              <Mi icon="download" style={{ fontSize: 13 }} />Download
            </a>
          </div>
        );
      })();

      return (
        <Shell title={exp.id || "Expense Detail"} size="modal-lg"
          footer={<>
            <button className="btn" onClick={closeModal}>Close</button>
            {isReimb && <button className="btn btn-primary" onClick={() => downloadSlip(exp)}><Mi icon="download" style={{ fontSize: 15 }} />Download Slip</button>}
          </>}>
          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid var(--border)" }}>
            <div>
              <div style={{ fontWeight: 800, fontSize: 18, color: "var(--accent)" }}>{exp.title || "Employee Expense"}</div>
              <div style={{ fontSize: 12, color: "var(--text3)", fontFamily: "var(--font2)", marginTop: 2 }}>{exp.id}</div>
            </div>
            <Pill variant={statusVariant(exp.status)}>{exp.statusLabel || exp.status}</Pill>
          </div>

          {/* Detail grid */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 20px", fontSize: 13, marginBottom: 20 }}>
            {[["Employee", exp.employee || "—"], ["Category", exp.category || "—"], ["Amount", fmtAmt(exp.amount)], ["Expense Date", fmtDate(exp.date)], ["Payment Mode", exp.payment || "—"], ["Project", exp.project || "—"], ["Transaction Ref", txnRef]].map(([l, v]) => (
              <div key={l}><div style={{ fontSize: 10, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 3 }}>{l}</div><div style={{ fontWeight: 600 }}>{v}</div></div>
            ))}
            {(exp.desc || exp.notes) && <div style={{ gridColumn: "span 2" }}><div style={{ fontSize: 10, color: "var(--text3)", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 3 }}>Description</div><div style={{ fontWeight: 500, whiteSpace: "pre-wrap", color: "var(--text2)" }}>{exp.desc || exp.notes}</div></div>}
          </div>

          {/* Rejection banner */}
          {isRejected && exp.rejectionReason && (
            <div style={{ display: "flex", gap: 10, padding: "12px 14px", background: "var(--red-bg, #fef2f2)", border: "1px solid var(--red-bd, #fca5a5)", borderRadius: 8, marginBottom: 16, color: "var(--red)" }}>
              <Mi icon="cancel" /><div><div style={{ fontWeight: 600, marginBottom: 2 }}>Rejection Reason</div><div style={{ color: "var(--text2)", fontWeight: 400 }}>{exp.rejectionReason}</div></div>
            </div>
          )}

          {/* Info request banner */}
          {isInfo && exp.infoRequestMessage && (
            <div style={{ display: "flex", gap: 10, padding: "12px 14px", background: "var(--amber-bg, #fffbeb)", border: "1px solid var(--amber-bd, #fcd34d)", borderRadius: 8, marginBottom: 16, color: "var(--amber)" }}>
              <Mi icon="warning_amber" /><div><div style={{ fontWeight: 600, marginBottom: 2 }}>Clarification Requested</div><div style={{ color: "var(--text2)", fontWeight: 400 }}>{exp.infoRequestMessage}</div></div>
            </div>
          )}

          {/* Receipt */}
          {receiptBlock && (
            <div>
              <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text2)", marginBottom: 8, textTransform: "uppercase", letterSpacing: ".5px" }}>Attached Receipt</div>
              {receiptBlock}
            </div>
          )}

          {/* Approval Timeline */}
          <div style={{ marginTop: 24, borderTop: "1px solid var(--border)", paddingTop: 16 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text2)", textTransform: "uppercase", letterSpacing: ".6px", marginBottom: 14 }}>Approval Timeline</div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              {trailSteps.map((step, i) => {
                const isLast = i === trailSteps.length - 1;
                const circleBg = step.color === "#ccc" ? "var(--surface2)" : step.color === "var(--green)" ? "var(--green-bg)" : step.color === "var(--amber)" ? "var(--amber-bg)" : step.color === "var(--red)" ? "var(--red-bg)" : step.color === "var(--violet)" ? "var(--violet-bg)" : "var(--accent-light)";
                const lineColor = step.color === "#ccc" ? "var(--border)" : step.color;
                return (
                  <div key={i} style={{ display: "flex", gap: 14, alignItems: "stretch" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 34, flexShrink: 0 }}>
                      <div style={{ width: 34, height: 34, borderRadius: "50%", background: circleBg, border: `2px solid ${step.color}`, display: "flex", alignItems: "center", justifyContent: "center", color: step.color, flexShrink: 0 }}>
                        <Mi icon={step.icon} style={{ fontSize: 16 }} />
                      </div>
                      {!isLast && <div style={{ width: 2, flex: 1, minHeight: 20, background: lineColor, margin: "4px 0", borderRadius: 2 }} />}
                    </div>
                    <div style={{ paddingTop: 5, paddingBottom: isLast ? 0 : 20 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text)", lineHeight: 1.3 }}>{step.label}</div>
                      <div style={{ fontSize: 12, color: "var(--text3)", marginTop: 2 }}>{step.sub}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Shell>
      );
    }
    return (
      <Shell title="Expense Details" footer={<button className="btn" onClick={closeModal}>Close</button>}>
        <InfoBox>Reference: <strong>{data}</strong><br />Record not found.</InfoBox>
      </Shell>
    );
  }

  if (type === "export") {
    const ALL_REPORT_TYPES = [
      { value: "budget-report",    label: "Budget Report" },
      { value: "expense-summary",  label: "Expense Summary" },
      { value: "reimbursement",    label: "Reimbursement Statement" },
      { value: "pending",          label: "Pending Approvals" },
      { value: "rejected",         label: "Rejected Expenses" },
      { value: "utility",          label: "Utility Bill History" },
      { value: "grocery",          label: "Grocery Report" },
      { value: "internal",         label: "All Internal Expenses" },
      { value: "petty-cash",       label: "Petty Cash Statement" },
      { value: "all-expenses",     label: "All Expenses (Full)" },
    ];
    const today = new Date();
    const todayStr = today.toISOString().slice(0, 10);
    const activeType = exportReportType || data || "expense-summary";
    const isBudget   = activeType === "budget-report";
    const isInternal = ["utility", "grocery", "internal", "petty-cash"].includes(activeType);
    const isExpenseBased = !isInternal && !isBudget;
    const defaultFrom = isInternal
      ? `${today.getFullYear()}-01-01`
      : `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-01`;
    const dateLabel = activeType === "utility" ? "Due Date"
      : ["grocery", "internal"].includes(activeType) ? "Created Date"
        : activeType === "petty-cash" ? "Transaction Date"
          : "Expense Date";
    const allCats = [...new Set((expenseCategories || []).map(c => c.name).filter(Boolean))].sort();
    const allDepts = [...new Set((departments || []))].sort();
    const showStatusFilter = ["expense-summary", "all-expenses"].includes(activeType);
    return (
      <Shell title="Export Report"
        footer={<><button className="btn btn-primary" onClick={doExport}><Mi icon="file_download" style={{ fontSize: 15 }} />Download CSV</button><button className="btn" onClick={closeModal}>Cancel</button></>}>
        <InfoBox>Exports all matching records as a CSV file you can open in Excel or Google Sheets.</InfoBox>
        <FG label="Report Type">
          <select className="form-control" value={activeType} onChange={e => setExportReportType(e.target.value)}>
            {ALL_REPORT_TYPES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
          </select>
        </FG>
        {isBudget ? (
          <>
            <InfoBox style={{ background: "var(--accent-light)", border: "1px solid var(--accent-mid)" }}>
              Exports all budget allocations with spent, remaining, and utilisation % for the selected month.
              Columns: Department · Category · Period · Allocated · Spent · Remaining · Utilization% · Status
            </InfoBox>
            <FR>
              <FG label="Period (Month)">
                <input type="month" className="form-control" value={exportPeriod}
                  onChange={e => setExportPeriod(e.target.value)} />
              </FG>
              <FG label="Department">
                <select className="form-control" value={exportDept} onChange={e => setExportDept(e.target.value)}>
                  <option value="">All Departments</option>
                  {allDepts.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
              </FG>
            </FR>
          </>
        ) : (
          <>
            <FR>
              <FG label={`From ${dateLabel}`}><input ref={exportFromRef} type="date" className="form-control" defaultValue={defaultFrom} /></FG>
              <FG label={`To ${dateLabel}`}><input ref={exportToRef} type="date" className="form-control" defaultValue={todayStr} /></FG>
            </FR>
            {isExpenseBased && (
              <FR>
                <FG label="Department">
                  <select className="form-control" value={exportDept} onChange={e => setExportDept(e.target.value)}>
                    <option value="">All Departments</option>
                    {allDepts.map(d => <option key={d} value={d}>{d}</option>)}
                  </select>
                </FG>
                <FG label="Category">
                  <select className="form-control" value={exportCat} onChange={e => setExportCat(e.target.value)}>
                    <option value="">All Categories</option>
                    {allCats.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </FG>
              </FR>
            )}
            {showStatusFilter && (
              <FG label="Status">
                <select className="form-control" value={exportStatus} onChange={e => setExportStatus(e.target.value)}>
                  <option value="">All Statuses</option>
                  {["Pending L1","Pending L2","Info Requested","Approved","Reimbursed","Rejected"].map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </FG>
            )}
          </>
        )}
      </Shell>
    );
  }

  if (type === "filter") return (
    <Shell title="Filter Expenses"
      footer={<><button className="btn" onClick={() => { closeModal(); showToast("Filters cleared", "t-info"); }}>Reset</button><button className="btn btn-primary" onClick={() => { closeModal(); showToast("Filters applied", "t-info"); }}>Apply Filters</button></>}>
      <FR><FG label="From Date"><input type="date" className="form-control" /></FG>
        <FG label="To Date"><input type="date" className="form-control" /></FG></FR>
      <FG label="Department">
        <select className="form-control"><option value="">All</option>
          {departments.map(d => <option key={d} value={d}>{d}</option>)}
        </select>
      </FG>
      <FG label="Category"><select className="form-control"><option>All</option><option>Travel</option><option>Training</option><option>Software</option><option>Hardware</option><option>Meals</option></select></FG>
      <FG label="Status"><select className="form-control"><option>All</option><option>Pending L1</option><option>Pending L2</option><option>Approved</option><option>Reimbursed</option><option>Rejected</option></select></FG>
    </Shell>
  );

  return null;
}


/* ─── Root Component ─────────────────────────────────────── */
export default function AdminExpenseDashboard() {
  const [activePage, setActivePage] = useState("dashboard");
  const [modal, setModal] = useState(null);
  const [notifOpen, setNotifOpen] = useState(false);
  const [notifRead, setNotifRead] = useState(false);
  const { showToast } = useToast();
  const { badges, decrement, syncBadges } = useBadges();

  // Real API data
  const [allExpenses, setAllExpenses] = useState([]);
  const [pendingExpenses, setPendingExpenses] = useState([]);
  const [reimbExpenses, setReimbExpenses] = useState([]);
  const [pendingReimbExpenses, setPendingReimbExpenses] = useState([]);
  const [allClaims, setAllClaims] = useState([]);
  const [adminStats, setAdminStats] = useState(null);
  const [internalExpenses, setInternalExpenses] = useState([]);
  const [internalSummary, setInternalSummary] = useState(null);
  const [utilityExpenses, setUtilityExpenses] = useState([]);
  const [groceryExpenses, setGroceryExpenses] = useState([]);
  const [overdueExpenses, setOverdueExpenses] = useState([]);
  const [analytics, setAnalytics] = useState(null);
  const [pettyCash, setPettyCash] = useState(null);
  const [pettyCashSummary, setPettyCashSummary] = useState(null);
  const [budgets, setBudgets] = useState([]);
  const [intCategories, setIntCategories] = useState([]);
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [activityLog, setActivityLog] = useState({ items: [], total: 0, totalPages: 0 });

  const [pageLoading, setPageLoading] = useState(false);

  const authH = () => { const t = localStorage.getItem("token"); return t && t !== "null" ? { Authorization: `Bearer ${t}` } : null; };

  const fetchExpenses = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/expenses?year=${y}`, { headers: h }); if (r.ok) setAllExpenses(await r.json()); }, []);
  const fetchPendingExpenses = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/expenses/pending`, { headers: h }); if (r.ok) setPendingExpenses(await r.json()); }, []);
  const fetchReimbExpenses = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/expenses/reimbursements?year=${y}`, { headers: h }); if (r.ok) setReimbExpenses(await r.json()); }, []);
  const fetchPendingReimb = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/expenses/pending-reimb`, { headers: h }); if (r.ok) setPendingReimbExpenses(await r.json()); }, []);
  const fetchClaims = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/expense-claims?year=${y}`, { headers: h }); if (r.ok) setAllClaims(await r.json()); }, []);
  const fetchStats = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/expenses/stats`, { headers: h }); if (r.ok) setAdminStats(await r.json()); }, []);
  const fetchInternal = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/internal-expenses?year=${y}`, { headers: h }); if (r.ok) setInternalExpenses(await r.json()); }, []);
  const fetchInternalSummary = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/internal-expenses/summary`, { headers: h }); if (r.ok) setInternalSummary(await r.json()); }, []);
  const fetchAnalytics = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/expenses/analytics`, { headers: h }); if (r.ok) setAnalytics(await r.json()); }, []);
  const fetchUtilityExpenses = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/internal-expenses?type=UTILITY&year=${y}`, { headers: h }); if (r.ok) setUtilityExpenses(await r.json()); }, []);
  const fetchGroceryExpenses = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/internal-expenses?type=GROCERY&year=${y}`, { headers: h }); if (r.ok) setGroceryExpenses(await r.json()); }, []);
  const fetchOverdueExpenses = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/internal-expenses?overdue=true`, { headers: h }); if (r.ok) setOverdueExpenses(await r.json()); }, []);
  const fetchPetty = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/petty-cash?year=${y}`, { headers: h }); if (r.ok) setPettyCash(await r.json()); }, []);
  const fetchPettySummary = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/petty-cash/summary`, { headers: h }); if (r.ok) setPettyCashSummary(await r.json()); }, []);
  const fetchCats = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/expense-categories`, { headers: h }); if (r.ok) setExpenseCategories(await r.json()); }, []);
  const fetchBudgets = useCallback(async (year) => { const h = authH(); if (!h) return; const y = year || new Date().getFullYear(); const r = await fetch(`${API_BASE_URL}/api/budgets?year=${y}`, { headers: h }); if (r.ok) setBudgets(await r.json()); }, []);
  const fetchIntCats = useCallback(async () => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/internal-categories`, { headers: h }); if (r.ok) setIntCategories(await r.json()); }, []);
  const fetchActivity = useCallback(async (page = 0) => { const h = authH(); if (!h) return; const r = await fetch(`${API_BASE_URL}/api/system-notes/expense-activity?page=${page}&size=50`, { headers: h }); if (r.ok) setActivityLog(await r.json()); }, []);

  const loadPage = useCallback(async (page) => {
    setPageLoading(true);
    try {
      switch (page) {
        case "dashboard":
          await Promise.all([fetchPendingExpenses(), fetchPendingReimb(), fetchOverdueExpenses(), fetchUtilityExpenses(), fetchStats(), fetchInternalSummary(), fetchPettySummary(), fetchBudgets()]);
          break;
        case "reports":
          await Promise.all([fetchAnalytics(), fetchStats()]);
          break;
        case "all-expenses":
          await Promise.all([fetchExpenses(), fetchCats()]);
          break;
        case "approvals":
          await fetchPendingExpenses();
          break;
        case "reimbursements":
          await fetchReimbExpenses();
          break;
        case "claims":
          await fetchClaims();
          break;
        case "budgets":
          await Promise.all([fetchBudgets(), fetchCats()]);
          break;
        case "categories":
          await fetchCats();
          break;
        case "internal-expenses":
          await Promise.all([fetchInternal(), fetchIntCats()]);
          break;
        case "utility-bills":
          await fetchUtilityExpenses();
          break;
        case "grocery":
          await fetchGroceryExpenses();
          break;
        case "overdue":
          await fetchOverdueExpenses();
          break;
        case "petty-cash":
          await fetchPetty();
          break;
        case "int-categories":
          await fetchIntCats();
          break;
        case "system-notes":
          await fetchActivity();
          break;
        default:
          break;
      }
    } catch (err) { console.error("Fetch error:", err); }
    finally { setPageLoading(false); }
  }, [fetchExpenses, fetchPendingExpenses, fetchReimbExpenses, fetchPendingReimb, fetchClaims, fetchStats, fetchInternal, fetchInternalSummary, fetchAnalytics, fetchUtilityExpenses, fetchGroceryExpenses, fetchOverdueExpenses, fetchPetty, fetchPettySummary, fetchCats, fetchBudgets, fetchIntCats, fetchActivity]);

  const fetchCoreData = useCallback(() => Promise.all([fetchExpenses(), fetchPendingExpenses(), fetchReimbExpenses(), fetchClaims(), fetchStats(), fetchInternal(), fetchInternalSummary(), fetchAnalytics(), fetchUtilityExpenses(), fetchGroceryExpenses(), fetchOverdueExpenses(), fetchPetty()]), [fetchExpenses, fetchPendingExpenses, fetchReimbExpenses, fetchClaims, fetchStats, fetchInternal, fetchInternalSummary, fetchAnalytics, fetchUtilityExpenses, fetchGroceryExpenses, fetchOverdueExpenses, fetchPetty]);
  const fetchConfigData = useCallback(() => Promise.all([fetchBudgets(), fetchIntCats(), fetchCats()]), [fetchBudgets, fetchIntCats, fetchCats]);
  const fetchAdminData = useCallback(() => Promise.all([fetchCoreData(), fetchConfigData()]), [fetchCoreData, fetchConfigData]);

  useEffect(() => { loadPage("dashboard"); }, [loadPage]);

  useEffect(() => {
    syncBadges({
      "all-expenses": allExpenses.length || null,
      "approvals": pendingExpenses.length || null,
      "reimbursements": reimbExpenses.filter(e => e.status === "Approved").length || null,
      "overdue": overdueExpenses.length || null,
      "utility-bills": utilityExpenses.filter(e => e.status !== "Paid" && e.status !== "Draft").length || null,
    });
  }, [allExpenses, pendingExpenses, reimbExpenses, overdueExpenses, utilityExpenses, syncBadges]);

  const handleApprove = useCallback(async (id, l2 = true) => {
    const h = { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" };
    const res = await fetch(`${API_BASE_URL}/api/expenses/${id}/approve?l2=${l2}`, { method: "PATCH", headers: h });
    if (!res.ok) { const t = await res.text(); showToast(t || "Failed to approve", "t-error"); return; }
    showToast(l2 ? "Expense approved (L2)" : "Expense forwarded to L2 review", "t-success");
    await Promise.all([fetchPendingExpenses(), fetchExpenses(), fetchStats()]);
  }, [fetchPendingExpenses, fetchExpenses, fetchStats, showToast]);

  const handleReject = useCallback(async (id, reason) => {
    const h = { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" };
    const res = await fetch(`${API_BASE_URL}/api/expenses/${id}/reject`, { method: "PATCH", headers: h, body: JSON.stringify({ reason: reason || "Rejected by admin" }) });
    if (!res.ok) { const t = await res.text(); showToast(t || "Failed to reject", "t-error"); return; }
    showToast("Expense rejected", "t-info");
    await Promise.all([fetchPendingExpenses(), fetchExpenses(), fetchStats()]);
  }, [fetchPendingExpenses, fetchExpenses, fetchStats, showToast]);

  const handleReimburse = useCallback(async (id, transactionRef) => {
    const h = { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" };
    const res = await fetch(`${API_BASE_URL}/api/expenses/${id}/reimburse`, { method: "PATCH", headers: h, body: JSON.stringify(transactionRef ? { transactionRef } : {}) });
    if (!res.ok) { const text = await res.text(); throw new Error(text || "Reimbursement failed"); }
    showToast("Reimbursement processed successfully", "t-success");
    await Promise.all([fetchReimbExpenses(), fetchPendingReimb(), fetchExpenses(), fetchClaims(), fetchStats()]);
  }, [fetchReimbExpenses, fetchPendingReimb, fetchExpenses, fetchClaims, fetchStats, showToast]);

  const handleRequestInfo = useCallback(async (id, message) => {
    const h = { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json" };
    await fetch(`${API_BASE_URL}/api/expenses/${id}/request-info`, { method: "PATCH", headers: h, body: JSON.stringify({ message }) });
    showToast("Info request sent to employee", "t-amber");
    await Promise.all([fetchPendingExpenses(), fetchExpenses()]);
  }, [fetchPendingExpenses, fetchExpenses, showToast]);

  const onNav = (page) => {
    setActivePage(page);
    setNotifOpen(false);
    loadPage(page);
  };
  const onModal = useCallback((type, data) => setModal({ type, data }), []);
  const closeModal = useCallback(() => setModal(null), []);
  const markAllRead = () => { setNotifRead(true); setNotifOpen(false); showToast("All notifications marked as read", "t-info"); };

  // Keyboard ESC closes modal
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") { closeModal(); setNotifOpen(false); } };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  const commonProps = { onModal, onNav, showToast, badges, adminStats, allClaims, handleApprove, handleReject, handleReimburse, handleRequestInfo, pettyCash, budgets, intCategories, expenseCategories };

  const renderPage = () => {
    switch (activePage) {
      case "dashboard": return <DashboardPage {...commonProps} pendingExpenses={pendingExpenses} pendingReimbExpenses={pendingReimbExpenses} overdueExpenses={overdueExpenses} utilityExpenses={utilityExpenses} internalSummary={internalSummary} pettyCashSummary={pettyCashSummary} onRefresh={fetchCoreData} />;
      case "reports": return <ReportsPage {...commonProps} analytics={analytics} onRefresh={() => Promise.all([fetchAnalytics(), fetchStats()])} />;
      case "all-expenses": return <AllExpensesPage {...commonProps} allExpenses={allExpenses} onRefresh={fetchExpenses} />;
      case "approvals": return <ApprovalsPage {...commonProps} allExpenses={pendingExpenses} allClaims={allClaims} onRefresh={fetchPendingExpenses} />;
      case "reimbursements": return <ReimbursementsPage {...commonProps} allExpenses={reimbExpenses} onRefresh={fetchReimbExpenses} />;
      case "claims": return <ClaimsPage {...commonProps} onRefresh={fetchClaims} />;
      case "budgets": return <BudgetsPage {...commonProps} onRefresh={fetchBudgets} />;
      case "categories": return <CategoriesPage {...commonProps} onRefresh={fetchConfigData} />;
      case "internal-expenses": return <InternalExpensesPage {...commonProps} internalExpenses={internalExpenses} onRefresh={fetchInternal} />;
      case "utility-bills": return <UtilityBillsPage {...commonProps} internalExpenses={utilityExpenses} onRefresh={fetchUtilityExpenses} />;
      case "grocery": return <GroceryPage {...commonProps} internalExpenses={groceryExpenses} onRefresh={fetchGroceryExpenses} />;
      case "overdue": return <OverduePage {...commonProps} internalExpenses={overdueExpenses} onRefresh={fetchOverdueExpenses} />;
      case "petty-cash": return <PettyCashPage {...commonProps} onRefresh={fetchPetty} />;
      case "int-categories": return <IntCategoriesPage {...commonProps} onRefresh={fetchConfigData} />;
      case "system-notes": return <SystemNotesPage activityLog={activityLog} onRefresh={fetchActivity} />;
      case "permissions": return <ComingSoonPage title="Permissions" />;
      case "settings": return <ComingSoonPage title="Settings" />;
      default: return <DashboardPage {...commonProps} allExpenses={allExpenses} internalExpenses={internalExpenses} onRefresh={fetchCoreData} />;
    }
  };

  return (
    <>
      <AdminNavbar />
      <FontLoader />
      <style>{STYLES}</style>
      <div className="exp-root">
        <Sidebar active={activePage} onNav={onNav} badges={badges} />
        <div className="main">
          <Topbar
            active={activePage}
            onModal={onModal}
            showToast={showToast}
            notifOpen={notifOpen}
            setNotifOpen={setNotifOpen}
            notifRead={notifRead}
            onNav={onNav}
            markAllRead={markAllRead}
          />
          <div className="content" id="main-content">
            {pageLoading
              ? <div className="adm-spinner-wrap"><div className="adm-spinner" /><div className="adm-spinner-label">Loading...</div></div>
              : renderPage()}
          </div>
        </div>
        {modal && (
          <ModalSystem modal={modal} onModal={onModal} closeModal={closeModal} showToast={showToast} decrement={decrement} allExpenses={[...pendingExpenses, ...reimbExpenses, ...allExpenses]} allClaims={allClaims} pettyCash={pettyCash} expenseCategories={expenseCategories} intCategories={intCategories} internalExpenses={[...internalExpenses, ...utilityExpenses, ...groceryExpenses, ...overdueExpenses]} onRefresh={fetchAdminData} handleApprove={handleApprove} handleReject={handleReject} handleReimburse={handleReimburse} handleRequestInfo={handleRequestInfo} budgets={budgets} />
        )}
      </div>
    </>
  );
}
